// Public product copy. Authoritative legal bodies are deliberately excluded.
export const publicMessages: Record<string, { fr: string; ar: string }> = {
  "Language": {
    "fr": "Langue",
    "ar": "اللغة"
  },
  "Platform": {
    "fr": "Plateforme",
    "ar": "المنصة"
  },
  "Morocco": {
    "fr": "Maroc",
    "ar": "المغرب"
  },
  "Pricing": {
    "fr": "Tarifs",
    "ar": "الأسعار"
  },
  "About": {
    "fr": "À propos",
    "ar": "نبذة عنا"
  },
  "About Optrixis": {
    "fr": "À propos d’Optrixis",
    "ar": "نبذة عن Optrixis"
  },
  "Contact": {
    "fr": "Contact",
    "ar": "التواصل"
  },
  "Book a demo": {
    "fr": "Réserver une démo",
    "ar": "احجز عرضًا توضيحيًا"
  },
  "Request access": {
    "fr": "Demander un accès",
    "ar": "طلب الوصول"
  },
  "Contact sales": {
    "fr": "Contacter l’équipe commerciale",
    "ar": "تواصل مع المبيعات"
  },
  "Contact us": {
    "fr": "Nous contacter",
    "ar": "تواصل معنا"
  },
  "Sign in": {
    "fr": "Se connecter",
    "ar": "تسجيل الدخول"
  },
  "Enterprise": {
    "fr": "Enterprise",
    "ar": "Enterprise"
  },
  "Security & Trust": {
    "fr": "Sécurité et confiance",
    "ar": "الأمان والثقة"
  },
  "FAQ": {
    "fr": "FAQ",
    "ar": "الأسئلة الشائعة"
  },
  "Blog": {
    "fr": "Blog",
    "ar": "المدونة"
  },
  "Reviews & Reputation": {
    "fr": "Avis et réputation",
    "ar": "التقييمات والسمعة"
  },
  "Local SEO & Visibility": {
    "fr": "Référencement local et visibilité",
    "ar": "تحسين البحث المحلي والظهور"
  },
  "Local SEO": {
    "fr": "Référencement local",
    "ar": "تحسين البحث المحلي"
  },
  "Local Score": {
    "fr": "Score local",
    "ar": "النتيجة المحلية"
  },
  "Priority Actions": {
    "fr": "Actions prioritaires",
    "ar": "الإجراءات ذات الأولوية"
  },
  "Integrations": {
    "fr": "Intégrations",
    "ar": "عمليات التكامل"
  },
  "Industries": {
    "fr": "Secteurs",
    "ar": "القطاعات"
  },
  "Privacy": {
    "fr": "Confidentialité",
    "ar": "الخصوصية"
  },
  "Privacy Policy": {
    "fr": "Politique de confidentialité",
    "ar": "سياسة الخصوصية"
  },
  "Terms": {
    "fr": "Conditions",
    "ar": "الشروط"
  },
  "Terms of Service": {
    "fr": "Conditions d’utilisation",
    "ar": "شروط الخدمة"
  },
  "Data Deletion": {
    "fr": "Suppression des données",
    "ar": "حذف البيانات"
  },
  "Company": {
    "fr": "Entreprise",
    "ar": "الشركة"
  },
  "Legal": {
    "fr": "Informations juridiques",
    "ar": "المعلومات القانونية"
  },
  "Support": {
    "fr": "Assistance",
    "ar": "الدعم"
  },
  "Features": {
    "fr": "Fonctionnalités",
    "ar": "الميزات"
  },
  "View full pricing": {
    "fr": "Voir tous les tarifs",
    "ar": "عرض جميع الأسعار"
  },
  "View all questions": {
    "fr": "Voir toutes les questions",
    "ar": "عرض جميع الأسئلة"
  },
  "View preview": {
    "fr": "Voir l’aperçu",
    "ar": "عرض المعاينة"
  },
  "All insights": {
    "fr": "Tous les insights",
    "ar": "كل الرؤى"
  },
  "Learn more": {
    "fr": "En savoir plus",
    "ar": "معرفة المزيد"
  },
  "Explore": {
    "fr": "Découvrir",
    "ar": "استكشف"
  },
  "Explore the platform": {
    "fr": "Découvrir la plateforme",
    "ar": "استكشف المنصة"
  },
  "Explore the platform →": {
    "fr": "Découvrir la plateforme →",
    "ar": "استكشف المنصة ←"
  },
  "Explore industry →": {
    "fr": "Découvrir ce secteur →",
    "ar": "استكشف القطاع ←"
  },
  "Explore Optrixis AI": {
    "fr": "Découvrir Optrixis AI",
    "ar": "استكشف Optrixis AI"
  },
  "Explore the ecosystem": {
    "fr": "Découvrir l’écosystème",
    "ar": "استكشف المنظومة"
  },
  "Explore local growth tools": {
    "fr": "Découvrir les outils de croissance locale",
    "ar": "استكشف أدوات النمو المحلي"
  },
  "View all questions →": {
    "fr": "Voir toutes les questions →",
    "ar": "جميع الأسئلة ←"
  },
  "View full pricing →": {
    "fr": "Voir tous les tarifs →",
    "ar": "عرض جميع الأسعار ←"
  },
  "View preview →": {
    "fr": "Lire l’aperçu →",
    "ar": "عرض الملخص ←"
  },
  "← All insights": {
    "fr": "← Tous les articles",
    "ar": "جميع المقالات →"
  },
  "→": {
    "fr": "→",
    "ar": "←"
  },
  "←": {
    "fr": "←",
    "ar": "→"
  },
  "↗": {
    "fr": "↗",
    "ar": "↖"
  },
  "Appearance": {
    "fr": "Apparence",
    "ar": "المظهر"
  },
  "Automatic appearance": {
    "fr": "Apparence automatique",
    "ar": "المظهر التلقائي"
  },
  "Light appearance": {
    "fr": "Apparence claire",
    "ar": "المظهر الفاتح"
  },
  "Dark appearance": {
    "fr": "Apparence sombre",
    "ar": "المظهر الداكن"
  },
  "Auto": {
    "fr": "Auto",
    "ar": "تلقائي"
  },
  "Primary navigation": {
    "fr": "Navigation principale",
    "ar": "التنقل الرئيسي"
  },
  "Mobile navigation": {
    "fr": "Navigation mobile",
    "ar": "التنقل على الهاتف"
  },
  "Open navigation": {
    "fr": "Ouvrir le menu",
    "ar": "فتح القائمة"
  },
  "Close navigation": {
    "fr": "Fermer le menu",
    "ar": "إغلاق القائمة"
  },
  "Skip to main content": {
    "fr": "Aller au contenu principal",
    "ar": "الانتقال إلى المحتوى الرئيسي"
  },
  "OPTRIXIS LOCAL home": {
    "fr": "Accueil OPTRIXIS LOCAL",
    "ar": "الصفحة الرئيسية لـ OPTRIXIS LOCAL"
  },
  "All industries": {
    "fr": "Tous les secteurs",
    "ar": "جميع القطاعات"
  },
  "Restaurants": {
    "fr": "Restaurants",
    "ar": "المطاعم"
  },
  "Restaurant": {
    "fr": "Restaurant",
    "ar": "مطعم"
  },
  "Restaurant / Food service": {
    "fr": "Restaurant / Restauration",
    "ar": "مطعم / خدمات الطعام"
  },
  "Salons & Spas": {
    "fr": "Salons et spas",
    "ar": "الصالونات والمنتجعات الصحية"
  },
  "Salon & Spa": {
    "fr": "Salon et spa",
    "ar": "صالون ومنتجع صحي"
  },
  "Hotels & Hospitality": {
    "fr": "Hôtels et hébergement",
    "ar": "الفنادق والضيافة"
  },
  "Hotel / Hospitality": {
    "fr": "Hôtel / Hébergement",
    "ar": "فندق / ضيافة"
  },
  "Healthcare & Clinics": {
    "fr": "Santé et cliniques",
    "ar": "الرعاية الصحية والعيادات"
  },
  "Healthcare": {
    "fr": "Santé",
    "ar": "الرعاية الصحية"
  },
  "Healthcare / Clinic": {
    "fr": "Santé / Clinique",
    "ar": "رعاية صحية / عيادة"
  },
  "Retail": {
    "fr": "Commerce de détail",
    "ar": "تجارة التجزئة"
  },
  "Other local business": {
    "fr": "Autre entreprise locale",
    "ar": "نشاط محلي آخر"
  },
  "Other multi-location business": {
    "fr": "Autre entreprise multiétablissement",
    "ar": "نشاط آخر متعدد المواقع"
  },
  "Business name": {
    "fr": "Nom de l’entreprise",
    "ar": "اسم النشاط التجاري"
  },
  "Organization": {
    "fr": "Organisation",
    "ar": "المؤسسة"
  },
  "Message": {
    "fr": "Message",
    "ar": "الرسالة"
  },
  "Website": {
    "fr": "Site web",
    "ar": "الموقع الإلكتروني"
  },
  "Rollout needs (optional)": {
    "fr": "Besoins de déploiement (facultatif)",
    "ar": "احتياجات الإطلاق (اختياري)"
  },
  "Select an option": {
    "fr": "Sélectionner une option",
    "ar": "اختر خيارًا"
  },
  "Sending…": {
    "fr": "Envoi en cours…",
    "ar": "جارٍ الإرسال…"
  },
  "Email us instead": {
    "fr": "Nous écrire par e-mail",
    "ar": "راسلنا عبر البريد الإلكتروني"
  },
  "Prefer email?": {
    "fr": "Vous préférez l’e-mail ?",
    "ar": "تفضل البريد الإلكتروني؟"
  },
  "General inquiries": {
    "fr": "Questions générales",
    "ar": "الاستفسارات العامة"
  },
  "Partnerships": {
    "fr": "Partenariats",
    "ar": "الشراكات"
  },
  "Enterprise sales": {
    "fr": "Équipe commerciale Enterprise",
    "ar": "مبيعات Enterprise"
  },
  "Pricing questions": {
    "fr": "Questions sur les tarifs",
    "ar": "أسئلة حول الأسعار"
  },
  "Get in touch": {
    "fr": "Contactez-nous",
    "ar": "تواصل معنا"
  },
  "Let's talk.": {
    "fr": "Parlons-en.",
    "ar": "لنتحدث."
  },
  "Tell us about your business": {
    "fr": "Présentez-nous votre entreprise",
    "ar": "أخبرنا عن نشاطك التجاري"
  },
  "Request your demo": {
    "fr": "Demander une démo",
    "ar": "اطلب عرضًا توضيحيًا"
  },
  "Let's build your enterprise plan": {
    "fr": "Construisons votre offre Enterprise",
    "ar": "لنصمم خطة Enterprise المناسبة لك"
  },
  "We'll get back to you with a tailored proposal.": {
    "fr": "Nous vous répondrons avec une proposition adaptée.",
    "ar": "سنعود إليك بعرض يناسب احتياجاتك."
  },
  "We'll use these details only to handle your request and follow up with you.": {
    "fr": "Ces informations serviront uniquement à traiter votre demande et à vous recontacter.",
    "ar": "سنستخدم هذه المعلومات فقط لمعالجة طلبك ومتابعته معك."
  },
  "By submitting this request you agree to our": {
    "fr": "En envoyant cette demande, vous acceptez notre",
    "ar": "بإرسال هذا الطلب، فإنك توافق على"
  },
  "A confirmation has been sent to your inbox.": {
    "fr": "Une confirmation vous a été envoyée par e-mail.",
    "ar": "أُرسلت رسالة تأكيد إلى بريدك الإلكتروني."
  },
  "We received your": {
    "fr": "Nous avons reçu votre",
    "ar": "لقد استلمنا"
  },
  ". Our team will follow up with you shortly.": {
    "fr": ". Notre équipe vous recontactera prochainement.",
    "ar": ". سيتواصل فريقنا معك قريبًا."
  },
  "This field is required.": {
    "fr": "Ce champ est obligatoire.",
    "ar": "هذا الحقل مطلوب."
  },
  "Please check the highlighted fields.": {
    "fr": "Vérifiez les champs signalés.",
    "ar": "يرجى مراجعة الحقول المحددة."
  },
  "Please check the highlighted fields and try again.": {
    "fr": "Vérifiez les champs signalés et réessayez.",
    "ar": "يرجى مراجعة الحقول المحددة ثم المحاولة مجددًا."
  },
  "Enter a valid email address.": {
    "fr": "Saisissez une adresse e-mail valide.",
    "ar": "أدخل عنوان بريد إلكتروني صالحًا."
  },
  "Enter a message of at least 2 characters.": {
    "fr": "Saisissez un message d’au moins 2 caractères.",
    "ar": "أدخل رسالة مكونة من حرفين على الأقل."
  },
  "Please enter text.": {
    "fr": "Saisissez du texte.",
    "ar": "يرجى إدخال نص."
  },
  "Please remove unsupported characters.": {
    "fr": "Supprimez les caractères non pris en charge.",
    "ar": "يرجى إزالة الأحرف غير المدعومة."
  },
  "Please review your request.": {
    "fr": "Vérifiez votre demande.",
    "ar": "يرجى مراجعة طلبك."
  },
  "Choose your business type.": {
    "fr": "Choisissez votre type d’activité.",
    "ar": "اختر نوع نشاطك التجاري."
  },
  "Choose your number of locations.": {
    "fr": "Choisissez votre nombre d’établissements.",
    "ar": "اختر عدد مواقع نشاطك."
  },
  "Complete the security verification before sending.": {
    "fr": "Effectuez la vérification de sécurité avant l’envoi.",
    "ar": "أكمل التحقق الأمني قبل الإرسال."
  },
  "Complete the security verification before sending. If it is unavailable, please email contact@optrixislocal.com.": {
    "fr": "Effectuez la vérification de sécurité avant l’envoi. Si elle est indisponible, écrivez à contact@optrixislocal.com.",
    "ar": "أكمل التحقق الأمني قبل الإرسال. إذا كان غير متاح، راسل contact@optrixislocal.com."
  },
  "Complete the security verification below.": {
    "fr": "Effectuez la vérification de sécurité ci-dessous.",
    "ar": "أكمل التحقق الأمني أدناه."
  },
  "Loading security verification…": {
    "fr": "Chargement de la vérification de sécurité…",
    "ar": "جارٍ تحميل التحقق الأمني…"
  },
  "Security verification": {
    "fr": "Vérification de sécurité",
    "ar": "التحقق الأمني"
  },
  "Security verification complete.": {
    "fr": "Vérification de sécurité terminée.",
    "ar": "اكتمل التحقق الأمني."
  },
  "Security verification expired. Please verify again and resend.": {
    "fr": "La vérification a expiré. Recommencez-la, puis renvoyez votre demande.",
    "ar": "انتهت صلاحية التحقق الأمني. تحقق مجددًا ثم أعد الإرسال."
  },
  "Verification expired. Please verify again.": {
    "fr": "La vérification a expiré. Recommencez-la.",
    "ar": "انتهت صلاحية التحقق. يرجى التحقق مجددًا."
  },
  "Secure verification is temporarily unavailable.": {
    "fr": "La vérification de sécurité est temporairement indisponible.",
    "ar": "التحقق الأمني غير متاح مؤقتًا."
  },
  "The form is temporarily unavailable. Please email contact@optrixislocal.com.": {
    "fr": "Le formulaire est temporairement indisponible. Écrivez à contact@optrixislocal.com.",
    "ar": "النموذج غير متاح مؤقتًا. يرجى مراسلة contact@optrixislocal.com."
  },
  "We couldn't confirm that your message was received. Please try again, or email contact@optrixislocal.com.": {
    "fr": "Nous n’avons pas pu confirmer la réception de votre message. Réessayez ou écrivez à contact@optrixislocal.com.",
    "ar": "تعذر تأكيد استلام رسالتك. حاول مجددًا أو راسل contact@optrixislocal.com."
  },
  "Too many requests. Please wait a few minutes and try again.": {
    "fr": "Trop de demandes. Patientez quelques minutes avant de réessayer.",
    "ar": "طلبات كثيرة جدًا. انتظر بضع دقائق ثم حاول مجددًا."
  },
  "Too many attempts. Please wait a few minutes and try again.": {
    "fr": "Trop de tentatives. Patientez quelques minutes avant de réessayer.",
    "ar": "محاولات كثيرة جدًا. انتظر بضع دقائق ثم حاول مجددًا."
  },
  "Try again": {
    "fr": "Réessayer",
    "ar": "حاول مجددًا"
  },
  "Opening checkout…": {
    "fr": "Ouverture du paiement…",
    "ar": "جارٍ فتح صفحة الدفع…"
  },
  "Checkout closed": {
    "fr": "Paiement fermé",
    "ar": "أُغلقت صفحة الدفع"
  },
  "Check your subscription status": {
    "fr": "Vérifiez l’état de votre abonnement",
    "ar": "تحقق من حالة اشتراكك"
  },
  "View plans": {
    "fr": "Voir les offres",
    "ar": "عرض الخطط"
  },
  "Open my workspace": {
    "fr": "Ouvrir mon espace",
    "ar": "افتح مساحة العمل"
  },
  "Open workspace": {
    "fr": "Ouvrir l’espace de travail",
    "ar": "افتح مساحة العمل"
  },
  "Link my purchase": {
    "fr": "Rattacher mon achat",
    "ar": "ربط عملية الشراء"
  },
  "Returning from checkout does not confirm payment or activate your subscription. Your workspace shows the subscription status after secure verification.": {
    "fr": "Le retour de la page de paiement ne confirme pas le paiement et n’active pas l’abonnement. Votre espace affiche son état après vérification sécurisée.",
    "ar": "العودة من صفحة الدفع لا تؤكد الدفع ولا تفعّل الاشتراك. تعرض مساحة العمل حالة الاشتراك بعد التحقق الآمن."
  },
  "You returned from checkout. You can review the plans and try again whenever you are ready.": {
    "fr": "Vous avez quitté la page de paiement. Vous pouvez consulter les offres et réessayer quand vous le souhaitez.",
    "ar": "لقد عدت من صفحة الدفع. يمكنك مراجعة الخطط والمحاولة مجددًا عندما تكون مستعدًا."
  },
  "Create an account or sign in using the same email as your payment. Verify that email to link your purchase securely, then set up your business.": {
    "fr": "Créez un compte ou connectez-vous avec l’adresse e-mail utilisée pour le paiement. Vérifiez cette adresse pour rattacher l’achat, puis configurez votre entreprise.",
    "ar": "أنشئ حسابًا أو سجل الدخول بالبريد الإلكتروني المستخدم للدفع. تحقق من هذا البريد لربط عملية الشراء بأمان، ثم أعدّ نشاطك التجاري."
  },
  "This checkout has expired. Choose your plan again to start a new checkout.": {
    "fr": "Cette session de paiement a expiré. Sélectionnez à nouveau votre offre pour recommencer.",
    "ar": "انتهت صلاحية جلسة الدفع. اختر خطتك مجددًا لبدء جلسة جديدة."
  },
  "Online checkout is temporarily unavailable. Please try again later or contact us.": {
    "fr": "Le paiement en ligne est temporairement indisponible. Réessayez plus tard ou contactez-nous.",
    "ar": "الدفع عبر الإنترنت غير متاح مؤقتًا. حاول لاحقًا أو تواصل معنا."
  },
  "Manage the plan for this business from Billing in your workspace.": {
    "fr": "Gérez l’offre de cette entreprise dans la rubrique Facturation de votre espace.",
    "ar": "أدر خطة هذا النشاط من قسم الفوترة في مساحة العمل."
  },
  "The workspace owner needs to manage this subscription.": {
    "fr": "Le propriétaire de l’espace doit gérer cet abonnement.",
    "ar": "يجب أن يدير مالك مساحة العمل هذا الاشتراك."
  },
  "Complete your business setup before choosing a paid plan.": {
    "fr": "Terminez la configuration de votre entreprise avant de choisir une offre payante.",
    "ar": "أكمل إعداد نشاطك التجاري قبل اختيار خطة مدفوعة."
  },
  "Sign in to link a subscription to your business and choose your plan in Billing.": {
    "fr": "Connectez-vous pour rattacher un abonnement à votre entreprise et choisir votre offre dans Facturation.",
    "ar": "سجل الدخول لربط اشتراك بنشاطك واختيار خطتك من قسم الفوترة."
  },
  "Annual": {
    "fr": "Annuel",
    "ar": "سنوي"
  },
  "Monthly": {
    "fr": "Mensuel",
    "ar": "شهري"
  },
  "Billing period": {
    "fr": "Période de facturation",
    "ar": "فترة الفوترة"
  },
  "Billed annually ($": {
    "fr": "Facturé annuellement ($",
    "ar": "تُدفع سنويًا ($"
  },
  "Custom": {
    "fr": "Sur mesure",
    "ar": "مخصص"
  },
  "Custom commercial terms": {
    "fr": "Conditions commerciales sur mesure",
    "ar": "شروط تجارية مخصصة"
  },
  "Standard plans: Start, Growth, Pro": {
    "fr": "Offres standard : Start, Growth, Pro",
    "ar": "الخطط القياسية: Start وGrowth وPro"
  },
  "Enterprise plans": {
    "fr": "Offres Enterprise",
    "ar": "خطط Enterprise"
  },
  "Managing multiple locations?": {
    "fr": "Vous gérez plusieurs établissements ?",
    "ar": "هل تدير مواقع متعددة؟"
  },
  "One location = one subscription": {
    "fr": "Un établissement = un abonnement",
    "ar": "موقع واحد = اشتراك واحد"
  },
  "One subscription.": {
    "fr": "Un abonnement.",
    "ar": "اشتراك واحد."
  },
  "One location.": {
    "fr": "Un établissement.",
    "ar": "موقع واحد."
  },
  "One physical location.": {
    "fr": "Un établissement physique.",
    "ar": "موقع فعلي واحد."
  },
  "One workspace.": {
    "fr": "Un espace de travail.",
    "ar": "مساحة عمل واحدة."
  },
  "One platform.": {
    "fr": "Une plateforme.",
    "ar": "منصة واحدة."
  },
  "One number.": {
    "fr": "Un chiffre.",
    "ar": "رقم واحد."
  },
  "One Location Model": {
    "fr": "Modèle à un établissement",
    "ar": "نموذج الموقع الواحد"
  },
  "ONE LOCATION · CONTROLLED AI": {
    "fr": "UN ÉTABLISSEMENT · IA ENCADRÉE",
    "ar": "موقع واحد · ذكاء اصطناعي منضبط"
  },
  "Simple, honest pricing.": {
    "fr": "Des tarifs simples et transparents.",
    "ar": "أسعار بسيطة وشفافة."
  },
  "One subscription = one real physical business location. Clear plans. Transparent limits. No hidden surprises.": {
    "fr": "Un abonnement = un établissement physique réel. Des offres claires, des limites transparentes, sans mauvaise surprise.",
    "ar": "اشتراك واحد = موقع فعلي واحد للنشاط التجاري. خطط واضحة وحدود شفافة بلا مفاجآت خفية."
  },
  "One subscription = one real physical business location. Clear plan boundaries around one physical business location.": {
    "fr": "Un abonnement = un établissement physique réel. Chaque offre couvre clairement un seul établissement.",
    "ar": "اشتراك واحد = موقع فعلي واحد للنشاط التجاري. نطاق واضح لكل خطة حول موقع واحد."
  },
  "One subscription = one real physical business location. The connected platforms are integrations, not extra seats.": {
    "fr": "Un abonnement = un établissement physique réel. Les plateformes connectées sont des intégrations, pas des sièges supplémentaires.",
    "ar": "اشتراك واحد = موقع فعلي واحد للنشاط التجاري. المنصات المتصلة هي عمليات تكامل وليست مقاعد إضافية."
  },
  ", not extra locations. Enterprise plans unlock multi-location management for groups, chains, and franchises.": {
    "fr": ", pas des établissements supplémentaires. Les offres Enterprise permettent aux groupes, réseaux et franchises de gérer plusieurs établissements.",
    "ar": "، وليست مواقع إضافية. تتيح خطط Enterprise إدارة مواقع متعددة للمجموعات والسلاسل والامتيازات."
  },
  "Intelligence": {
    "fr": "Intelligence",
    "ar": "التحليل الذكي"
  },
  "Signals": {
    "fr": "Signaux",
    "ar": "المؤشرات"
  },
  "Signal categories": {
    "fr": "Catégories de signaux",
    "ar": "فئات المؤشرات"
  },
  "Signal-driven updates": {
    "fr": "Mises à jour guidées par les signaux",
    "ar": "تحديثات تستند إلى المؤشرات"
  },
  "Actions": {
    "fr": "Actions",
    "ar": "الإجراءات"
  },
  "Action": {
    "fr": "Action",
    "ar": "إجراء"
  },
  "Priority": {
    "fr": "Priorité",
    "ar": "الأولوية"
  },
  "Visibility": {
    "fr": "Visibilité",
    "ar": "الظهور"
  },
  "Reputation": {
    "fr": "Réputation",
    "ar": "السمعة"
  },
  "Engagement": {
    "fr": "Engagement",
    "ar": "التفاعل"
  },
  "Context": {
    "fr": "Contexte",
    "ar": "السياق"
  },
  "History": {
    "fr": "Historique",
    "ar": "السجل"
  },
  "Insights": {
    "fr": "Analyses",
    "ar": "الرؤى"
  },
  "Overview": {
    "fr": "Vue d’ensemble",
    "ar": "نظرة عامة"
  },
  "Channels": {
    "fr": "Canaux",
    "ar": "القنوات"
  },
  "Ecosystem": {
    "fr": "Écosystème",
    "ar": "المنظومة"
  },
  "Connected Ecosystem": {
    "fr": "Écosystème connecté",
    "ar": "منظومة متصلة"
  },
  "Provider Ecosystem": {
    "fr": "Écosystème de fournisseurs",
    "ar": "منظومة مزودي الخدمات"
  },
  "Intelligence for local growth.": {
    "fr": "L’intelligence au service de la croissance locale.",
    "ar": "تحليلات ذكية للنمو المحلي."
  },
  "An intelligence layer": {
    "fr": "Une couche d’intelligence",
    "ar": "طبقة من التحليل الذكي"
  },
  "An intelligence layer that thinks with you.": {
    "fr": "Une couche d’intelligence qui réfléchit avec vous.",
    "ar": "طبقة ذكية تفكر معك."
  },
  "Get found": {
    "fr": "Être trouvé",
    "ar": "كن سهل العثور عليه"
  },
  "Build trust": {
    "fr": "Renforcer la confiance",
    "ar": "ابنِ الثقة"
  },
  "Know what to do next": {
    "fr": "Savoir quoi faire ensuite",
    "ar": "اعرف خطوتك التالية"
  },
  "What Optrixis Local does": {
    "fr": "Ce que fait Optrixis Local",
    "ar": "ما الذي تقدمه Optrixis Local"
  },
  "Three outcomes that change your business.": {
    "fr": "Trois résultats qui transforment votre activité.",
    "ar": "ثلاث نتائج تُحدث فرقًا في نشاطك."
  },
  "Your business deserves": {
    "fr": "Votre entreprise mérite",
    "ar": "نشاطك التجاري يستحق"
  },
  "world-class intelligence.": {
    "fr": "une intelligence de premier plan.",
    "ar": "تحليلات ذكية بمستوى عالمي."
  },
  "Your entire local presence.": {
    "fr": "Toute votre présence locale.",
    "ar": "حضورك المحلي بالكامل."
  },
  "Your local presence.": {
    "fr": "Votre présence locale.",
    "ar": "حضورك المحلي."
  },
  "Your reputation,": {
    "fr": "Votre réputation,",
    "ar": "سمعتك،"
  },
  "Your channels create signals.": {
    "fr": "Vos canaux génèrent des signaux.",
    "ar": "قنواتك تنتج مؤشرات."
  },
  "OPTRIXIS turns them into decisions.": {
    "fr": "OPTRIXIS les transforme en décisions.",
    "ar": "تحوّلها OPTRIXIS إلى قرارات."
  },
  "Every channel that matters.": {
    "fr": "Tous les canaux qui comptent.",
    "ar": "كل قناة تهم نشاطك."
  },
  "Every signal that": {
    "fr": "Tous les signaux qui",
    "ar": "كل مؤشر"
  },
  "local growth.": {
    "fr": "la croissance locale.",
    "ar": "النمو المحلي."
  },
  "local growth, unified.": {
    "fr": "la croissance locale, unifiée.",
    "ar": "النمو المحلي في مكان واحد."
  },
  "Everything that drives": {
    "fr": "Tout ce qui stimule",
    "ar": "كل ما يدفع"
  },
  "attention next.": {
    "fr": "une attention prioritaire.",
    "ar": "الاهتمام التالي."
  },
  "Know what deserves": {
    "fr": "Identifiez ce qui mérite",
    "ar": "اعرف ما يستحق"
  },
  "The operating": {
    "fr": "Le système de pilotage",
    "ar": "نظام التشغيل"
  },
  "system for": {
    "fr": "pour",
    "ar": "من أجل"
  },
  "local businesses.": {
    "fr": "les entreprises locales.",
    "ar": "الأنشطة التجارية المحلية."
  },
  "together.": {
    "fr": "ensemble.",
    "ar": "معًا."
  },
  "Be found by the customers": {
    "fr": "Soyez trouvé par les clients",
    "ar": "كن ظاهرًا للعملاء"
  },
  "Be found everywhere": {
    "fr": "Soyez visible partout",
    "ar": "كن ظاهرًا في كل مكان"
  },
  "Connected.": {
    "fr": "Connectés.",
    "ar": "متصلة."
  },
  "Built for real": {
    "fr": "Conçu pour les vraies",
    "ar": "مصمم للأنشطة"
  },
  "Built for real local businesses.": {
    "fr": "Conçu pour les entreprises locales.",
    "ar": "مصمم للأنشطة التجارية المحلية الحقيقية."
  },
  "Designed for real local businesses": {
    "fr": "Conçu pour les entreprises locales",
    "ar": "مصمم للأنشطة التجارية المحلية الحقيقية"
  },
  "Built around one real local business location": {
    "fr": "Conçu autour d’un établissement physique réel",
    "ar": "مصمم حول موقع فعلي واحد للنشاط التجاري"
  },
  "Built for multi-location": {
    "fr": "Conçu pour le multiétablissement",
    "ar": "مصمم للمواقع المتعددة"
  },
  "With Optrixis": {
    "fr": "Avec Optrixis",
    "ar": "مع Optrixis"
  },
  "Before": {
    "fr": "Avant",
    "ar": "قبل"
  },
  "The transformation": {
    "fr": "La transformation",
    "ar": "التحول"
  },
  "From scattered signals to clear decisions.": {
    "fr": "Des signaux dispersés aux décisions claires.",
    "ar": "من مؤشرات متفرقة إلى قرارات واضحة."
  },
  "From signal to decision.": {
    "fr": "Du signal à la décision.",
    "ar": "من المؤشر إلى القرار."
  },
  "Operating flow": {
    "fr": "Cycle de fonctionnement",
    "ar": "سير العمل"
  },
  "How Optrixis Local works": {
    "fr": "Comment fonctionne Optrixis Local",
    "ar": "كيف تعمل Optrixis Local"
  },
  "From provider connection to a clearer operating context.": {
    "fr": "De la connexion des fournisseurs à un pilotage plus clair.",
    "ar": "من ربط مزودي الخدمات إلى فهم أوضح للعمل."
  },
  "Connect your channels": {
    "fr": "Connectez vos canaux",
    "ar": "اربط قنواتك"
  },
  "Your Local Score appears": {
    "fr": "Votre score local apparaît",
    "ar": "تظهر نتيجتك المحلية"
  },
  "AI analyzes your signals": {
    "fr": "L’IA analyse vos signaux",
    "ar": "يحلل الذكاء الاصطناعي مؤشراتك"
  },
  "Act with confidence": {
    "fr": "Agissez avec confiance",
    "ar": "تصرف بثقة"
  },
  "Start growing locally today.": {
    "fr": "Commencez votre croissance locale aujourd’hui.",
    "ar": "ابدأ نموك المحلي اليوم."
  },
  "Ready to grow locally?": {
    "fr": "Prêt à développer votre présence locale ?",
    "ar": "هل أنت مستعد للنمو محليًا؟"
  },
  "Ready to take control of your local growth?": {
    "fr": "Prêt à piloter votre croissance locale ?",
    "ar": "هل أنت مستعد لقيادة نموك المحلي؟"
  },
  "Ready to own your reputation?": {
    "fr": "Prêt à prendre votre réputation en main ?",
    "ar": "هل أنت مستعد لإدارة سمعتك؟"
  },
  "Start with OPTRIXIS LOCAL": {
    "fr": "Commencez avec OPTRIXIS LOCAL",
    "ar": "ابدأ مع OPTRIXIS LOCAL"
  },
  "Get started with Optrixis Local": {
    "fr": "Démarrer avec Optrixis Local",
    "ar": "ابدأ مع Optrixis Local"
  },
  "See the platform": {
    "fr": "Découvrir la plateforme",
    "ar": "شاهد المنصة"
  },
  "See a demo": {
    "fr": "Voir une démo",
    "ar": "شاهد عرضًا توضيحيًا"
  },
  "See Optrixis Local in action.": {
    "fr": "Découvrez Optrixis Local en action.",
    "ar": "شاهد Optrixis Local أثناء العمل."
  },
  "Talk to sales": {
    "fr": "Contacter l’équipe commerciale",
    "ar": "تحدث مع المبيعات"
  },
  "Work with us": {
    "fr": "Travailler avec nous",
    "ar": "اعمل معنا"
  },
  "Our mission": {
    "fr": "Notre mission",
    "ar": "رسالتنا"
  },
  "What we stand for": {
    "fr": "Nos engagements",
    "ar": "مبادئنا"
  },
  "We believe local businesses deserve": {
    "fr": "Nous pensons que les entreprises locales méritent",
    "ar": "نؤمن بأن الأنشطة التجارية المحلية تستحق"
  },
  "Clarity over complexity": {
    "fr": "La clarté avant la complexité",
    "ar": "الوضوح قبل التعقيد"
  },
  "Action over information": {
    "fr": "L’action au-delà de l’information",
    "ar": "العمل انطلاقًا من المعلومات"
  },
  "Honest intelligence": {
    "fr": "Une intelligence transparente",
    "ar": "تحليل ذكي وشفاف"
  },
  "Human control": {
    "fr": "Contrôle humain",
    "ar": "التحكم البشري"
  },
  "Human-controlled": {
    "fr": "Sous contrôle humain",
    "ar": "تحت التحكم البشري"
  },
  "Governed access": {
    "fr": "Accès encadré",
    "ar": "وصول منضبط"
  },
  "Access controls": {
    "fr": "Contrôles d’accès",
    "ar": "ضوابط الوصول"
  },
  "Audit trails": {
    "fr": "Journaux d’audit",
    "ar": "سجلات التدقيق"
  },
  "Tenant isolation": {
    "fr": "Isolation des organisations",
    "ar": "عزل المؤسسات"
  },
  "Operational controls": {
    "fr": "Contrôles opérationnels",
    "ar": "ضوابط التشغيل"
  },
  "Operational resilience": {
    "fr": "Résilience opérationnelle",
    "ar": "المرونة التشغيلية"
  },
  "Data lifecycle": {
    "fr": "Cycle de vie des données",
    "ar": "دورة حياة البيانات"
  },
  "Data lifecycle controls": {
    "fr": "Contrôles du cycle de vie des données",
    "ar": "ضوابط دورة حياة البيانات"
  },
  "Data ownership": {
    "fr": "Propriété des données",
    "ar": "ملكية البيانات"
  },
  "Minimal collection": {
    "fr": "Collecte minimale",
    "ar": "الحد الأدنى من جمع البيانات"
  },
  "Provider transparency": {
    "fr": "Transparence sur les fournisseurs",
    "ar": "الشفافية بشأن مزودي الخدمات"
  },
  "Transparent AI": {
    "fr": "IA transparente",
    "ar": "ذكاء اصطناعي شفاف"
  },
  "Transport & secret hygiene": {
    "fr": "Sécurité des échanges et des secrets",
    "ar": "أمان النقل وحماية الأسرار"
  },
  "GDPR readiness": {
    "fr": "Préparation au RGPD",
    "ar": "الاستعداد للائحة حماية البيانات العامة"
  },
  "Our data principles": {
    "fr": "Nos principes sur les données",
    "ar": "مبادئنا بشأن البيانات"
  },
  "Built on trust and transparency.": {
    "fr": "Fondé sur la confiance et la transparence.",
    "ar": "مبني على الثقة والشفافية."
  },
  "Your data. Your business. Your control.": {
    "fr": "Vos données. Votre entreprise. Votre contrôle.",
    "ar": "بياناتك. نشاطك. تحكمك."
  },
  "You control your data": {
    "fr": "Vous contrôlez vos données",
    "ar": "أنت تتحكم في بياناتك"
  },
  "We never sell your data": {
    "fr": "Nous ne vendons jamais vos données",
    "ar": "لا نبيع بياناتك مطلقًا"
  },
  "Contact our security team": {
    "fr": "Contacter notre équipe sécurité",
    "ar": "تواصل مع فريق الأمان"
  },
  "Questions about our security posture or data practices?": {
    "fr": "Des questions sur notre sécurité ou nos pratiques de gestion des données ?",
    "ar": "هل لديك أسئلة حول الأمان أو ممارساتنا المتعلقة بالبيانات؟"
  },
  "An Optrixis LLC Product": {
    "fr": "Un produit Optrixis LLC",
    "ar": "منتج من Optrixis LLC"
  },
  "© 2026 Optrixis LLC. OPTRIXIS LOCAL is an Optrixis LLC product.": {
    "fr": "© 2026 Optrixis LLC. OPTRIXIS LOCAL est un produit Optrixis LLC.",
    "ar": "© 2026 Optrixis LLC. ‏OPTRIXIS LOCAL منتج من Optrixis LLC."
  },
  "Grow locally. Go further. ↗": {
    "fr": "Grandissez localement. Allez plus loin. ↗",
    "ar": "انمُ محليًا. وانطلق أبعد. ↖"
  },
  "Common questions.": {
    "fr": "Questions fréquentes.",
    "ar": "أسئلة شائعة."
  },
  "Frequently asked questions": {
    "fr": "Questions fréquentes",
    "ar": "الأسئلة الشائعة"
  },
  "Can't find what you're looking for?": {
    "fr": "Vous ne trouvez pas votre réponse ?",
    "ar": "لم تجد ما تبحث عنه؟"
  },
  "Getting started": {
    "fr": "Premiers pas",
    "ar": "البدء"
  },
  "Platform & features": {
    "fr": "Plateforme et fonctionnalités",
    "ar": "المنصة والميزات"
  },
  "Pricing & billing": {
    "fr": "Tarifs et facturation",
    "ar": "الأسعار والفوترة"
  },
  "Less detail": {
    "fr": "Moins de détails",
    "ar": "تفاصيل أقل"
  },
  "Integration & capability details": {
    "fr": "Détails des intégrations et capacités",
    "ar": "تفاصيل التكامل والإمكانات"
  },
  "Page not found.": {
    "fr": "Page introuvable.",
    "ar": "الصفحة غير موجودة."
  },
  "Go home": {
    "fr": "Retour à l’accueil",
    "ar": "العودة إلى الرئيسية"
  },
  "The page you're looking for doesn't exist or has been moved. Let's get you back on track.": {
    "fr": "La page recherchée n’existe pas ou a été déplacée. Revenons à l’accueil.",
    "ar": "الصفحة التي تبحث عنها غير موجودة أو نُقلت. لنعد إلى الصفحة الرئيسية."
  },
  "Guide preview": {
    "fr": "Aperçu du guide",
    "ar": "ملخص الدليل"
  },
  "· Guide preview": {
    "fr": "· Aperçu du guide",
    "ar": "· ملخص الدليل"
  },
  "Guides, research, and strategies to help local businesses grow smarter.": {
    "fr": "Des guides, études et stratégies pour aider les entreprises locales à mieux se développer.",
    "ar": "أدلة وأبحاث واستراتيجيات لمساعدة الأنشطة المحلية على النمو بذكاء."
  },
  "This preview introduces the topic. Explore the platform for current product information, or contact us with your questions.": {
    "fr": "Cet aperçu présente le sujet. Découvrez la plateforme pour connaître le produit actuel, ou contactez-nous pour toute question.",
    "ar": "يقدم هذا الملخص الموضوع. استكشف المنصة للاطلاع على معلومات المنتج الحالية، أو تواصل معنا لطرح أسئلتك."
  },
  "Related OPTRIXIS capabilities": {
    "fr": "Fonctionnalités OPTRIXIS associées",
    "ar": "إمكانات OPTRIXIS ذات الصلة"
  },
  "First name": {
    "fr": "Prénom",
    "ar": "الاسم الأول"
  },
  "Last name": {
    "fr": "Nom",
    "ar": "اسم العائلة"
  },
  "Full name": {
    "fr": "Nom complet",
    "ar": "الاسم الكامل"
  },
  "Business email": {
    "fr": "E-mail professionnel",
    "ar": "البريد الإلكتروني للعمل"
  },
  "Business type": {
    "fr": "Type d’activité",
    "ar": "نوع النشاط"
  },
  "Locations": {
    "fr": "Établissements",
    "ar": "المواقع"
  },
  "Phone (optional)": {
    "fr": "Téléphone (facultatif)",
    "ar": "الهاتف (اختياري)"
  },
  "Send message": {
    "fr": "Envoyer le message",
    "ar": "إرسال الرسالة"
  },
  "Book my demo": {
    "fr": "Réserver ma démo",
    "ar": "احجز عرضي التوضيحي"
  },
  "Message received": {
    "fr": "Message reçu",
    "ar": "تم استلام الرسالة"
  },
  "Demo request received": {
    "fr": "Demande de démo reçue",
    "ar": "تم استلام طلب العرض التوضيحي"
  },
  "Access request received": {
    "fr": "Demande d’accès reçue",
    "ar": "تم استلام طلب الوصول"
  },
  "Enterprise request received": {
    "fr": "Demande Enterprise reçue",
    "ar": "تم استلام طلب Enterprise"
  },
  "and acknowledge our": {
    "fr": "et prenez connaissance de notre",
    "ar": "وتقر بالاطلاع على"
  },
  "message": {
    "fr": "message",
    "ar": "الرسالة"
  },
  "request": {
    "fr": "demande",
    "ar": "الطلب"
  },
  "2h ago": {
    "fr": "il y a 2 h",
    "ar": "منذ ساعتين"
  },
  "Google · 3 min ago": {
    "fr": "Google · il y a 3 min",
    "ar": "Google · منذ 3 دقائق"
  },
  "Aug 8, 2026": {
    "fr": "8 août 2026",
    "ar": "8 أغسطس 2026"
  },
  "Aug 15, 2026": {
    "fr": "15 août 2026",
    "ar": "15 أغسطس 2026"
  },
  "Aug 22, 2026": {
    "fr": "22 août 2026",
    "ar": "22 أغسطس 2026"
  },
  "Aug 28, 2026": {
    "fr": "28 août 2026",
    "ar": "28 أغسطس 2026"
  },
  "Jul 22, 2026": {
    "fr": "22 juillet 2026",
    "ar": "22 يوليو 2026"
  },
  "Jul 30, 2026": {
    "fr": "30 juillet 2026",
    "ar": "30 يوليو 2026"
  },
  "Active": {
    "fr": "Actif",
    "ar": "نشط"
  },
  "Live": {
    "fr": "En direct",
    "ar": "مباشر"
  },
  "Selected": {
    "fr": "Sélectionné",
    "ar": "محدد"
  },
  "Do it": {
    "fr": "Agir",
    "ar": "نفّذ الإجراء"
  },
  "Always yours": {
    "fr": "Toujours à vous",
    "ar": "ملكك دائمًا"
  },
  "Approval boundaries": {
    "fr": "Cadre d’approbation",
    "ar": "حدود الموافقة"
  },
  "Backups & health checks": {
    "fr": "Sauvegardes et contrôles de disponibilité",
    "ar": "النسخ الاحتياطية وفحوص سلامة التشغيل"
  },
  "Multi-tenant controls": {
    "fr": "Contrôles multi-organisations",
    "ar": "ضوابط تعدد المؤسسات"
  },
  "Privacy controls": {
    "fr": "Contrôles de confidentialité",
    "ar": "ضوابط الخصوصية"
  },
  "Traceable operations": {
    "fr": "Opérations traçables",
    "ar": "عمليات قابلة للتتبع"
  },
  "Export & deletion paths": {
    "fr": "Procédures d’export et de suppression",
    "ar": "مسارات التصدير والحذف"
  },
  "AI Draft Response": {
    "fr": "Brouillon de réponse IA",
    "ar": "مسودة رد بالذكاء الاصطناعي"
  },
  "AI Opportunity": {
    "fr": "Opportunité IA",
    "ar": "فرصة رصدها الذكاء الاصطناعي"
  },
  "AI response drafts": {
    "fr": "Brouillons de réponses IA",
    "ar": "مسودات ردود بالذكاء الاصطناعي"
  },
  "AI-assisted context": {
    "fr": "Contexte assisté par IA",
    "ar": "سياق بمساعدة الذكاء الاصطناعي"
  },
  "AI-assisted opportunities": {
    "fr": "Opportunités assistées par IA",
    "ar": "فرص بمساعدة الذكاء الاصطناعي"
  },
  "AI-assisted responses": {
    "fr": "Réponses assistées par IA",
    "ar": "ردود بمساعدة الذكاء الاصطناعي"
  },
  "AI-assisted review response drafts with operator approval": {
    "fr": "Brouillons de réponses aux avis assistés par IA et approuvés par l’opérateur",
    "ar": "مسودات ردود على التقييمات بمساعدة الذكاء الاصطناعي وموافقة المسؤول"
  },
  "AI-drafted review responses in your brand voice": {
    "fr": "Réponses aux avis rédigées par IA dans le ton de votre marque",
    "ar": "ردود على التقييمات بصياغة الذكاء الاصطناعي وبأسلوب علامتك"
  },
  "Assisted interpretation of supported local signals": {
    "fr": "Interprétation assistée des signaux locaux pris en charge",
    "ar": "تفسير مساعد للمؤشرات المحلية المدعومة"
  },
  "Assisted reputation context and response drafting": {
    "fr": "Contexte de réputation et rédaction de réponses assistés",
    "ar": "سياق السمعة وصياغة الردود بمساعدة ذكية"
  },
  "Assisted response drafting with operator approval": {
    "fr": "Rédaction assistée de réponses avec approbation de l’opérateur",
    "ar": "صياغة ردود مساعدة بموافقة المسؤول"
  },
  "Assisted review intelligence with human control": {
    "fr": "Analyse assistée des avis sous contrôle humain",
    "ar": "تحليل مساعد للتقييمات تحت تحكم بشري"
  },
  "Assisted review-response drafting with operator control": {
    "fr": "Rédaction assistée de réponses aux avis sous contrôle de l’opérateur",
    "ar": "صياغة مساعدة للردود على التقييمات تحت تحكم المسؤول"
  },
  "Review Intelligence": {
    "fr": "Analyse des avis",
    "ar": "تحليل التقييمات"
  },
  "Review intelligence": {
    "fr": "Analyse des avis",
    "ar": "تحليل التقييمات"
  },
  "Review response drafts": {
    "fr": "Brouillons de réponses aux avis",
    "ar": "مسودات الردود على التقييمات"
  },
  "Review history": {
    "fr": "Historique des avis",
    "ar": "سجل التقييمات"
  },
  "Review activity history": {
    "fr": "Historique de l’activité des avis",
    "ar": "سجل نشاط التقييمات"
  },
  "Recent reviews": {
    "fr": "Avis récents",
    "ar": "التقييمات الأخيرة"
  },
  "Sample review": {
    "fr": "Exemple d’avis",
    "ar": "تقييم توضيحي"
  },
  "New review": {
    "fr": "Nouvel avis",
    "ar": "تقييم جديد"
  },
  "Reputation alerts": {
    "fr": "Alertes de réputation",
    "ar": "تنبيهات السمعة"
  },
  "Reviews that build trust": {
    "fr": "Des avis qui renforcent la confiance",
    "ar": "تقييمات تبني الثقة"
  },
  "Response rate tracking": {
    "fr": "Suivi du taux de réponse",
    "ar": "تتبع معدل الردود"
  },
  "Keyword context": {
    "fr": "Contexte des mots-clés",
    "ar": "سياق الكلمات المفتاحية"
  },
  "Keyword history": {
    "fr": "Historique des mots-clés",
    "ar": "سجل الكلمات المفتاحية"
  },
  "Keyword opportunities": {
    "fr": "Opportunités de mots-clés",
    "ar": "فرص الكلمات المفتاحية"
  },
  "Keyword signals": {
    "fr": "Signaux des mots-clés",
    "ar": "مؤشرات الكلمات المفتاحية"
  },
  "Category keyword context": {
    "fr": "Contexte des mots-clés par catégorie",
    "ar": "سياق الكلمات المفتاحية حسب الفئة"
  },
  "Specialty keyword context": {
    "fr": "Contexte des mots-clés de spécialité",
    "ar": "سياق الكلمات المفتاحية للتخصص"
  },
  "Traveler keyword context": {
    "fr": "Contexte des mots-clés des voyageurs",
    "ar": "سياق الكلمات المفتاحية للمسافرين"
  },
  "Profile context": {
    "fr": "Contexte du profil",
    "ar": "سياق الملف"
  },
  "Profile-change context": {
    "fr": "Contexte des changements de profil",
    "ar": "سياق تغييرات الملف"
  },
  "Seasonal context": {
    "fr": "Contexte saisonnier",
    "ar": "السياق الموسمي"
  },
  "Local context": {
    "fr": "Contexte local",
    "ar": "السياق المحلي"
  },
  "Local visibility context": {
    "fr": "Contexte de visibilité locale",
    "ar": "سياق الظهور المحلي"
  },
  "History-aware context": {
    "fr": "Contexte enrichi par l’historique",
    "ar": "سياق يستند إلى السجل"
  },
  "History-aware context connecting supported signals and actions": {
    "fr": "Contexte historique reliant les signaux et actions pris en charge",
    "ar": "سياق تاريخي يربط المؤشرات والإجراءات المدعومة"
  },
  "Local performance context preserved over time": {
    "fr": "Contexte des performances locales conservé dans le temps",
    "ar": "سياق الأداء المحلي المحفوظ عبر الزمن"
  },
  "Pattern context": {
    "fr": "Contexte des tendances",
    "ar": "سياق الأنماط"
  },
  "Plain-language explanations": {
    "fr": "Explications en langage clair",
    "ar": "تفسيرات بلغة واضحة"
  },
  "Plain-language explanations of every metric change": {
    "fr": "Explications claires de chaque variation d’indicateur",
    "ar": "تفسيرات واضحة لكل تغير في المقاييس"
  },
  "Plain-language explanations of supported signal changes": {
    "fr": "Explications claires des changements de signaux pris en charge",
    "ar": "تفسيرات واضحة لتغيرات المؤشرات المدعومة"
  },
  "Search impressions": {
    "fr": "Impressions dans la recherche",
    "ar": "مرات الظهور في البحث"
  },
  "Search visibility overview": {
    "fr": "Vue d’ensemble de la visibilité dans la recherche",
    "ar": "نظرة عامة على الظهور في البحث"
  },
  "Google Performance": {
    "fr": "Performances Google",
    "ar": "أداء Google"
  },
  "Google Reviews": {
    "fr": "Avis Google",
    "ar": "تقييمات Google"
  },
  "Google performance context": {
    "fr": "Contexte des performances Google",
    "ar": "سياق أداء Google"
  },
  "Google review workflow": {
    "fr": "Traitement des avis Google",
    "ar": "سير عمل تقييمات Google"
  },
  "Ranked priority actions": {
    "fr": "Actions prioritaires classées",
    "ar": "إجراءات ذات أولوية مرتبة"
  },
  "Priority actions ranked through defined impact rules": {
    "fr": "Actions prioritaires classées selon des règles d’impact définies",
    "ar": "إجراءات ذات أولوية مرتبة وفق قواعد محددة للأثر"
  },
  "Impact-oriented ranking": {
    "fr": "Classement selon l’impact",
    "ar": "ترتيب حسب الأثر"
  },
  "Personalized priority actions ranked by impact": {
    "fr": "Actions prioritaires personnalisées classées selon l’impact",
    "ar": "إجراءات أولوية مخصصة ومرتبة حسب الأثر"
  },
  "Competitive gap analysis with actionable guidance": {
    "fr": "Analyse des écarts concurrentiels et conseils concrets",
    "ar": "تحليل الفجوات التنافسية مع توجيهات قابلة للتنفيذ"
  },
  "Critical and high-impact signals surfaced first": {
    "fr": "Les signaux critiques et à fort impact en premier",
    "ar": "عرض المؤشرات الحرجة وذات الأثر الكبير أولًا"
  },
  "Priority connection": {
    "fr": "Lien avec les priorités",
    "ar": "الارتباط بالأولويات"
  },
  "Centralized AI intelligence": {
    "fr": "Intelligence IA centralisée",
    "ar": "تحليل مركزي بالذكاء الاصطناعي"
  },
  "Custom integration planning": {
    "fr": "Planification des intégrations sur mesure",
    "ar": "تخطيط عمليات التكامل المخصصة"
  },
  "Integration planning": {
    "fr": "Planification des intégrations",
    "ar": "تخطيط التكامل"
  },
  "Enterprise capabilities": {
    "fr": "Capacités Enterprise",
    "ar": "إمكانات Enterprise"
  },
  "Enterprise path for location portfolios": {
    "fr": "Parcours Enterprise pour les portefeuilles d’établissements",
    "ar": "مسار Enterprise لمجموعات المواقع"
  },
  "Multi-location rollout": {
    "fr": "Déploiement multiétablissement",
    "ar": "إطلاق عبر مواقع متعددة"
  },
  "Contact-led rollout": {
    "fr": "Déploiement accompagné",
    "ar": "إطلاق بمرافقة الفريق"
  },
  "Tailored rollout": {
    "fr": "Déploiement sur mesure",
    "ar": "إطلاق مخصص"
  },
  "Built around your locations": {
    "fr": "Conçu autour de vos établissements",
    "ar": "مصمم حول مواقعك"
  },
  "Single-location operating view": {
    "fr": "Vue de pilotage d’un établissement",
    "ar": "واجهة تشغيل لموقع واحد"
  },
  "Controlled trial window": {
    "fr": "Période d’essai encadrée",
    "ar": "فترة تجربة منضبطة"
  },
  "Controlled workflow": {
    "fr": "Processus encadré",
    "ar": "سير عمل منضبط"
  },
  "Core V1 provider workflow, subject to provider approval": {
    "fr": "Parcours fournisseur principal de la V1, sous réserve d’approbation",
    "ar": "سير عمل المزود الأساسي في V1، رهن موافقته"
  },
  "Core local discovery and reputation provider workflow": {
    "fr": "Parcours fournisseur principal pour la découverte locale et la réputation",
    "ar": "سير عمل المزود الأساسي للاكتشاف المحلي والسمعة"
  },
  "Demo workspace": {
    "fr": "Espace de démonstration",
    "ar": "مساحة عمل تجريبية"
  },
  "Good morning": {
    "fr": "Bonjour",
    "ar": "صباح الخير"
  },
  "Your Business": {
    "fr": "Votre entreprise",
    "ar": "نشاطك التجاري"
  },
  "Your Business Location": {
    "fr": "Votre établissement",
    "ar": "موقع نشاطك التجاري"
  },
  "Your Local Score": {
    "fr": "Votre score local",
    "ar": "نتيجتك المحلية"
  },
  "Your actions for today": {
    "fr": "Vos actions du jour",
    "ar": "إجراءاتك اليوم"
  },
  "Your local growth advisor": {
    "fr": "Votre conseiller en croissance locale",
    "ar": "مستشارك للنمو المحلي"
  },
  "Optrixis AI Insight": {
    "fr": "Analyse Optrixis AI",
    "ar": "رؤية من Optrixis AI"
  },
  "Example Local Business": {
    "fr": "Exemple d’entreprise locale",
    "ar": "نشاط محلي توضيحي"
  },
  "Example score view": {
    "fr": "Exemple de vue du score",
    "ar": "عرض توضيحي للنتيجة"
  },
  "Example signal view": {
    "fr": "Exemple de vue des signaux",
    "ar": "عرض توضيحي للمؤشرات"
  },
  "Example 90-day context": {
    "fr": "Exemple de contexte sur 90 jours",
    "ar": "سياق توضيحي لمدة 90 يومًا"
  },
  "Example tracked terms": {
    "fr": "Exemples de termes suivis",
    "ar": "أمثلة على العبارات المتتبعة"
  },
  "Illustrative Local Score": {
    "fr": "Exemple de score local",
    "ar": "نتيجة محلية توضيحية"
  },
  "Illustrative interface - example data": {
    "fr": "Interface illustrative — données d’exemple",
    "ar": "واجهة توضيحية — بيانات تجريبية"
  },
  "Illustrative interface preview — actual values depend on supported signals.": {
    "fr": "Aperçu illustratif de l’interface — les valeurs réelles dépendent des signaux disponibles.",
    "ar": "معاينة توضيحية للواجهة — تعتمد القيم الفعلية على المؤشرات المدعومة."
  },
  "Interactive preview": {
    "fr": "Aperçu interactif",
    "ar": "معاينة تفاعلية"
  },
  "\"Example customer feedback appears here after a supported review sync.\"": {
    "fr": "« Un exemple d’avis client apparaît ici après une synchronisation prise en charge. »",
    "ar": "«يظهر هنا مثال لتقييم عميل بعد مزامنة التقييمات المدعومة.»"
  },
  "\"Great local experience. Friendly service and a welcoming atmosphere.\"": {
    "fr": "« Une excellente expérience locale. Un service chaleureux et une ambiance accueillante. »",
    "ar": "«تجربة محلية رائعة. خدمة ودودة وأجواء مرحبة.»"
  },
  "Great food and atmosphere. Service was a bit slow at peak hours.": {
    "fr": "Cuisine et ambiance excellentes. Service un peu lent aux heures de pointe.",
    "ar": "طعام وأجواء رائعة. كانت الخدمة بطيئة قليلًا في أوقات الذروة."
  },
  "Absolutely exceptional service. Will be back every week.": {
    "fr": "Un service vraiment exceptionnel. Je reviendrai chaque semaine.",
    "ar": "خدمة استثنائية فعلًا. سأعود كل أسبوع."
  },
  "Best in the neighborhood, no question. 10 stars if I could.": {
    "fr": "Le meilleur du quartier, sans hésiter. Dix étoiles si c’était possible.",
    "ar": "الأفضل في الحي بلا شك. عشر نجوم لو أمكن."
  },
  "Thank you, James! We appreciate your kind words and are actively improving our peak-hour service. Hope to see you again soon!": {
    "fr": "Merci, James ! Vos mots nous font plaisir. Nous améliorons notre service aux heures de pointe. Au plaisir de vous revoir bientôt !",
    "ar": "شكرًا يا James! نقدّر كلماتك الطيبة ونعمل على تحسين الخدمة في أوقات الذروة. نأمل رؤيتك مجددًا قريبًا!"
  },
  "Draft prepared. Review or edit it before any controlled publishing step.": {
    "fr": "Brouillon préparé. Vérifiez-le ou modifiez-le avant toute publication encadrée.",
    "ar": "المسودة جاهزة. راجعها أو عدلها قبل أي خطوة نشر خاضعة للرقابة."
  },
  "Review Sunday closing time": {
    "fr": "Vérifier l’heure de fermeture du dimanche",
    "ar": "راجع وقت الإغلاق يوم الأحد"
  },
  "Respond to 2 unanswered reviews": {
    "fr": "Répondre à 2 avis sans réponse",
    "ar": "رد على تقييمين بلا إجابة"
  },
  "Review a meaningful visibility change": {
    "fr": "Examiner un changement notable de visibilité",
    "ar": "راجع تغيرًا مهمًا في الظهور"
  },
  "Review an unanswered customer question": {
    "fr": "Examiner une question client sans réponse",
    "ar": "راجع سؤال عميل لم يُجب عنه"
  },
  "New unanswered reviews are waiting for operator review and response.": {
    "fr": "De nouveaux avis attendent d’être examinés et traités par l’opérateur.",
    "ar": "تنتظر تقييمات جديدة دون إجابة مراجعة المسؤول وردّه."
  },
  "A supported customer question may need an operator response.": {
    "fr": "Une question client prise en charge peut nécessiter une réponse de l’opérateur.",
    "ar": "قد يحتاج سؤال عميل مدعوم إلى رد من المسؤول."
  },
  "A supported local-performance signal crossed the configured threshold.": {
    "fr": "Un signal de performance locale a franchi le seuil configuré.",
    "ar": "تجاوز مؤشر أداء محلي مدعوم الحد المضبوط."
  },
  "A supported profile signal suggests that the listed hours may deserve verification.": {
    "fr": "Un signal du profil suggère de vérifier les horaires affichés.",
    "ar": "يشير مؤشر ملف مدعوم إلى ضرورة التحقق من ساعات العمل المعروضة."
  },
  "Discover your visibility and reputation gaps": {
    "fr": "Identifiez vos lacunes de visibilité et de réputation",
    "ar": "اكتشف فجوات الظهور والسمعة لديك"
  },
  "Get a personalized roadmap for your business": {
    "fr": "Obtenez une feuille de route adaptée à votre entreprise",
    "ar": "احصل على خطة عمل تناسب نشاطك"
  },
  "Live walkthrough of the full platform": {
    "fr": "Présentation en direct de toute la plateforme",
    "ar": "جولة مباشرة في المنصة بالكامل"
  },
  "See how Local Score is structured around your location": {
    "fr": "Découvrez comment le score local est construit pour votre établissement",
    "ar": "شاهد كيف تُبنى النتيجة المحلية حول موقعك"
  },
  "What goes into your score": {
    "fr": "Les composantes de votre score",
    "ar": "مكونات نتيجتك"
  },
  "What Optrixis AI does": {
    "fr": "Ce que fait Optrixis AI",
    "ar": "ما الذي تقدمه Optrixis AI"
  },
  "The full ecosystem at a glance": {
    "fr": "L’écosystème complet en un coup d’œil",
    "ar": "نظرة شاملة على المنظومة"
  },
  "The channels around it.": {
    "fr": "Les canaux qui l’entourent.",
    "ar": "القنوات المحيطة به."
  },
  "Supported channels around it.": {
    "fr": "Les canaux pris en charge autour de lui.",
    "ar": "القنوات المدعومة المحيطة به."
  },
  "One platform. Industry-aware context.": {
    "fr": "Une plateforme. Un contexte adapté au secteur.",
    "ar": "منصة واحدة. سياق يراعي القطاع."
  },
  "Industry": {
    "fr": "Secteur",
    "ar": "القطاع"
  },
  "Hospitality": {
    "fr": "Hébergement",
    "ar": "الضيافة"
  },
  "Hotels": {
    "fr": "Hôtels",
    "ar": "الفنادق"
  },
  "Hospitality business": {
    "fr": "Entreprise d’hébergement",
    "ar": "نشاط ضيافة"
  },
  "Healthcare reception": {
    "fr": "Accueil d’un établissement de santé",
    "ar": "استقبال منشأة صحية"
  },
  "Independent restaurant": {
    "fr": "Restaurant indépendant",
    "ar": "مطعم مستقل"
  },
  "Independent retail boutique": {
    "fr": "Boutique indépendante",
    "ar": "متجر مستقل"
  },
  "Local salon": {
    "fr": "Salon de proximité",
    "ar": "صالون محلي"
  },
  "Client trust signals": {
    "fr": "Signaux de confiance des clients",
    "ar": "مؤشرات ثقة العملاء"
  },
  "Patient trust signals": {
    "fr": "Signaux de confiance des patients",
    "ar": "مؤشرات ثقة المرضى"
  },
  "Guest sentiment intelligence": {
    "fr": "Analyse du ressenti des clients",
    "ar": "تحليل مشاعر الضيوف"
  },
  "In-store visit intelligence": {
    "fr": "Analyse des visites en magasin",
    "ar": "تحليل زيارات المتجر"
  },
  "Compliant review management": {
    "fr": "Gestion des avis dans le respect des règles",
    "ar": "إدارة تقييمات تراعي الضوابط"
  },
  "Compliance-aware review response — knowing what to say and what not to": {
    "fr": "Réponses aux avis respectant les règles — savoir quoi dire et quoi éviter",
    "ar": "ردود على التقييمات تراعي الضوابط — معرفة ما يقال وما ينبغي تجنبه"
  },
  "Physical location per standard workspace": {
    "fr": "Établissement physique par espace standard",
    "ar": "موقع فعلي لكل مساحة عمل قياسية"
  },
  "Physical restaurant location per standard workspace": {
    "fr": "Restaurant physique par espace standard",
    "ar": "موقع مطعم فعلي لكل مساحة عمل قياسية"
  },
  "Physical salon location per standard workspace": {
    "fr": "Salon physique par espace standard",
    "ar": "موقع صالون فعلي لكل مساحة عمل قياسية"
  },
  "Physical hospitality location per standard workspace": {
    "fr": "Établissement d’hébergement par espace standard",
    "ar": "موقع ضيافة فعلي لكل مساحة عمل قياسية"
  },
  "Physical clinic location per standard workspace": {
    "fr": "Clinique physique par espace standard",
    "ar": "موقع عيادة فعلي لكل مساحة عمل قياسية"
  },
  "Physical retail location per standard workspace": {
    "fr": "Magasin physique par espace standard",
    "ar": "موقع متجر فعلي لكل مساحة عمل قياسية"
  },
  "Turn your online presence into full tables.": {
    "fr": "Transformez votre présence en ligne en tables occupées.",
    "ar": "حوّل حضورك عبر الإنترنت إلى طاولات ممتلئة."
  },
  "The reputation that keeps your calendar full.": {
    "fr": "La réputation qui remplit votre agenda.",
    "ar": "السمعة التي تملأ جدول حجوزاتك."
  },
  "Build the reputation that fills your calendar.": {
    "fr": "Bâtissez la réputation qui remplit votre agenda.",
    "ar": "ابنِ السمعة التي تملأ جدول حجوزاتك."
  },
  "Stand out where travelers search first.": {
    "fr": "Démarquez-vous là où les voyageurs cherchent en premier.",
    "ar": "تميّز حيث يبحث المسافرون أولًا."
  },
  "Build the trust that brings patients through your door.": {
    "fr": "Bâtissez la confiance qui attire les patients dans votre cabinet.",
    "ar": "ابنِ الثقة التي تجذب المرضى إلى عيادتك."
  },
  "Turn local search into foot traffic.": {
    "fr": "Transformez la recherche locale en visites en magasin.",
    "ar": "حوّل البحث المحلي إلى زيارات فعلية."
  },
  "Drive foot traffic with local intelligence.": {
    "fr": "Attirez des visites grâce à l’intelligence locale.",
    "ar": "اجذب الزوار بالتحليل المحلي الذكي."
  },
  "The challenges Optrixis Local solves for you": {
    "fr": "Les défis qu’Optrixis Local vous aide à relever",
    "ar": "التحديات التي تساعدك Optrixis Local على حلها"
  },
  "Restaurants, salons, hotels, clinics and retail.": {
    "fr": "Restaurants, salons, hôtels, cliniques et commerces.",
    "ar": "المطاعم والصالونات والفنادق والعيادات والمتاجر."
  },
  "Can I cancel anytime?": {
    "fr": "Puis-je résilier à tout moment ?",
    "ar": "هل يمكنني الإلغاء في أي وقت؟"
  },
  "Can I switch plans?": {
    "fr": "Puis-je changer d’offre ?",
    "ar": "هل يمكنني تغيير خطتي؟"
  },
  "Do I need technical knowledge to use Optrixis Local?": {
    "fr": "Faut-il des connaissances techniques pour utiliser Optrixis Local ?",
    "ar": "هل أحتاج إلى معرفة تقنية لاستخدام Optrixis Local؟"
  },
  "Do I need technical knowledge?": {
    "fr": "Faut-il des connaissances techniques ?",
    "ar": "هل أحتاج إلى معرفة تقنية؟"
  },
  "Do you have an API?": {
    "fr": "Proposez-vous une API ?",
    "ar": "هل لديكم واجهة API؟"
  },
  "Do you offer discounts for annual billing?": {
    "fr": "Proposez-vous une réduction sur la facturation annuelle ?",
    "ar": "هل تقدمون خصمًا للفوترة السنوية؟"
  },
  "How does Optrixis AI work?": {
    "fr": "Comment fonctionne Optrixis AI ?",
    "ar": "كيف تعمل Optrixis AI؟"
  },
  "How is Enterprise priced?": {
    "fr": "Comment l’offre Enterprise est-elle tarifée ?",
    "ar": "كيف يتم تسعير Enterprise؟"
  },
  "How long does setup take?": {
    "fr": "Combien de temps prend la configuration ?",
    "ar": "كم يستغرق الإعداد؟"
  },
  "Is Tripadvisor included?": {
    "fr": "Tripadvisor est-il inclus ?",
    "ar": "هل يشمل Tripadvisor؟"
  },
  "Is there a free trial?": {
    "fr": "Y a-t-il un essai gratuit ?",
    "ar": "هل تتوفر تجربة مجانية؟"
  },
  "Is there a trial?": {
    "fr": "Y a-t-il une période d’essai ?",
    "ar": "هل تتوفر فترة تجربة؟"
  },
  "A 14-day trial is available with controlled product entitlements.": {
    "fr": "Un essai de 14 jours est disponible avec des droits d’accès encadrés.",
    "ar": "تتوفر تجربة لمدة 14 يومًا بصلاحيات منتج محددة."
  },
  "A 14-day trial is available with controlled trial entitlements.": {
    "fr": "Un essai de 14 jours est disponible avec des droits d’accès encadrés.",
    "ar": "تتوفر تجربة لمدة 14 يومًا بصلاحيات تجربة محددة."
  },
  "A controlled 14-day trial follows approved Early Access. See Pricing for the current annual billing totals.": {
    "fr": "Un essai encadré de 14 jours suit l’approbation de l’accès anticipé. Consultez les tarifs pour les montants annuels actuels.",
    "ar": "تتبع الموافقة على الوصول المبكر تجربة منضبطة لمدة 14 يومًا. راجع الأسعار لمعرفة الإجماليات السنوية الحالية."
  },
  "Annual prices are shown as monthly equivalents billed yearly. The Pricing page shows the current yearly totals, and checkout remains the source of truth before payment.": {
    "fr": "Les tarifs annuels sont présentés en équivalent mensuel, facturés à l’année. La page Tarifs indique les totaux annuels actuels ; le montant affiché au paiement fait foi avant règlement.",
    "ar": "تُعرض الأسعار السنوية بمكافئ شهري وتُدفع سنويًا. تعرض صفحة الأسعار الإجماليات السنوية الحالية، ويُعتمد المبلغ الظاهر في صفحة الدفع قبل السداد."
  },
  "Enterprise has no public fixed price. Contact us for a proposal based on locations, rollout scope and integration requirements.": {
    "fr": "Enterprise n’a pas de prix fixe public. Contactez-nous pour une proposition selon vos établissements, le périmètre de déploiement et les intégrations nécessaires.",
    "ar": "لا يوجد سعر ثابت معلن لـ Enterprise. تواصل معنا للحصول على عرض حسب المواقع ونطاق الإطلاق ومتطلبات التكامل."
  },
  "Cancellation options and their effective date are shown in the application or applicable order flow. Fees are non-refundable except where required by law or expressly stated otherwise.": {
    "fr": "Les possibilités de résiliation et leur date d’effet figurent dans l’application ou le parcours de commande applicable. Les frais ne sont pas remboursables, sauf obligation légale ou mention expresse contraire.",
    "ar": "تظهر خيارات الإلغاء وتاريخ سريانها في التطبيق أو مسار الطلب المعني. الرسوم غير قابلة للاسترداد إلا إذا تطلب القانون ذلك أو نُص صراحةً على خلافه."
  },
  "A change in keyword and performance signals may deserve attention. Review the supporting context before deciding what to change.": {
    "fr": "Un changement dans les mots-clés et les performances peut mériter votre attention. Examinez le contexte avant de décider quoi modifier.",
    "ar": "قد يستحق تغير مؤشرات الكلمات المفتاحية والأداء اهتمامك. راجع السياق الداعم قبل تحديد ما ستغيره."
  },
  "A contact-led operating model for organizations managing multiple physical locations, with portfolio governance, custom rollout and integration planning.": {
    "fr": "Un modèle accompagné pour les organisations multiétablissements : gouvernance du portefeuille, déploiement sur mesure et planification des intégrations.",
    "ar": "نموذج عمل بمرافقة الفريق للمؤسسات التي تدير مواقع فعلية متعددة، مع حوكمة مجموعة المواقع وإطلاق مخصص وتخطيط التكامل."
  },
  "A curated queue of critical, high-impact and recommended actions derived from supported signals, with deduplication and controlled workflow rules.": {
    "fr": "Une sélection d’actions critiques, à fort impact et recommandées, issues des signaux pris en charge, avec dédoublonnage et règles de traitement encadrées.",
    "ar": "قائمة منتقاة من الإجراءات الحرجة وذات الأثر الكبير والموصى بها، مشتقة من المؤشرات المدعومة، مع إزالة التكرار وقواعد عمل منضبطة."
  },
  "A deep dive into the intelligence behind your Local Score: what signals it weighs, how it's calculated, and how to use it as a growth compass.": {
    "fr": "Découvrez les fondements du score local : les signaux pondérés, son calcul et son utilisation pour guider votre croissance.",
    "ar": "تعرّف على التحليل وراء نتيجتك المحلية: المؤشرات التي يوازنها، وكيف يُحسب، وكيف يوجّه نموك."
  },
  "A history-aware intelligence score built from supported local signals available for your location and plan.": {
    "fr": "Un score intelligent enrichi par l’historique, construit à partir des signaux locaux disponibles pour votre établissement et votre offre.",
    "ar": "نتيجة ذكية تستند إلى السجل، مبنية من المؤشرات المحلية المدعومة المتاحة لموقعك وخطتك."
  },
  "A history-aware intelligence view built from supported visibility, reputation and performance signals available for your location.": {
    "fr": "Une vue intelligente enrichie par l’historique, construite à partir des signaux de visibilité, de réputation et de performance disponibles pour votre établissement.",
    "ar": "واجهة تحليل ذكية تستند إلى السجل ومؤشرات الظهور والسمعة والأداء المدعومة المتاحة لموقعك."
  },
  "A history-aware intelligence view that brings supported visibility, reputation and performance signals into one clearer local benchmark.": {
    "fr": "Une vue intelligente enrichie par l’historique qui réunit les signaux de visibilité, de réputation et de performance dans un repère local plus clair.",
    "ar": "واجهة تحليل ذكية تستند إلى السجل وتجمع مؤشرات الظهور والسمعة والأداء المدعومة في معيار محلي أوضح."
  },
  "A meaningful change appeared in your supported local signals. Your Local Score history and review activity provide context for what deserves attention next.": {
    "fr": "Un changement notable est apparu dans vos signaux locaux. L’historique du score local et des avis aide à identifier ce qui mérite votre attention.",
    "ar": "ظهر تغير مهم في مؤشراتك المحلية المدعومة. يوفر سجل النتيجة المحلية ونشاط التقييمات سياقًا لما يستحق اهتمامك بعد ذلك."
  },
  "A ranked queue of critical, high-impact and recommended actions, organized by business impact and controlled workflow rules.": {
    "fr": "Une liste classée d’actions critiques, à fort impact et recommandées, organisée selon leur effet sur l’activité et des règles encadrées.",
    "ar": "قائمة مرتبة من الإجراءات الحرجة وذات الأثر الكبير والموصى بها، وفق أثرها على النشاط وقواعد عمل منضبطة."
  },
  "A sector-focused guide to the reputation, visibility and operating signals salons can monitor as their local presence evolves.": {
    "fr": "Un guide sectoriel des signaux de réputation, de visibilité et d’activité que les salons peuvent suivre au fil de leur développement local.",
    "ar": "دليل متخصص لمؤشرات السمعة والظهور والتشغيل التي يمكن للصالونات متابعتها مع تطور حضورها المحلي."
  },
  "A supported Google performance signal changed this week. I can show the related history and profile context so you can decide whether anything needs attention.": {
    "fr": "Un signal de performance Google a changé cette semaine. Je peux montrer son historique et le contexte du profil pour vous aider à décider s’il faut intervenir.",
    "ar": "تغير مؤشر أداء Google مدعوم هذا الأسبوع. يمكنني عرض السجل المرتبط وسياق الملف لتقرر ما إذا كان الأمر يحتاج إلى اهتمام."
  },
  "A supported performance signal changed around your location. Review the evidence and recommended next action before deciding what to change.": {
    "fr": "Un signal de performance a changé autour de votre établissement. Examinez les éléments et l’action recommandée avant de décider quoi modifier.",
    "ar": "تغير مؤشر أداء مدعوم حول موقعك. راجع الأدلة والخطوة الموصى بها قبل تحديد ما ستغيره."
  },
  "A supported review signal needs attention. I can show the context and prepare a response draft for operator review.": {
    "fr": "Un signal d’avis demande votre attention. Je peux en présenter le contexte et préparer une réponse à vérifier par l’opérateur.",
    "ar": "يحتاج مؤشر تقييم مدعوم إلى اهتمام. يمكنني عرض السياق وإعداد مسودة رد ليراجعها المسؤول."
  },
  "AI can draft response suggestions using available brand context. Operators review, edit and approve controlled publishing where supported.": {
    "fr": "L’IA peut proposer des réponses selon le contexte de marque disponible. Les opérateurs les vérifient, les modifient et approuvent leur publication lorsqu’elle est prise en charge.",
    "ar": "يمكن للذكاء الاصطناعي اقتراح ردود باستخدام سياق العلامة المتاح. يراجعها المسؤولون ويعدلونها ويوافقون على نشرها حيث يكون ذلك مدعومًا."
  },
  "AI provides context and drafts while controlled actions retain appropriate approval and audit boundaries.": {
    "fr": "L’IA fournit du contexte et des brouillons ; les actions encadrées restent soumises aux approbations et contrôles appropriés.",
    "ar": "يوفر الذكاء الاصطناعي السياق والمسودات، مع إبقاء الإجراءات المنضبطة ضمن حدود الموافقة والتدقيق المناسبة."
  },
  "AI surfaces what guests love most (and dislike most) about your property — with trends over time.": {
    "fr": "L’IA met en évidence ce que les clients apprécient le plus et le moins dans votre établissement, avec les tendances dans le temps.",
    "ar": "يبرز الذكاء الاصطناعي أكثر ما يحبه الضيوف وما لا يحبونه في منشأتك، مع اتجاهات عبر الزمن."
  },
  "AI-assisted analysis can add sentiment, severity, intent and recurring-pattern context to supported review signals.": {
    "fr": "L’analyse assistée par IA peut enrichir les avis pris en charge avec le ressenti, la gravité, l’intention et les tendances récurrentes.",
    "ar": "يمكن للتحليل المساعد بالذكاء الاصطناعي إضافة سياق المشاعر والشدة والنية والأنماط المتكررة إلى مؤشرات التقييمات المدعومة."
  },
  "AI-assisted analysis can surface recurring patterns and meaningful changes from supported signals without presenting speculation as fact.": {
    "fr": "L’analyse assistée par IA peut faire ressortir des tendances récurrentes et des changements notables, sans présenter les hypothèses comme des faits.",
    "ar": "يمكن للتحليل المساعد بالذكاء الاصطناعي إبراز الأنماط المتكررة والتغيرات المهمة من المؤشرات المدعومة دون تقديم التخمين كحقيقة."
  },
  "AI-assisted context and recommendations are designed to remain understandable, auditable and subject to human-control boundaries where actions are sensitive.": {
    "fr": "Le contexte et les recommandations assistés par IA sont conçus pour rester compréhensibles, auditables et sous contrôle humain pour les actions sensibles.",
    "ar": "صُمم السياق والتوصيات بمساعدة الذكاء الاصطناعي ليظلا مفهومين وقابلين للتدقيق وخاضعين للتحكم البشري في الإجراءات الحساسة."
  },
  "AI-assisted context helps explain supported local signals in plain language and surface priority actions while keeping important decisions under operator control.": {
    "fr": "Le contexte assisté par IA explique les signaux locaux en langage clair et fait ressortir les priorités, tout en laissant les décisions importantes à l’opérateur.",
    "ar": "يساعد السياق بالذكاء الاصطناعي على تفسير المؤشرات المحلية المدعومة بلغة واضحة وإبراز الأولويات، مع إبقاء القرارات المهمة بيد المسؤول."
  },
  "AI-assisted interpretation adds history and meaning.": {
    "fr": "L’interprétation assistée par IA ajoute de l’historique et du sens.",
    "ar": "يضيف التفسير المساعد بالذكاء الاصطناعي السجل والمعنى."
  },
  "AI-assisted interpretation that explains supported patterns and recommendations while keeping important actions under human control.": {
    "fr": "Une interprétation assistée par IA qui explique les tendances et recommandations, tout en conservant le contrôle humain des actions importantes.",
    "ar": "تفسير مساعد بالذكاء الاصطناعي يشرح الأنماط والتوصيات المدعومة مع إبقاء الإجراءات المهمة تحت التحكم البشري."
  },
  "AI-assisted response drafts designed for human review, with sensitive-content and privacy boundaries kept under operator control.": {
    "fr": "Des brouillons de réponses assistés par IA, destinés à une vérification humaine, avec le contenu sensible et la confidentialité sous contrôle de l’opérateur.",
    "ar": "مسودات ردود بمساعدة الذكاء الاصطناعي مصممة للمراجعة البشرية، مع إبقاء المحتوى الحساس والخصوصية تحت تحكم المسؤول."
  },
  "AI-powered local growth: what it is, what it isn't": {
    "fr": "Croissance locale et IA : ce qu’elle apporte, et ses limites",
    "ar": "النمو المحلي بالذكاء الاصطناعي: ما هو وما ليس كذلك"
  },
  "AI-powered priority actions tell you exactly what matters today, not just what changed.": {
    "fr": "Les actions prioritaires assistées par IA indiquent ce qui compte aujourd’hui, au-delà des seuls changements.",
    "ar": "توضح الإجراءات ذات الأولوية بالذكاء الاصطناعي ما يهم اليوم، وليس فقط ما تغير."
  },
  "Actions are organized into critical, high-impact and recommended levels using defined priority rules.": {
    "fr": "Les actions sont classées en niveaux critiques, à fort impact et recommandés selon des règles de priorité définies.",
    "ar": "تُنظم الإجراءات إلى مستويات حرجة وذات أثر كبير وموصى بها وفق قواعد أولوية محددة."
  },
  "Actions preserve ownership, status and audit context instead of becoming an untracked checklist.": {
    "fr": "Chaque action conserve son responsable, son état et sa traçabilité, au-delà d’une simple liste à cocher.",
    "ar": "تحتفظ الإجراءات بالمسؤولية والحالة وسياق التدقيق، بدل أن تصبح قائمة مهام بلا تتبع."
  },
  "An intelligence layer that explains supported signals, surfaces context, and helps operators decide what deserves attention next.": {
    "fr": "Une couche d’intelligence qui explique les signaux disponibles, présente leur contexte et aide l’opérateur à choisir ses prochaines priorités.",
    "ar": "طبقة تحليل ذكية تفسر المؤشرات المدعومة وتعرض السياق وتساعد المسؤولين على تحديد ما يستحق الاهتمام التالي."
  },
  "Application data and operations are scoped to the correct workspace and physical business location, with explicit authorization boundaries.": {
    "fr": "Les données et opérations de l’application sont limitées au bon espace et établissement physique, avec des autorisations explicites.",
    "ar": "تُحصر بيانات التطبيق وعملياته في مساحة العمل والموقع الفعلي الصحيحين، ضمن حدود صلاحيات صريحة."
  },
  "Bring review, local-search and priority signals into one operating view for a salon or spa.": {
    "fr": "Réunissez les avis, la recherche locale et les priorités dans une seule vue pour votre salon ou spa.",
    "ar": "اجمع مؤشرات التقييمات والبحث المحلي والأولويات في واجهة تشغيل واحدة لصالونك أو منتجعك الصحي."
  },
  "Bring supported Google Business Profile performance signals into the local history view.": {
    "fr": "Intégrez les performances Google Business Profile disponibles à la vue historique locale.",
    "ar": "أضف مؤشرات أداء Google Business Profile المدعومة إلى عرض السجل المحلي."
  },
  "Bring supported Google review activity, AI-assisted response drafts and operator-controlled publishing into one workflow.": {
    "fr": "Réunissez les avis Google disponibles, les brouillons IA et la publication contrôlée par l’opérateur dans un même processus.",
    "ar": "اجمع نشاط تقييمات Google المدعوم ومسودات الردود بالذكاء الاصطناعي والنشر بتحكم المسؤول في سير عمل واحد."
  },
  "Bring supported V1 reputation activity into one workflow across the provider ecosystem, with AI-assisted context and operator-controlled responses.": {
    "fr": "Réunissez l’activité de réputation prise en charge en V1 dans un processus commun aux fournisseurs, avec un contexte IA et des réponses contrôlées par l’opérateur.",
    "ar": "اجمع نشاط السمعة المدعوم في V1 عبر منظومة المزودين في سير عمل واحد، مع سياق بالذكاء الاصطناعي وردود بتحكم المسؤول."
  },
  "Bring supported review signals into one intelligent workflow with AI-assisted context, response drafts, deduplication and controlled publishing where the provider permits it.": {
    "fr": "Réunissez les avis pris en charge dans un processus intelligent avec contexte IA, brouillons, dédoublonnage et publication contrôlée lorsque le fournisseur l’autorise.",
    "ar": "اجمع مؤشرات التقييمات المدعومة في سير عمل ذكي مع سياق بالذكاء الاصطناعي ومسودات وردود وإزالة التكرار ونشر منضبط حيث يسمح المزود."
  },
  "Bring supported review signals into one workspace with AI-assisted analysis, response drafts, trend context and controlled publishing workflows.": {
    "fr": "Réunissez les avis disponibles dans un espace avec analyse IA, brouillons de réponses, suivi des tendances et publication encadrée.",
    "ar": "اجمع مؤشرات التقييمات المدعومة في مساحة واحدة مع تحليل بالذكاء الاصطناعي ومسودات ردود وسياق الاتجاهات وسير نشر منضبط."
  },
  "Bring your local presence together.": {
    "fr": "Réunissez votre présence locale.",
    "ar": "اجمع حضورك المحلي في مكان واحد."
  },
  "Changes in local-search visibility that are difficult to interpret without history": {
    "fr": "Des variations de visibilité locale difficiles à interpréter sans historique",
    "ar": "تغيرات في الظهور بالبحث المحلي يصعب تفسيرها دون سجل"
  },
  "Collection and processing are limited to product, security, billing, support and connected-provider purposes described in the published policies.": {
    "fr": "La collecte et le traitement sont limités aux finalités de produit, sécurité, facturation, assistance et fournisseurs connectés décrites dans les politiques publiées.",
    "ar": "يقتصر الجمع والمعالجة على أغراض المنتج والأمان والفوترة والدعم والمزودين المتصلين الموصوفة في السياسات المنشورة."
  },
  "Connect meaningful reputation and local-performance signals to ranked Priority Actions.": {
    "fr": "Reliez les signaux significatifs de réputation et de performance locale aux actions prioritaires classées.",
    "ar": "اربط مؤشرات السمعة والأداء المحلي المهمة بإجراءات الأولوية المرتبة."
  },
  "Connect supported Google performance, review and priority signals around one retail location.": {
    "fr": "Connectez les performances Google, avis et priorités disponibles autour d’un magasin.",
    "ar": "اربط مؤشرات أداء Google والتقييمات والأولويات المدعومة حول موقع متجر واحد."
  },
  "Connect supported providers as they become available. Google Business Profile is the core V1 workflow, subject to provider approval.": {
    "fr": "Connectez les fournisseurs pris en charge à mesure de leur disponibilité. Google Business Profile est le parcours principal de la V1, sous réserve d’approbation.",
    "ar": "اربط المزودين المدعومين عند توفرهم. Google Business Profile هو سير العمل الأساسي في V1، رهن موافقة المزود."
  },
  "Connected by purpose, not just channel.": {
    "fr": "Connectés par leur utilité, au-delà du canal.",
    "ar": "متصلة بهدف واضح يتجاوز القناة."
  },
  "Connected channels are only the beginning.": {
    "fr": "Connecter les canaux n’est qu’un début.",
    "ar": "ربط القنوات هو البداية فقط."
  },
  "Connected-provider data is used for the product workflows described in the privacy and integration documentation, with explicit disconnect and deletion paths.": {
    "fr": "Les données des fournisseurs connectés servent aux processus décrits dans la documentation de confidentialité et d’intégration, avec des procédures explicites de déconnexion et de suppression.",
    "ar": "تُستخدم بيانات المزودين المتصلين لسير عمل المنتج الموضح في وثائق الخصوصية والتكامل، مع مسارات واضحة للفصل والحذف."
  },
  "Critical and high-impact review signals can create controlled notifications according to configured policy, consent and plan entitlements.": {
    "fr": "Les signaux d’avis critiques et à fort impact peuvent générer des notifications encadrées selon les règles configurées, le consentement et les droits de l’offre.",
    "ar": "يمكن لمؤشرات التقييمات الحرجة وذات الأثر الكبير إنشاء إشعارات منضبطة وفق السياسة المضبوطة والموافقة وصلاحيات الخطة."
  },
  "Critical, high-impact and recommended actions are surfaced through the Priority Actions engine.": {
    "fr": "Le moteur d’actions prioritaires présente les actions critiques, à fort impact et recommandées.",
    "ar": "يُبرز محرك إجراءات الأولوية الإجراءات الحرجة وذات الأثر الكبير والموصى بها."
  },
  "Defined rules rank what deserves attention.": {
    "fr": "Des règles définies classent ce qui mérite votre attention.",
    "ar": "ترتب قواعد محددة ما يستحق الاهتمام."
  },
  "Difficulty encouraging satisfied clients to leave reviews without seeming pushy": {
    "fr": "La difficulté d’encourager les clients satisfaits à laisser un avis sans insister",
    "ar": "صعوبة تشجيع العملاء الراضين على ترك تقييمات دون إلحاح"
  },
  "Each V1 channel is mapped to a clear product purpose so discovery, reputation, messaging and customer signals stay understandable inside one operating view.": {
    "fr": "Chaque canal V1 répond à un objectif clair pour garder la découverte, la réputation, la messagerie et les signaux clients compréhensibles dans une même vue.",
    "ar": "ترتبط كل قناة في V1 بهدف منتج واضح، لتبقى مؤشرات الاكتشاف والسمعة والمراسلة والعملاء مفهومة في واجهة عمل واحدة."
  },
  "Each standard subscription covers one physical business address. Connected providers are channels around that same location, not extra locations. Multi-location organizations are handled through Enterprise.": {
    "fr": "Chaque abonnement standard couvre une adresse physique. Les fournisseurs connectés sont des canaux de ce même établissement. Les organisations multiétablissements passent par Enterprise.",
    "ar": "يغطي كل اشتراك قياسي عنوانًا فعليًا واحدًا. المزودون المتصلون قنوات حول الموقع نفسه وليسوا مواقع إضافية. تُدار المؤسسات متعددة المواقع عبر Enterprise."
  },
  "Each subscription covers one physical business address. Connected provider channels are integrations around that location — not extra locations. Enterprise plans cover multiple physical locations.": {
    "fr": "Chaque abonnement couvre une adresse physique. Les canaux fournisseurs sont des intégrations autour de cet établissement. Les offres Enterprise couvrent plusieurs établissements.",
    "ar": "يغطي كل اشتراك عنوانًا فعليًا واحدًا. قنوات المزودين المتصلين عمليات تكامل حول ذلك الموقع وليست مواقع إضافية. تغطي خطط Enterprise مواقع فعلية متعددة."
  },
  "Each subscription covers one physical business address. The connected platforms (Google, Meta, Instagram, etc.) are integrations — not extra locations. Enterprise plans cover multiple physical locations.": {
    "fr": "Chaque abonnement couvre une adresse physique. Les plateformes connectées (Google, Meta, Instagram…) sont des intégrations. Enterprise couvre plusieurs établissements physiques.",
    "ar": "يغطي كل اشتراك عنوانًا فعليًا واحدًا. المنصات المتصلة مثل Google وMeta وInstagram هي عمليات تكامل وليست مواقع إضافية. تغطي Enterprise مواقع فعلية متعددة."
  },
  "Enterprise access requirements are scoped during rollout, with role-aware permissions and auditable control boundaries built into the platform.": {
    "fr": "Les besoins d’accès Enterprise sont définis pendant le déploiement, avec des autorisations par rôle et des contrôles auditables intégrés.",
    "ar": "تُحدد متطلبات وصول Enterprise أثناء الإطلاق، مع صلاحيات حسب الأدوار وضوابط قابلة للتدقيق مدمجة في المنصة."
  },
  "Enterprise integration requirements can be evaluated and scoped against supported provider capabilities and security constraints.": {
    "fr": "Les besoins d’intégration Enterprise sont évalués selon les capacités des fournisseurs pris en charge et les contraintes de sécurité.",
    "ar": "يمكن تقييم متطلبات تكامل Enterprise وتحديد نطاقها وفق إمكانات المزودين المدعومة وقيود الأمان."
  },
  "Enterprise intelligence requirements can be scoped across the organization during rollout, subject to the approved multi-location architecture and available provider signals.": {
    "fr": "Les besoins d’analyse Enterprise peuvent être définis à l’échelle de l’organisation pendant le déploiement, selon l’architecture multiétablissement approuvée et les signaux disponibles.",
    "ar": "يمكن تحديد متطلبات التحليل في Enterprise على مستوى المؤسسة أثناء الإطلاق، حسب بنية المواقع المتعددة المعتمدة ومؤشرات المزودين المتاحة."
  },
  "Enterprise is the path for organizations operating multiple physical locations, with custom rollout, governance and implementation scope.": {
    "fr": "Enterprise s’adresse aux organisations multiétablissements, avec un déploiement, une gouvernance et un périmètre de mise en œuvre adaptés.",
    "ar": "Enterprise هو المسار للمؤسسات ذات المواقع الفعلية المتعددة، مع إطلاق وحوكمة ونطاق تنفيذ مخصص."
  },
  "Every SaaS tool claims to use AI now. Here's what real AI-powered local growth intelligence actually looks like — and how to evaluate whether a tool is genuinely helpful or just marketing noise.": {
    "fr": "De nombreux outils SaaS revendiquent l’IA. Découvrez ce que peut apporter l’analyse de croissance locale et comment distinguer l’utilité réelle du discours commercial.",
    "ar": "تدّعي أدوات SaaS اليوم استخدام الذكاء الاصطناعي. تعرّف على شكل التحليل الفعلي للنمو المحلي وكيف تميز الأداة المفيدة من الضجيج التسويقي."
  },
  "Every feature should make your decision simpler, not add another thing to learn. We obsess over making difficult intelligence feel effortless.": {
    "fr": "Chaque fonctionnalité doit simplifier vos décisions sans ajouter de complexité. Nous travaillons à rendre l’analyse facile à utiliser.",
    "ar": "ينبغي لكل ميزة أن تبسط قرارك دون أن تضيف عبئًا جديدًا للتعلم. نعمل على جعل التحليلات المعقدة سهلة الاستخدام."
  },
  "Exact provider capabilities can vary by API, account eligibility, region, permissions and policy.": {
    "fr": "Les capacités exactes varient selon l’API, l’éligibilité du compte, la région, les autorisations et les règles du fournisseur.",
    "ar": "قد تختلف إمكانات المزود الفعلية حسب واجهة API وأهلية الحساب والمنطقة والأذونات والسياسات."
  },
  "Example signal: weekend dinner visibility is lower than the comparison period. Review opening hours and supported performance context before deciding whether an update is appropriate.": {
    "fr": "Exemple : la visibilité des dîners du week-end baisse par rapport à la période comparée. Vérifiez les horaires et les performances disponibles avant de décider d’une mise à jour.",
    "ar": "مؤشر توضيحي: انخفض ظهور عشاء نهاية الأسبوع مقارنة بالفترة المرجعية. راجع ساعات العمل وسياق الأداء المدعوم قبل تقرير الحاجة إلى تحديث."
  },
  "Follow supported keyword and local-search signals relevant to the clinic specialty and location.": {
    "fr": "Suivez les mots-clés et signaux de recherche locale disponibles pour la spécialité et l’emplacement de la clinique.",
    "ar": "تابع مؤشرات الكلمات المفتاحية والبحث المحلي المدعومة ذات الصلة بتخصص العيادة وموقعها."
  },
  "Follow supported keyword and local-search signals relevant to the store category and location.": {
    "fr": "Suivez les mots-clés et signaux de recherche locale disponibles pour la catégorie et l’emplacement du magasin.",
    "ar": "تابع مؤشرات الكلمات المفتاحية والبحث المحلي المدعومة ذات الصلة بفئة المتجر وموقعه."
  },
  "Follow supported keyword signals and connect meaningful changes to local performance history.": {
    "fr": "Suivez les mots-clés disponibles et reliez leurs changements notables à l’historique des performances locales.",
    "ar": "تابع مؤشرات الكلمات المفتاحية المدعومة واربط التغيرات المهمة بسجل الأداء المحلي."
  },
  "Follow supported local keyword signals relevant to the services and location you operate.": {
    "fr": "Suivez les signaux de mots-clés locaux disponibles pour vos services et votre établissement.",
    "ar": "تابع مؤشرات الكلمات المفتاحية المحلية المدعومة ذات الصلة بخدماتك وموقع عملك."
  },
  "Follow supported local-search and keyword signals relevant to the property and destination context.": {
    "fr": "Suivez les signaux de recherche locale et les mots-clés disponibles pour l’établissement et sa destination.",
    "ar": "تابع مؤشرات البحث المحلي والكلمات المفتاحية المدعومة ذات الصلة بالمنشأة والوجهة."
  },
  "For healthcare practices and clinics, trust is the primary conversion driver. Patients read reviews, check visibility, and compare providers before booking their first appointment. Optrixis Local helps you build and protect the digital reputation that converts search into patients.": {
    "fr": "Pour les cabinets et cliniques, la confiance guide la prise de rendez-vous. Les patients lisent les avis, recherchent et comparent. Optrixis Local aide à bâtir et protéger la réputation numérique qui transforme ces recherches en consultations.",
    "ar": "الثقة عامل أساسي لحجز المواعيد في العيادات والمراكز الصحية. يقرأ المرضى التقييمات ويبحثون ويقارنون قبل موعدهم الأول. تساعدك Optrixis Local على بناء السمعة الرقمية التي تحول البحث إلى زيارات وحمايتها."
  },
  "For restaurants, local discovery and reputation matter. OPTRIXIS LOCAL brings supported review, Google performance and priority signals into one operating context so teams can see what changed and what deserves attention.": {
    "fr": "Pour les restaurants, la découverte locale et la réputation comptent. OPTRIXIS LOCAL réunit les avis, performances Google et priorités disponibles pour montrer aux équipes ce qui change et mérite leur attention.",
    "ar": "الاكتشاف المحلي والسمعة مهمان للمطاعم. تجمع OPTRIXIS LOCAL مؤشرات التقييمات وأداء Google والأولويات المدعومة في سياق عمل واحد لترى الفرق ما تغير وما يستحق الاهتمام."
  },
  "For salons and spas, trust is everything. Clients are putting their appearance in your hands — they research carefully before booking. Optrixis Local helps you build and maintain the online reputation that converts browsers into loyal clients.": {
    "fr": "Pour les salons et spas, la confiance est essentielle. Les clients vous confient leur apparence et se renseignent avant de réserver. Optrixis Local aide à construire la réputation en ligne qui les fidélise.",
    "ar": "الثقة أساسية للصالونات والمنتجعات الصحية. يأتمنك العملاء على مظهرهم ويبحثون بعناية قبل الحجز. تساعدك Optrixis Local على بناء السمعة عبر الإنترنت والحفاظ عليها لتحويل الباحثين إلى عملاء أوفياء."
  },
  "Generate response drafts for operator review, editing and controlled publishing where the provider permits it.": {
    "fr": "Générez des brouillons que l’opérateur vérifie et modifie avant publication encadrée, lorsque le fournisseur l’autorise.",
    "ar": "أنشئ مسودات ردود ليراجعها المسؤول ويعدلها وينشرها ضمن الضوابط حيث يسمح المزود."
  },
  "Google Business Profile information that may require periodic operator verification": {
    "fr": "Informations Google Business Profile pouvant nécessiter une vérification périodique de l’opérateur",
    "ar": "معلومات Google Business Profile التي قد تتطلب تحققًا دوريًا من المسؤول"
  },
  "Google Business Profile is the core V1 review provider workflow, subject to provider access and policy.": {
    "fr": "Google Business Profile est le principal parcours d’avis de la V1, selon les accès et règles du fournisseur.",
    "ar": "Google Business Profile هو سير عمل مزود التقييمات الأساسي في V1، وفق الوصول وسياسة المزود."
  },
  "Google Business Profile is the core V1 review workflow, with AI-assisted context and operator-controlled responses.": {
    "fr": "Google Business Profile est le principal parcours d’avis de la V1, avec contexte IA et réponses contrôlées par l’opérateur.",
    "ar": "Google Business Profile هو سير عمل التقييمات الأساسي في V1، مع سياق بالذكاء الاصطناعي وردود بتحكم المسؤول."
  },
  "Google Business Profile is the core V1 review workflow, with AI-assisted response drafting and operator control.": {
    "fr": "Google Business Profile est le principal parcours d’avis de la V1, avec rédaction assistée par IA sous contrôle de l’opérateur.",
    "ar": "Google Business Profile هو سير عمل التقييمات الأساسي في V1، مع صياغة ردود بالذكاء الاصطناعي وتحكم المسؤول."
  },
  "Health checks, deployment preflights, backups and recovery procedures are part of the operating model. No public uptime guarantee is claimed here.": {
    "fr": "Les contrôles de disponibilité, vérifications avant déploiement, sauvegardes et procédures de reprise font partie de l’exploitation. Aucune garantie publique de disponibilité n’est annoncée ici.",
    "ar": "فحوص سلامة التشغيل والتحقق قبل الإطلاق والنسخ الاحتياطية وإجراءات الاستعادة جزء من نموذج التشغيل. لا يُدعى هنا تقديم ضمان عام لوقت التشغيل."
  },
  "How supported local signals evolve over time so changes are not read in isolation.": {
    "fr": "L’évolution des signaux locaux disponibles pour interpréter les changements dans leur contexte.",
    "ar": "كيف تتطور المؤشرات المحلية المدعومة عبر الزمن لئلا تُقرأ التغيرات بمعزل عن سياقها."
  },
  "How you respond to reviews — especially negative ones — is an important part of local reputation management. A practical framework for writing useful, brand-aware responses without treating every review the same.": {
    "fr": "La réponse aux avis, surtout négatifs, compte dans la réputation locale. Un cadre pratique pour rédiger des réponses utiles, adaptées à votre marque et à chaque avis.",
    "ar": "طريقة الرد على التقييمات، خاصة السلبية، جزء مهم من إدارة السمعة المحلية. إطار عملي لردود مفيدة تراعي العلامة دون التعامل مع جميع التقييمات بالطريقة نفسها."
  },
  "Identify which aspects of your salon — atmosphere, skill, pricing — drive the strongest positive sentiment.": {
    "fr": "Identifiez les aspects de votre salon — ambiance, savoir-faire, tarifs — qui suscitent les avis les plus positifs.",
    "ar": "حدد جوانب صالونك، من الأجواء والمهارة والأسعار، التي تولد أقوى المشاعر الإيجابية."
  },
  "Improve how your business appears when local customers search for what you offer across supported discovery surfaces.": {
    "fr": "Améliorez la présentation de votre entreprise lorsque les clients locaux recherchent vos services sur les canaux pris en charge.",
    "ar": "حسّن ظهور نشاطك عندما يبحث العملاء المحليون عن عروضك عبر قنوات الاكتشاف المدعومة."
  },
  "In 30 minutes, we'll show you how Optrixis Local can transform the way you understand and grow your local presence. Personalized to your business type and goals.": {
    "fr": "En 30 minutes, découvrez comment Optrixis Local peut améliorer votre compréhension et votre développement local, selon votre activité et vos objectifs.",
    "ar": "خلال 30 دقيقة، نريك كيف يمكن لـ Optrixis Local تغيير طريقة فهم حضورك المحلي وتنميته، بما يناسب نوع نشاطك وأهدافك."
  },
  "In a world where clients choose their salon based on online reviews and how easily you appear in Maps, your digital reputation is your most important front-of-house.": {
    "fr": "Les clients choisissent leur salon grâce aux avis et à sa visibilité sur Maps. Votre réputation numérique est votre première vitrine.",
    "ar": "حين يختار العملاء صالونهم بناءً على التقييمات وسهولة ظهوره في الخرائط، تصبح سمعتك الرقمية أهم واجهة لاستقبالهم."
  },
  "In hospitality, online reputation and local discovery matter. OPTRIXIS LOCAL connects supported review, Google performance and priority signals so operators can understand what changed and what deserves attention.": {
    "fr": "Dans l’hébergement, la réputation et la découverte locale comptent. OPTRIXIS LOCAL relie avis, performances Google et priorités disponibles pour comprendre les changements et les actions utiles.",
    "ar": "في الضيافة، تهم السمعة عبر الإنترنت والاكتشاف المحلي. تربط OPTRIXIS LOCAL مؤشرات التقييمات وأداء Google والأولويات المدعومة لفهم ما تغير وما يستحق الاهتمام."
  },
  "Industry-specific context. Workflows that reflect how different local businesses manage reputation, visibility and priority actions.": {
    "fr": "Un contexte propre à chaque secteur. Des processus adaptés à la gestion de la réputation, de la visibilité et des priorités des entreprises locales.",
    "ar": "سياق خاص بكل قطاع، وسير عمل يعكس كيفية إدارة الأنشطة المحلية المختلفة للسمعة والظهور وإجراءات الأولوية."
  },
  "Industry-specific intelligence. Sector-aware benchmarks. Insights that fit how your business actually works.": {
    "fr": "Une intelligence et des repères sectoriels. Des analyses adaptées au fonctionnement réel de votre activité.",
    "ar": "تحليل ذكي خاص بالقطاع ومعايير تراعيه ورؤى تناسب طريقة عمل نشاطك الفعلية."
  },
  "Information is most useful when it helps an operator decide what to do next.": {
    "fr": "L’information est surtout utile lorsqu’elle aide l’opérateur à choisir sa prochaine action.",
    "ar": "تكون المعلومات أكثر فائدة عندما تساعد المسؤول على اختيار خطوته التالية."
  },
  "Keep review activity and derived intelligence in context over time within compliant retention rules.": {
    "fr": "Conservez le contexte des avis et des analyses dans le temps, selon les règles de conservation applicables.",
    "ar": "احتفظ بنشاط التقييمات والتحليلات الناتجة ضمن سياقها عبر الزمن وفق قواعد الاحتفاظ المعمول بها."
  },
  "Keep supported local changes visible over time instead of interpreting a single snapshot in isolation.": {
    "fr": "Suivez les changements locaux disponibles dans le temps pour dépasser une lecture isolée.",
    "ar": "تابع التغيرات المحلية المدعومة عبر الزمن بدل تفسير لقطة واحدة بمعزل عن السياق."
  },
  "Keep supported local signals visible over time so changes can be interpreted with context.": {
    "fr": "Gardez les signaux locaux disponibles dans le temps pour interpréter les changements avec leur contexte.",
    "ar": "أبقِ المؤشرات المحلية المدعومة ظاهرة عبر الزمن لتفسير التغيرات ضمن سياقها."
  },
  "Keep supported local-search changes visible over time instead of interpreting one snapshot in isolation.": {
    "fr": "Suivez les changements de recherche locale dans le temps plutôt qu’une seule image isolée.",
    "ar": "تابع تغيرات البحث المحلي المدعومة عبر الزمن بدل تفسير لقطة واحدة منفردة."
  },
  "Keep supported profile information and meaningful changes visible for operator review.": {
    "fr": "Gardez les informations de profil et leurs changements significatifs visibles pour l’opérateur.",
    "ar": "أبقِ معلومات الملف المدعومة والتغيرات المهمة ظاهرة لمراجعة المسؤول."
  },
  "Keep supported profile information and meaningful changes visible for operator verification.": {
    "fr": "Gardez les informations de profil et leurs changements significatifs visibles pour vérification par l’opérateur.",
    "ar": "أبقِ معلومات الملف المدعومة والتغيرات المهمة ظاهرة ليتحقق منها المسؤول."
  },
  "Keep supported reputation, local-search and profile context visible with human-controlled workflows.": {
    "fr": "Gardez le contexte de réputation, de recherche locale et de profil visible dans des processus sous contrôle humain.",
    "ar": "أبقِ سياق السمعة والبحث المحلي والملف المدعوم ظاهرًا ضمن سير عمل بتحكم بشري."
  },
  "Keeping supported Google Business Profile information under periodic operator review": {
    "fr": "Vérification périodique des informations Google Business Profile disponibles par l’opérateur",
    "ar": "إبقاء معلومات Google Business Profile المدعومة تحت مراجعة دورية من المسؤول"
  },
  "Know what changed. Know what matters. Know what to do next. One unified workspace for every signal that drives local growth.": {
    "fr": "Comprenez ce qui change, ce qui compte et quoi faire ensuite. Un espace unifié pour tous les signaux de croissance locale.",
    "ar": "اعرف ما تغير وما يهم وما ينبغي فعله بعد ذلك. مساحة موحدة لكل مؤشر يدفع النمو المحلي."
  },
  "Know your response rate and response time, and keep unanswered reviews visible before they become forgotten work.": {
    "fr": "Suivez votre taux et votre délai de réponse, et gardez les avis sans réponse visibles pour ne pas les oublier.",
    "ar": "اعرف معدل ردودك ووقتها، وأبقِ التقييمات بلا إجابة ظاهرة قبل أن تُنسى."
  },
  "Local business signals often live in separate places. OPTRIXIS LOCAL brings supported reputation, performance, priority and AI-assisted context into one operating view.": {
    "fr": "Les signaux d’une entreprise locale sont souvent dispersés. OPTRIXIS LOCAL réunit réputation, performances, priorités et contexte assisté par IA dans une même vue.",
    "ar": "غالبًا ما تتوزع مؤشرات النشاط المحلي في أماكن منفصلة. تجمع OPTRIXIS LOCAL السمعة والأداء والأولويات المدعومة والسياق بالذكاء الاصطناعي في واجهة عمل واحدة."
  },
  "Local businesses are the backbone of every community. They are resilient, resourceful operators — and they deserve clearer intelligence without enterprise-level complexity.": {
    "fr": "Les entreprises locales font vivre les communautés. Leurs équipes sont résilientes et inventives ; elles méritent des analyses claires, sans la complexité des grandes organisations.",
    "ar": "الأنشطة المحلية أساس كل مجتمع. يديرها أشخاص مرنون وواسعو الحيلة، ويستحقون تحليلات أوضح دون تعقيد أنظمة المؤسسات الكبرى."
  },
  "Local growth signals are spread across reviews, discovery, social and customer channels. Optrixis Local brings them into one operating view so teams can understand what changed and what deserves attention next.": {
    "fr": "Les signaux de croissance locale sont dispersés entre avis, découverte, réseaux sociaux et canaux clients. Optrixis Local les réunit pour comprendre les changements et choisir les prochaines priorités.",
    "ar": "تتوزع مؤشرات النمو المحلي بين التقييمات والاكتشاف والقنوات الاجتماعية وقنوات العملاء. تجمعها Optrixis Local لتفهم الفرق ما تغير وما يستحق الاهتمام التالي."
  },
  "Local retail depends on discoverability and trust. OPTRIXIS LOCAL connects supported Google performance, reputation and priority signals around one store location so teams can act with clearer context.": {
    "fr": "Le commerce local repose sur la visibilité et la confiance. OPTRIXIS LOCAL relie les performances Google, la réputation et les priorités disponibles autour d’un magasin pour éclairer les actions.",
    "ar": "تعتمد تجارة التجزئة المحلية على سهولة الاكتشاف والثقة. تربط OPTRIXIS LOCAL مؤشرات أداء Google والسمعة والأولويات المدعومة حول متجر واحد لتتصرف الفرق بسياق أوضح."
  },
  "Local-search changes that are difficult to interpret without supporting history": {
    "fr": "Des changements de recherche locale difficiles à comprendre sans historique",
    "ar": "تغيرات البحث المحلي التي يصعب تفسيرها دون سجل داعم"
  },
  "Managing reputation across multiple provider profiles at a single practice": {
    "fr": "Gérer la réputation sur plusieurs profils fournisseurs pour un même cabinet",
    "ar": "إدارة السمعة عبر ملفات مزودين متعددة لعيادة واحدة"
  },
  "Managing reviews that affect whether shoppers choose you over the next store": {
    "fr": "Gérer les avis qui influencent le choix des clients entre votre magasin et un autre",
    "ar": "إدارة التقييمات التي تؤثر في اختيار المتسوقين لمتجرك بدل المتجر المجاور"
  },
  "Meaningful supported reputation and performance signals can become ranked Priority Actions.": {
    "fr": "Les signaux pertinents de réputation et de performance peuvent devenir des actions prioritaires classées.",
    "ar": "يمكن أن تتحول مؤشرات السمعة والأداء المدعومة والمهمة إلى إجراءات أولوية مرتبة."
  },
  "Meaningful supported signals can feed the Priority Actions engine when configured thresholds are crossed.": {
    "fr": "Les signaux pertinents peuvent alimenter les actions prioritaires lorsqu’ils franchissent les seuils configurés.",
    "ar": "يمكن للمؤشرات المدعومة المهمة تغذية محرك إجراءات الأولوية عند تجاوز الحدود المضبوطة."
  },
  "Monitor supported review activity and response work over time for the salon location.": {
    "fr": "Suivez les avis et les réponses disponibles dans le temps pour votre salon.",
    "ar": "تابع نشاط التقييمات والردود المدعوم عبر الزمن لموقع الصالون."
  },
  "Most business owners don't realize their rankings are slipping until a competitor has taken their position. Here's how to audit and reclaim your local visibility before it costs you customers.": {
    "fr": "Beaucoup de dirigeants découvrent une baisse de classement après avoir perdu leur place face à un concurrent. Voici comment examiner et reconquérir votre visibilité locale avant de perdre des clients.",
    "ar": "لا يلاحظ كثير من أصحاب الأعمال تراجع ترتيبهم حتى يأخذ منافس مكانهم. تعرّف على كيفية فحص ظهورك المحلي واستعادته قبل خسارة العملاء."
  },
  "Most local businesses have a Google Business Profile. Very few have an optimized one. The gap between the two costs real money every single month.": {
    "fr": "La plupart des entreprises locales ont une fiche Google Business Profile, mais peu l’optimisent. Cet écart peut avoir un coût chaque mois.",
    "ar": "لدى معظم الأنشطة المحلية ملف Google Business Profile، لكن القليل منها يحسّنه. والفجوة بين الحالتين تكلف مالًا كل شهر."
  },
  "Nine provider channels designed around one V1 local-growth ecosystem.": {
    "fr": "Neuf canaux fournisseurs réunis dans un écosystème V1 de croissance locale.",
    "ar": "تسع قنوات لمزودي الخدمات ضمن منظومة V1 واحدة للنمو المحلي."
  },
  "No single history-aware view connecting reputation and local-performance changes": {
    "fr": "Aucune vue historique unifiée reliant réputation et variations des performances locales",
    "ar": "غياب عرض موحد يستند إلى السجل ويربط السمعة بتغيرات الأداء المحلي"
  },
  "No single history-aware view connecting reputation and local-performance signals": {
    "fr": "Aucune vue historique unifiée reliant réputation et signaux de performance locale",
    "ar": "غياب عرض موحد يستند إلى السجل ويربط السمعة بمؤشرات الأداء المحلي"
  },
  "No single history-aware view connecting reputation and supported local-performance signals": {
    "fr": "Aucune vue historique unifiée reliant réputation et performances locales disponibles",
    "ar": "غياب عرض موحد يستند إلى السجل ويربط السمعة بمؤشرات الأداء المحلي المدعومة"
  },
  "No single view connecting supported discovery activity and local-performance history": {
    "fr": "Aucune vue unifiée reliant découverte disponible et historique des performances locales",
    "ar": "غياب عرض موحد يربط نشاط الاكتشاف المدعوم بسجل الأداء المحلي"
  },
  "No specialist technical background is required. The guided onboarding is designed for business owners and managers, with connection steps and status feedback inside the product.": {
    "fr": "Aucune expertise technique n’est nécessaire. La configuration guidée s’adresse aux dirigeants et responsables, avec des étapes de connexion et des indications d’état dans le produit.",
    "ar": "لا تتطلب معرفة تقنية متخصصة. صُمم الإعداد الموجه لأصحاب الأعمال والمديرين، مع خطوات ربط ومعلومات حالة داخل المنتج."
  },
  "No vanity metrics and no inflated claims. Supported signals stay connected to their source and context.": {
    "fr": "Pas d’indicateurs flatteurs ni de promesses exagérées. Les signaux restent reliés à leur source et à leur contexte.",
    "ar": "لا مقاييس شكلية ولا ادعاءات مبالغ فيها. تبقى المؤشرات المدعومة مرتبطة بمصدرها وسياقها."
  },
  "None whatsoever. Optrixis Local is designed for business owners and managers, not technical teams. If you can log in to your provider accounts, you can use Optrixis Local.": {
    "fr": "Aucune. Optrixis Local est conçu pour les dirigeants et responsables. Si vous savez vous connecter à vos comptes fournisseurs, vous pouvez l’utiliser.",
    "ar": "لا حاجة لذلك. صُممت Optrixis Local لأصحاب الأعمال والمديرين. إذا كنت تستطيع تسجيل الدخول إلى حسابات مزوديك، يمكنك استخدامها."
  },
  "Not appearing in Google Maps when potential customers search for your product category": {
    "fr": "Ne pas apparaître dans Google Maps lorsque des clients cherchent votre catégorie de produits",
    "ar": "عدم الظهور في خرائط Google عندما يبحث العملاء المحتملون عن فئة منتجاتك"
  },
  "Not appearing when patients search for your specialty in your area": {
    "fr": "Ne pas apparaître lorsque des patients cherchent votre spécialité dans votre secteur",
    "ar": "عدم الظهور عندما يبحث المرضى عن تخصصك في منطقتك"
  },
  "Not appearing when potential clients search 'best hair salon near me' or 'balayage [city]'": {
    "fr": "Ne pas apparaître lorsque des clients cherchent « meilleur coiffeur à proximité » ou « balayage [ville] »",
    "ar": "عدم الظهور عندما يبحث العملاء عن «أفضل صالون شعر بالقرب مني» أو «بالياج [المدينة]»"
  },
  "Not at all. Optrixis Local is designed for business owners and managers, not technical teams. Guided onboarding keeps provider connection and setup steps clear inside the product.": {
    "fr": "Pas du tout. Optrixis Local s’adresse aux dirigeants et responsables. La configuration guidée clarifie les connexions fournisseurs et les étapes de mise en place.",
    "ar": "لا. صُممت Optrixis Local لأصحاب الأعمال والمديرين. يجعل الإعداد الموجه ربط المزودين وخطوات الإعداد واضحة داخل المنتج."
  },
  "Not just dashboards. Optrixis AI interprets supported local signals, explains patterns in context, and helps surface what deserves attention next.": {
    "fr": "Optrixis AI va au-delà des tableaux de bord : il interprète les signaux locaux disponibles, explique les tendances dans leur contexte et fait ressortir les prochaines priorités.",
    "ar": "تتجاوز Optrixis AI لوحات المعلومات: تفسر المؤشرات المحلية المدعومة وتشرح الأنماط ضمن سياقها وتساعد على إبراز ما يستحق الاهتمام التالي."
  },
  "Not knowing which supported search and keyword signals are changing around your location": {
    "fr": "Ne pas savoir quels signaux de recherche et de mots-clés évoluent autour de votre établissement",
    "ar": "عدم معرفة مؤشرات البحث والكلمات المفتاحية المدعومة التي تتغير حول موقعك"
  },
  "OPTRIXIS LOCAL does not position customer business data as an advertising product. Data handling follows the published privacy policy and necessary service-provider relationships.": {
    "fr": "OPTRIXIS LOCAL ne traite pas les données des entreprises clientes comme un produit publicitaire. Leur gestion suit la politique de confidentialité et les relations nécessaires avec les prestataires.",
    "ar": "لا تتعامل OPTRIXIS LOCAL مع بيانات نشاط العميل كمنتج إعلاني. تتبع معالجة البيانات سياسة الخصوصية المنشورة والعلاقات اللازمة مع مزودي الخدمات."
  },
  "Onboarding is guided step by step. Provider connections are handled inside the product with clear authorization and status feedback.": {
    "fr": "La configuration est guidée étape par étape. Les connexions fournisseurs se font dans le produit avec des autorisations et des indications d’état claires.",
    "ar": "الإعداد موجه خطوة بخطوة. تُدار اتصالات المزودين داخل المنتج مع تفويض واضح ومعلومات عن الحالة."
  },
  "One V1 ecosystem around the channels that shape local growth.": {
    "fr": "Un écosystème V1 autour des canaux qui façonnent la croissance locale.",
    "ar": "منظومة V1 واحدة حول القنوات التي تشكل النمو المحلي."
  },
  "Optrixis AI adds context to supported reputation, visibility and performance signals and explains relevant changes.": {
    "fr": "Optrixis AI donne du contexte aux signaux de réputation, de visibilité et de performance disponibles et explique les changements pertinents.",
    "ar": "تضيف Optrixis AI سياقًا لمؤشرات السمعة والظهور والأداء المدعومة وتشرح التغيرات ذات الصلة."
  },
  "Optrixis AI adds context to supported reputation, visibility and performance signals, then helps surface priority actions while keeping controlled actions behind appropriate approval boundaries.": {
    "fr": "Optrixis AI contextualise les signaux disponibles et fait ressortir les priorités, tout en maintenant les actions encadrées sous les approbations nécessaires.",
    "ar": "تضيف Optrixis AI سياقًا لمؤشرات السمعة والظهور والأداء المدعومة ثم تبرز الأولويات، مع إبقاء الإجراءات المنضبطة ضمن حدود الموافقة المناسبة."
  },
  "Optrixis AI can draft response suggestions for operator review, editing and controlled publishing where the provider permits it.": {
    "fr": "Optrixis AI peut proposer des brouillons que l’opérateur vérifie et modifie avant publication encadrée, lorsque le fournisseur l’autorise.",
    "ar": "يمكن لـ Optrixis AI صياغة اقتراحات ردود لمراجعة المسؤول وتعديلها ونشرها ضمن الضوابط حيث يسمح المزود."
  },
  "Optrixis AI explains supported patterns and recommendations while keeping important actions under operator control.": {
    "fr": "Optrixis AI explique les tendances et recommandations disponibles, tout en laissant les actions importantes sous contrôle de l’opérateur.",
    "ar": "تشرح Optrixis AI الأنماط والتوصيات المدعومة مع إبقاء الإجراءات المهمة تحت تحكم المسؤول."
  },
  "Optrixis AI interprets supported local signals, explains meaningful changes in plain language, and helps surface the next decision while keeping important actions under human control.": {
    "fr": "Optrixis AI interprète les signaux locaux disponibles, explique les changements en langage clair et aide à préparer la prochaine décision, sous contrôle humain.",
    "ar": "تفسر Optrixis AI المؤشرات المحلية المدعومة وتشرح التغيرات المهمة بلغة واضحة وتساعد في إبراز القرار التالي مع إبقاء الإجراءات المهمة تحت التحكم البشري."
  },
  "Optrixis AI interprets supported signals, adds context to meaningful changes, and helps operators understand what may deserve attention next.": {
    "fr": "Optrixis AI interprète les signaux disponibles, contextualise les changements et aide les opérateurs à identifier ce qui mérite leur attention.",
    "ar": "تفسر Optrixis AI المؤشرات المدعومة وتضيف سياقًا للتغيرات المهمة وتساعد المسؤولين على فهم ما قد يستحق الاهتمام التالي."
  },
  "Optrixis Local is built around real physical business locations — not seat counts, not platform connections. V1 provider channels around that business are": {
    "fr": "Optrixis Local est conçu autour d’établissements physiques réels. Les canaux fournisseurs V1 de cette entreprise sont des",
    "ar": "تُبنى Optrixis Local حول مواقع فعلية حقيقية للنشاط التجاري، لا عدد المقاعد أو اتصالات المنصات. قنوات المزودين في V1 حول ذلك النشاط هي"
  },
  "Optrixis Local turns supported reputation, local-performance and priority signals into a clearer operating context with AI assistance and human control.": {
    "fr": "Optrixis Local transforme les signaux disponibles de réputation, de performance locale et de priorité en un contexte de pilotage plus clair, avec l’aide de l’IA et sous contrôle humain.",
    "ar": "تحول Optrixis Local مؤشرات السمعة والأداء المحلي والأولويات المدعومة إلى سياق عمل أوضح بمساعدة الذكاء الاصطناعي والتحكم البشري."
  },
  "Optrixis Local unifies your visibility, reputation, customer signals, and AI intelligence into a single, elegant command center designed for local business owners and operators.": {
    "fr": "Optrixis Local réunit votre visibilité, votre réputation, les signaux clients et l’analyse IA dans un espace de pilotage conçu pour les dirigeants et opérateurs locaux.",
    "ar": "تجمع Optrixis Local ظهورك وسمعتك ومؤشرات عملائك وتحليلات الذكاء الاصطناعي في مركز قيادة واحد مصمم لأصحاب الأنشطة المحلية والقائمين عليها."
  },
  "Optrixis Local was built for local operators who need clearer answers about reputation, visibility and what deserves attention next — without enterprise-level complexity.": {
    "fr": "Optrixis Local s’adresse aux opérateurs locaux qui veulent des réponses claires sur leur réputation, leur visibilité et leurs priorités, sans complexité excessive.",
    "ar": "صُممت Optrixis Local للقائمين على الأنشطة المحلية الذين يحتاجون إجابات أوضح عن السمعة والظهور وما يستحق الاهتمام التالي، دون تعقيد أنظمة المؤسسات الكبرى."
  },
  "Part of the OPTRIXIS LOCAL V1 integration suite. Capabilities can vary by provider API, account eligibility, region and permissions.": {
    "fr": "Intégré au périmètre V1 d’OPTRIXIS LOCAL. Les capacités varient selon l’API, l’éligibilité du compte, la région et les autorisations.",
    "ar": "جزء من مجموعة تكامل OPTRIXIS LOCAL V1. قد تختلف الإمكانات حسب API المزود وأهلية الحساب والمنطقة والأذونات."
  },
  "Part of the OPTRIXIS LOCAL V1 integration suite. Provider approval, permissions and policy apply.": {
    "fr": "Intégré au périmètre V1 d’OPTRIXIS LOCAL, sous réserve de l’approbation, des autorisations et des règles du fournisseur.",
    "ar": "جزء من مجموعة تكامل OPTRIXIS LOCAL V1، وفق موافقة المزود وأذوناته وسياساته."
  },
  "Patients research healthcare choices carefully. Your online reputation is an important trust signal — and Optrixis Local helps you understand the supported signals around your practice.": {
    "fr": "Les patients étudient attentivement leurs choix de santé. Votre réputation en ligne est un signal de confiance ; Optrixis Local aide à comprendre les signaux disponibles autour du cabinet.",
    "ar": "يبحث المرضى بعناية في خيارات الرعاية الصحية. سمعتك عبر الإنترنت مؤشر مهم للثقة، وتساعدك Optrixis Local على فهم المؤشرات المدعومة حول عيادتك."
  },
  "Patients using Google reviews and local discovery signals when evaluating nearby providers": {
    "fr": "Des patients qui consultent les avis Google et les résultats locaux pour comparer les praticiens proches",
    "ar": "مرضى يستخدمون تقييمات Google ومؤشرات الاكتشاف المحلي لتقييم مقدمي الرعاية القريبين"
  },
  "Plan changes follow the billing and entitlement rules shown in the application at the time of the change.": {
    "fr": "Les changements d’offre suivent les règles de facturation et de droits affichées dans l’application au moment du changement.",
    "ar": "تتبع تغييرات الخطة قواعد الفوترة والصلاحيات المعروضة في التطبيق وقت التغيير."
  },
  "Potential clients using online reviews and local discovery signals when deciding where to book": {
    "fr": "Des clients potentiels qui s’appuient sur les avis et la découverte locale avant de réserver",
    "ar": "عملاء محتملون يستخدمون التقييمات عبر الإنترنت ومؤشرات الاكتشاف المحلي لاختيار مكان الحجز"
  },
  "Priority Actions help rank what deserves attention using supported signals and defined impact rules.": {
    "fr": "Les actions prioritaires classent ce qui mérite l’attention selon les signaux disponibles et des règles d’impact définies.",
    "ar": "تساعد إجراءات الأولوية على ترتيب ما يستحق الاهتمام باستخدام المؤشرات المدعومة وقواعد أثر محددة."
  },
  "Priority Actions surfaces critical, high-impact and recommended work so the operator can decide what to do next.": {
    "fr": "Les actions prioritaires présentent le travail critique, à fort impact et recommandé pour que l’opérateur choisisse la suite.",
    "ar": "تبرز إجراءات الأولوية الأعمال الحرجة وذات الأثر الكبير والموصى بها ليختار المسؤول خطوته التالية."
  },
  "Production traffic and secrets are handled through controlled runtime configuration, HTTPS boundaries and least-exposure operational practices.": {
    "fr": "Le trafic et les secrets de production sont gérés par une configuration contrôlée, HTTPS et des pratiques limitant leur exposition.",
    "ar": "تُدار حركة الإنتاج والأسرار عبر إعداد تشغيل منضبط وحدود HTTPS وممارسات تقلل الانكشاف."
  },
  "Provider channels are associated with the same physical business location — they are not separate locations. OPTRIXIS LOCAL connects supported V1 provider capabilities around that location, subject to each provider's API, permissions and policy.": {
    "fr": "Les canaux fournisseurs sont associés au même établissement physique. OPTRIXIS LOCAL y connecte les capacités V1 disponibles, selon les API, autorisations et règles de chaque fournisseur.",
    "ar": "ترتبط قنوات المزودين بالموقع الفعلي نفسه للنشاط وليست مواقع منفصلة. تربط OPTRIXIS LOCAL إمكانات V1 المدعومة حوله وفق API كل مزود وأذوناته وسياساته."
  },
  "Provider-aware rollout": {
    "fr": "Déploiement adapté aux fournisseurs",
    "ar": "إطلاق يراعي المزودين"
  },
  "Public API access is not advertised as a standard-plan capability today. Enterprise integration requirements are handled through a contact-led scope.": {
    "fr": "L’accès à une API publique n’est pas annoncé dans les offres standard actuelles. Les besoins d’intégration Enterprise sont définis avec notre équipe.",
    "ar": "لا يُعلن حاليًا عن وصول API عام ضمن الخطط القياسية. تُحدد متطلبات تكامل Enterprise بالتواصل مع فريقنا."
  },
  "Published privacy and data-deletion paths explain available export, disconnect and deletion requests and the constraints that may apply.": {
    "fr": "Les procédures publiées de confidentialité et de suppression expliquent les demandes d’export, de déconnexion et de suppression possibles, ainsi que leurs limites.",
    "ar": "توضح مسارات الخصوصية وحذف البيانات المنشورة طلبات التصدير والفصل والحذف المتاحة والقيود المحتملة."
  },
  "Published privacy and deletion processes define how connected data can be disconnected, exported or deleted under applicable rules.": {
    "fr": "Les procédures publiées définissent comment déconnecter, exporter ou supprimer les données liées selon les règles applicables.",
    "ar": "تحدد إجراءات الخصوصية والحذف المنشورة كيفية فصل البيانات المتصلة أو تصديرها أو حذفها وفق القواعد المعمول بها."
  },
  "Questions about Optrixis Local? Want to partner, integrate, or explore enterprise solutions? We'd love to talk.": {
    "fr": "Une question sur Optrixis Local ? Un partenariat, une intégration ou un projet Enterprise ? Parlons-en.",
    "ar": "هل لديك أسئلة عن Optrixis Local أو ترغب بشراكة أو تكامل أو حلول للمؤسسات؟ يسعدنا الحديث معك."
  },
  "Relevant local-search signals can feed the Priority Actions engine when they cross configured thresholds.": {
    "fr": "Les signaux de recherche locale pertinents alimentent les actions prioritaires lorsqu’ils franchissent les seuils configurés.",
    "ar": "يمكن لمؤشرات البحث المحلي ذات الصلة تغذية محرك إجراءات الأولوية عند تجاوز الحدود المضبوطة."
  },
  "Request access to the current rollout and confirm the plan that fits your location.": {
    "fr": "Demandez l’accès au déploiement actuel et confirmez l’offre adaptée à votre établissement.",
    "ar": "اطلب الوصول إلى الإطلاق الحالي وأكد الخطة المناسبة لموقعك."
  },
  "Request access to the current rollout, or talk to us about the right plan for your location.": {
    "fr": "Demandez l’accès au déploiement actuel ou contactez-nous pour choisir l’offre de votre établissement.",
    "ar": "اطلب الوصول إلى الإطلاق الحالي أو تحدث معنا عن الخطة المناسبة لموقعك."
  },
  "Review activity and response work living in separate provider workflows": {
    "fr": "Des avis et des réponses gérés séparément chez chaque fournisseur",
    "ar": "نشاط التقييمات والردود الموزع بين مسارات عمل مزودين منفصلة"
  },
  "Review and discovery signals living across separate provider workflows": {
    "fr": "Des avis et des signaux de découverte dispersés entre fournisseurs",
    "ar": "مؤشرات التقييمات والاكتشاف الموزعة عبر مسارات عمل مزودين منفصلة"
  },
  "Review the unanswered reviews that crossed your configured priority rules. I can show the supporting context and draft response suggestions for operator review.": {
    "fr": "Examinez les avis sans réponse qui correspondent à vos règles de priorité. Je peux montrer leur contexte et proposer des brouillons à vérifier.",
    "ar": "راجع التقييمات بلا إجابة التي تجاوزت قواعد الأولوية المضبوطة. يمكنني عرض السياق الداعم واقتراح مسودات ردود ليراجعها المسؤول."
  },
  "Role-aware permissions": {
    "fr": "Autorisations par rôle",
    "ar": "صلاحيات حسب الدور"
  },
  "Role-based permissions, multi-factor authentication for privileged control access, and auditable authorization checks protect sensitive operations.": {
    "fr": "Les autorisations par rôle, l’authentification multifacteur des accès privilégiés et les contrôles auditables protègent les opérations sensibles.",
    "ar": "تحمي العمليات الحساسة صلاحيات حسب الأدوار ومصادقة متعددة العوامل للوصول المميز وفحوص تفويض قابلة للتدقيق."
  },
  "Rollout, location structure and operational requirements are defined with the organization before implementation.": {
    "fr": "Le déploiement, la structure des établissements et les besoins opérationnels sont définis avec l’organisation avant mise en œuvre.",
    "ar": "يُحدد الإطلاق وهيكل المواقع والمتطلبات التشغيلية مع المؤسسة قبل التنفيذ."
  },
  "Salons that dominate locally: what they do differently": {
    "fr": "Les salons qui se démarquent localement : leurs pratiques",
    "ar": "الصالونات المتصدرة محليًا: ما الذي تفعله بشكل مختلف"
  },
  "Seasonal search visibility gaps that cost occupancy during shoulder periods": {
    "fr": "Des lacunes saisonnières de visibilité qui réduisent l’occupation en intersaison",
    "ar": "فجوات موسمية في الظهور بالبحث تقلل الإشغال خارج فترات الذروة"
  },
  "Security is built around tenant isolation, controlled access, auditability, data lifecycle rules and operational safeguards. Provider permissions and sensitive actions remain policy-aware.": {
    "fr": "La sécurité repose sur l’isolation des organisations, les accès encadrés, la traçabilité, le cycle de vie des données et les protections opérationnelles. Les autorisations fournisseurs et actions sensibles respectent les règles applicables.",
    "ar": "يستند الأمان إلى عزل المؤسسات والوصول المنضبط وقابلية التدقيق وقواعد دورة حياة البيانات وحماية التشغيل. تراعي أذونات المزودين والإجراءات الحساسة السياسات."
  },
  "See the score move with its signals.": {
    "fr": "Suivez le score avec ses signaux.",
    "ar": "شاهد النتيجة تتغير مع مؤشراتها."
  },
  "Show me the drafts.": {
    "fr": "Montrez-moi les brouillons.",
    "ar": "أرني المسودات."
  },
  "Slow review responses that signal poor service to potential guests": {
    "fr": "Des réponses tardives aux avis qui donnent une mauvaise impression aux futurs clients",
    "ar": "ردود بطيئة على التقييمات تعطي الضيوف المحتملين انطباعًا بخدمة ضعيفة"
  },
  "Standard workspaces stay centered on one physical clinic location; multi-location organizations are handled through Enterprise.": {
    "fr": "Un espace standard couvre une clinique physique ; les organisations multisites passent par Enterprise.",
    "ar": "تتمحور مساحات العمل القياسية حول موقع عيادة فعلي واحد، وتُدار المؤسسات متعددة المواقع عبر Enterprise."
  },
  "Start understanding your local presence today. No complexity. No long setup. Just clear intelligence and the actions to grow.": {
    "fr": "Comprenez votre présence locale dès aujourd’hui. Une mise en place simple, des analyses claires et des actions pour progresser.",
    "ar": "ابدأ فهم حضورك المحلي اليوم. دون تعقيد أو إعداد طويل، مع تحليلات واضحة وإجراءات للنمو."
  },
  "Start with one physical business location, then connect the supported signals that matter to that location.": {
    "fr": "Commencez par un établissement physique, puis connectez les signaux disponibles qui lui sont utiles.",
    "ar": "ابدأ بموقع فعلي واحد لنشاطك، ثم اربط المؤشرات المدعومة التي تهمه."
  },
  "Start with the channels that matter today and build a clearer picture of your business as your ecosystem grows.": {
    "fr": "Commencez par les canaux utiles aujourd’hui, puis affinez votre compréhension à mesure que votre écosystème grandit.",
    "ar": "ابدأ بالقنوات المهمة اليوم وابنِ صورة أوضح لنشاطك مع نمو منظومتك."
  },
  "Strengthen how your business appears across supported local discovery signals and understand where visibility deserves attention.": {
    "fr": "Renforcez votre présence sur les canaux de découverte locale disponibles et identifiez les points de visibilité à travailler.",
    "ar": "عزز ظهور نشاطك عبر مؤشرات الاكتشاف المحلي المدعومة وافهم أين يحتاج الظهور إلى اهتمام."
  },
  "Support, rollout and service commitments are defined in the Enterprise proposal rather than advertised as a universal public SLA.": {
    "fr": "Les engagements d’assistance, de déploiement et de service sont définis dans la proposition Enterprise, sans SLA public universel.",
    "ar": "تُحدد التزامات الدعم والإطلاق والخدمة في عرض Enterprise بدل إعلان اتفاقية مستوى خدمة عامة موحدة."
  },
  "Supported channels can generate reviews, visibility data and customer signals. OPTRIXIS AI adds context to the data that is actually available and helps surface what deserves attention next.": {
    "fr": "Les canaux pris en charge peuvent produire des avis, de la visibilité et des signaux clients. OPTRIXIS AI contextualise les données réellement disponibles pour faire ressortir les priorités.",
    "ar": "يمكن للقنوات المدعومة إنتاج تقييمات وبيانات ظهور ومؤشرات عملاء. تضيف OPTRIXIS AI سياقًا للبيانات المتاحة فعليًا وتساعد على إبراز الاهتمام التالي."
  },
  "Supported local-search and Google performance signals available for your location.": {
    "fr": "Signaux de recherche locale et de performance Google disponibles pour votre établissement.",
    "ar": "مؤشرات البحث المحلي وأداء Google المدعومة والمتاحة لموقعك."
  },
  "Supported payment methods depend on market and checkout availability. Manual payment methods may also be recorded through controlled internal workflows.": {
    "fr": "Les moyens de paiement dépendent du marché et de la disponibilité du paiement en ligne. Des paiements manuels peuvent aussi être enregistrés via des processus internes contrôlés.",
    "ar": "تعتمد طرق الدفع المدعومة على السوق وتوفر الدفع. ويمكن أيضًا تسجيل طرق دفع يدوية عبر مسارات عمل داخلية منضبطة."
  },
  "Supported profile and performance context available from connected providers and product workflows.": {
    "fr": "Contexte de profil et de performance disponible via les fournisseurs connectés et les processus du produit.",
    "ar": "سياق الملف والأداء المدعوم المتاح من المزودين المتصلين ومسارات عمل المنتج."
  },
  "Supported provider data enters one operating context.": {
    "fr": "Les données fournisseurs disponibles rejoignent un contexte de pilotage commun.",
    "ar": "تدخل بيانات المزودين المدعومة في سياق تشغيل واحد."
  },
  "Supported reputation and local performance signals": {
    "fr": "Signaux de réputation et de performance locale pris en charge",
    "ar": "مؤشرات السمعة والأداء المحلي المدعومة"
  },
  "Supported review quality, response activity and review-intelligence signals available for the location.": {
    "fr": "Signaux disponibles sur la qualité des avis, les réponses et leur analyse pour l’établissement.",
    "ar": "مؤشرات جودة التقييمات ونشاط الردود وتحليل التقييمات المدعومة المتاحة للموقع."
  },
  "Supported signal changes can be summarized in clearer language with the underlying context kept visible.": {
    "fr": "Les changements des signaux disponibles peuvent être résumés clairement tout en conservant leur contexte visible.",
    "ar": "يمكن تلخيص تغيرات المؤشرات المدعومة بلغة أوضح مع إبقاء السياق الأساسي ظاهرًا."
  },
  "Surface supported Google Business Profile information and changes that may deserve operator verification.": {
    "fr": "Présentez les informations Google Business Profile disponibles et les changements à vérifier par l’opérateur.",
    "ar": "أبرز معلومات Google Business Profile المدعومة والتغيرات التي قد تستحق تحقق المسؤول."
  },
  "Tell us about your business. Our team will review your request and send the next step for onboarding.": {
    "fr": "Présentez-nous votre entreprise. Notre équipe examinera votre demande et vous indiquera la prochaine étape de configuration.",
    "ar": "أخبرنا عن نشاطك. سيراجع فريقنا طلبك ويرسل لك الخطوة التالية للإعداد."
  },
  "Tell us about your organization, location footprint and rollout needs. Enterprise proposals are tailored rather than priced publicly.": {
    "fr": "Présentez votre organisation, vos établissements et vos besoins de déploiement. Les propositions Enterprise sont personnalisées, sans tarif public fixe.",
    "ar": "أخبرنا عن مؤسستك وانتشار مواقعك واحتياجات الإطلاق. عروض Enterprise مخصصة وليست ذات سعر عام ثابت."
  },
  "The AI Local Growth Platform that helps your business get found, build trust, and grow.": {
    "fr": "La plateforme de croissance locale assistée par IA pour être trouvé, inspirer confiance et se développer.",
    "ar": "منصة النمو المحلي بالذكاء الاصطناعي التي تساعد نشاطك على الظهور وبناء الثقة والنمو."
  },
  "The Local Score brings supported local signals into one history-aware intelligence view so changes can be interpreted over time. Its level varies by plan and available provider data.": {
    "fr": "Le score local réunit les signaux disponibles dans une vue historique intelligente pour comprendre leur évolution. Son niveau dépend de l’offre et des données fournisseurs disponibles.",
    "ar": "تجمع النتيجة المحلية المؤشرات المدعومة في عرض ذكي يستند إلى السجل لفهم التغيرات عبر الزمن. يختلف مستواها حسب الخطة وبيانات المزود المتاحة."
  },
  "The Local Score is a history-aware intelligence layer built from supported local signals. Its inputs and depth depend on the plan and provider data available for the location.": {
    "fr": "Le score local est une couche d’intelligence enrichie par l’historique des signaux locaux. Ses données et sa profondeur dépendent de l’offre et des données disponibles pour l’établissement.",
    "ar": "النتيجة المحلية طبقة تحليل ذكية تستند إلى سجل المؤشرات المحلية المدعومة. تعتمد مدخلاتها وعمقها على الخطة وبيانات المزود المتاحة للموقع."
  },
  "The V1 integration suite is designed to bring supported reputation signals from Google Business Profile, Facebook, Tripadvisor and Yelp into the broader local-growth context, with exact capabilities determined by each provider's API and permissions.": {
    "fr": "Les intégrations V1 visent à réunir les signaux de réputation disponibles de Google Business Profile, Facebook, Tripadvisor et Yelp dans le contexte de croissance locale, selon les API et autorisations de chaque fournisseur.",
    "ar": "صُممت مجموعة تكامل V1 لجمع مؤشرات السمعة المدعومة من Google Business Profile وFacebook وTripadvisor وYelp ضمن سياق النمو المحلي، وفق API كل مزود وأذوناته."
  },
  "The V1 provider ecosystem brings discovery, reputation, social, messaging and hospitality channels around one physical business location. Exact capabilities can vary by provider API, account eligibility, region, permissions and policy.": {
    "fr": "L’écosystème V1 réunit découverte, réputation, réseaux sociaux, messagerie et hébergement autour d’un établissement physique. Les capacités varient selon les API, l’éligibilité, la région, les autorisations et les règles.",
    "ar": "تجمع منظومة مزودي V1 قنوات الاكتشاف والسمعة والتواصل الاجتماعي والمراسلة والضيافة حول موقع فعلي واحد. قد تختلف الإمكانات حسب API المزود وأهلية الحساب والمنطقة والأذونات والسياسات."
  },
  "The V1 provider ecosystem includes Google Business Profile, Meta, Facebook, Instagram, WhatsApp, Tripadvisor, Booking.com, Apple and Yelp. Exact capabilities can vary by provider API, account eligibility, region, permissions and policy.": {
    "fr": "L’écosystème V1 comprend Google Business Profile, Meta, Facebook, Instagram, WhatsApp, Tripadvisor, Booking.com, Apple et Yelp. Les capacités varient selon les API, l’éligibilité, la région, les autorisations et les règles.",
    "ar": "تضم منظومة V1 كلًا من Google Business Profile وMeta وFacebook وInstagram وWhatsApp وTripadvisor وBooking.com وApple وYelp. قد تختلف الإمكانات حسب API المزود وأهلية الحساب والمنطقة والأذونات والسياسات."
  },
  "The V1 provider ecosystem is built around Google Business Profile, Meta, Facebook, Instagram, WhatsApp, Tripadvisor, Booking.com, Apple and Yelp. Exact capabilities can vary by provider API, account eligibility, region, permissions and policy.": {
    "fr": "L’écosystème V1 s’articule autour de Google Business Profile, Meta, Facebook, Instagram, WhatsApp, Tripadvisor, Booking.com, Apple et Yelp. Les capacités varient selon les API, l’éligibilité, la région, les autorisations et les règles.",
    "ar": "تُبنى منظومة V1 حول Google Business Profile وMeta وFacebook وInstagram وWhatsApp وTripadvisor وBooking.com وApple وYelp. قد تختلف الإمكانات حسب API المزود وأهلية الحساب والمنطقة والأذونات والسياسات."
  },
  "The catalog includes a 14-day trial with controlled trial entitlements; not every paid-plan capability is enabled in trial.": {
    "fr": "Le catalogue inclut un essai de 14 jours avec des droits limités ; toutes les capacités payantes ne sont pas activées pendant l’essai.",
    "ar": "يتضمن الكتالوج تجربة لمدة 14 يومًا بصلاحيات محددة؛ ولا تُفعّل جميع إمكانات الخطط المدفوعة أثناء التجربة."
  },
  "The product catalog includes a 14-day trial with controlled trial entitlements.": {
    "fr": "Le catalogue produit inclut un essai de 14 jours avec des droits d’accès encadrés.",
    "ar": "يتضمن كتالوج المنتج تجربة لمدة 14 يومًا بصلاحيات منضبطة."
  },
  "The product catalog includes a 14-day trial. Trial entitlements are controlled and do not unlock every paid-plan capability.": {
    "fr": "Le catalogue inclut un essai de 14 jours. Ses droits sont encadrés et ne donnent pas accès à toutes les fonctions payantes.",
    "ar": "يتضمن كتالوج المنتج تجربة لمدة 14 يومًا. صلاحيات التجربة منضبطة ولا تتيح كل إمكانات الخطط المدفوعة."
  },
  "The hidden cost of ignoring Google Business Profile optimization": {
    "fr": "Le coût caché d’une fiche Google Business Profile non optimisée",
    "ar": "التكلفة الخفية لتجاهل تحسين Google Business Profile"
  },
  "The onboarding flow builds a local baseline from the supported signals available for your location.": {
    "fr": "La configuration construit un état de référence local à partir des signaux disponibles pour votre établissement.",
    "ar": "يبني مسار الإعداد خط أساس محليًا من المؤشرات المدعومة المتاحة لموقعك."
  },
  "The operator decides what to do next.": {
    "fr": "L’opérateur décide de la prochaine action.",
    "ar": "يقرر المسؤول الخطوة التالية."
  },
  "The queue changes as supported signals create, update, resolve or deduplicate priority items.": {
    "fr": "La liste évolue lorsque les signaux disponibles créent, actualisent, résolvent ou dédoublonnent des priorités.",
    "ar": "تتغير القائمة عندما تنشئ المؤشرات المدعومة عناصر الأولوية أو تحدثها أو تحلها أو تزيل تكرارها."
  },
  "The review response strategy that converts skeptics into customers": {
    "fr": "La stratégie de réponse aux avis qui convainc les clients hésitants",
    "ar": "استراتيجية الرد على التقييمات التي تحوّل المترددين إلى عملاء"
  },
  "The same operating model, adapted to the reputation and local-performance context of each business category.": {
    "fr": "Un même modèle de pilotage, adapté à la réputation et aux performances locales de chaque catégorie d’activité.",
    "ar": "نموذج العمل نفسه، متكيف مع سياق السمعة والأداء المحلي لكل فئة نشاط."
  },
  "The score and every numeric sub-score animate together as the card enters view. Values shown here are illustrative interface data, not a claim about a real business.": {
    "fr": "Le score et ses composantes numériques s’animent à l’apparition de la carte. Les valeurs sont illustratives et ne décrivent aucune entreprise réelle.",
    "ar": "تتحرك النتيجة والنتائج الفرعية الرقمية مع ظهور البطاقة. القيم المعروضة بيانات واجهة توضيحية وليست ادعاءً عن نشاط حقيقي."
  },
  "Time-consuming review monitoring and response work across separate workflows": {
    "fr": "Un suivi des avis et des réponses chronophage dans des processus séparés",
    "ar": "متابعة التقييمات والردود التي تستغرق وقتًا عبر مسارات عمل منفصلة"
  },
  "Track how you appear in local search, Maps, and AI-driven discovery. Know your ranking, understand competitors, fix what's holding you back.": {
    "fr": "Suivez votre présence dans la recherche locale, Maps et la découverte assistée par IA. Comprenez votre classement, vos concurrents et les points à améliorer.",
    "ar": "تابع ظهورك في البحث المحلي والخرائط والاكتشاف بالذكاء الاصطناعي. اعرف ترتيبك وافهم المنافسين وعالج ما يعيقك."
  },
  "Track supported keyword signals and how they change over time for your location.": {
    "fr": "Suivez les mots-clés disponibles et leur évolution pour votre établissement.",
    "ar": "تابع مؤشرات الكلمات المفتاحية المدعومة وتغيرها عبر الزمن لموقعك."
  },
  "Track supported local-search and Google performance signals over time for your restaurant location.": {
    "fr": "Suivez dans le temps la recherche locale et les performances Google disponibles pour votre restaurant.",
    "ar": "تابع مؤشرات البحث المحلي وأداء Google المدعومة عبر الزمن لموقع مطعمك."
  },
  "Track supported local-search, keyword and Google performance signals over time, and use them to understand where visibility deserves attention.": {
    "fr": "Suivez les signaux de recherche locale, de mots-clés et de performance Google dans le temps pour identifier les priorités de visibilité.",
    "ar": "تابع مؤشرات البحث المحلي والكلمات المفتاحية وأداء Google المدعومة عبر الزمن لفهم أين يحتاج الظهور إلى اهتمام."
  },
  "Travelers search, compare, and decide based on what they find online. OPTRIXIS LOCAL helps properties understand the supported reputation and discovery signals around one location.": {
    "fr": "Les voyageurs cherchent, comparent et décident en ligne. OPTRIXIS LOCAL aide les établissements à comprendre les signaux de réputation et de découverte disponibles autour de leur site.",
    "ar": "يبحث المسافرون ويقارنون ويقررون بناءً على ما يجدونه عبر الإنترنت. تساعد OPTRIXIS LOCAL المنشآت على فهم مؤشرات السمعة والاكتشاف المدعومة حول موقع واحد."
  },
  "Trust and visibility for clinics and practices.": {
    "fr": "Confiance et visibilité pour les cliniques et cabinets.",
    "ar": "الثقة والظهور للعيادات والمراكز الصحية."
  },
  "Turn every review into a growth signal. Respond intelligently, manage reputation, and convert trust into loyalty.": {
    "fr": "Transformez chaque avis en signal de croissance. Répondez avec pertinence, gérez votre réputation et transformez la confiance en fidélité.",
    "ar": "حوّل كل تقييم إلى مؤشر نمو. رد بذكاء وأدر السمعة وحوّل الثقة إلى ولاء."
  },
  "Turn online presence into full tables.": {
    "fr": "Transformez votre présence en ligne en tables occupées.",
    "ar": "حوّل حضورك عبر الإنترنت إلى طاولات ممتلئة."
  },
  "Turn supported reputation and local-performance signals into clearer decisions for one restaurant location.": {
    "fr": "Transformez les signaux de réputation et de performance locale disponibles en décisions plus claires pour votre restaurant.",
    "ar": "حوّل مؤشرات السمعة والأداء المحلي المدعومة إلى قرارات أوضح لموقع مطعم واحد."
  },
  "Turn supported review activity into clearer reputation context, with AI-assisted drafts and controlled response workflows.": {
    "fr": "Transformez les avis disponibles en un contexte de réputation plus clair, avec brouillons IA et réponses encadrées.",
    "ar": "حوّل نشاط التقييمات المدعوم إلى سياق سمعة أوضح، مع مسودات بالذكاء الاصطناعي ومسارات رد منضبطة."
  },
  "Two unanswered reviews are waiting for operator review. I can draft response suggestions and keep the underlying review context visible.": {
    "fr": "Deux avis attendent une réponse de l’opérateur. Je peux proposer des brouillons en conservant le contexte de chaque avis.",
    "ar": "ينتظر تقييمان بلا إجابة مراجعة المسؤول. يمكنني اقتراح مسودات ردود مع إبقاء سياق التقييمات ظاهرًا."
  },
  "Understand reputation, local-performance and priority signals around one hospitality location.": {
    "fr": "Comprenez la réputation, les performances locales et les priorités autour d’un établissement d’hébergement.",
    "ar": "افهم مؤشرات السمعة والأداء المحلي والأولويات حول موقع ضيافة واحد."
  },
  "Understand supported keyword, local-search and Google performance signals over time, then connect meaningful changes to the next action.": {
    "fr": "Comprenez l’évolution des mots-clés, recherches locales et performances Google disponibles, puis reliez les changements significatifs à l’action suivante.",
    "ar": "افهم مؤشرات الكلمات المفتاحية والبحث المحلي وأداء Google المدعومة عبر الزمن، ثم اربط التغيرات المهمة بالإجراء التالي."
  },
  "Understand supported local-performance changes over time instead of relying on one snapshot.": {
    "fr": "Comprenez les variations des performances locales disponibles dans le temps plutôt qu’une seule image.",
    "ar": "افهم تغيرات الأداء المحلي المدعومة عبر الزمن بدل الاعتماد على لقطة واحدة."
  },
  "Understand supported local-search, keyword and Google performance signals over time. See what changed and where attention may be useful.": {
    "fr": "Comprenez la recherche locale, les mots-clés et les performances Google disponibles dans le temps. Voyez ce qui change et où agir peut être utile.",
    "ar": "افهم مؤشرات البحث المحلي والكلمات المفتاحية وأداء Google المدعومة عبر الزمن. اعرف ما تغير وأين قد يكون الاهتمام مفيدًا."
  },
  "Understand which aspects of your patient experience drive the strongest reputation signals.": {
    "fr": "Identifiez les aspects de l’expérience patient qui influencent le plus votre réputation.",
    "ar": "افهم جوانب تجربة المرضى التي تنتج أقوى مؤشرات السمعة."
  },
  "Understanding local-search changes without a history-aware operating view": {
    "fr": "Comprendre les changements de recherche locale sans vue historique de pilotage",
    "ar": "فهم تغيرات البحث المحلي دون عرض تشغيل يستند إلى السجل"
  },
  "Use supported Google performance signals to understand how discovery activity changes around your location.": {
    "fr": "Utilisez les performances Google disponibles pour comprendre l’évolution de la découverte autour de votre établissement.",
    "ar": "استخدم مؤشرات أداء Google المدعومة لفهم تغير نشاط الاكتشاف حول موقعك."
  },
  "Use supported keyword and performance context to identify areas that may deserve local SEO attention.": {
    "fr": "Utilisez les mots-clés et performances disponibles pour identifier les points à travailler en référencement local.",
    "ar": "استخدم سياق الكلمات المفتاحية والأداء المدعوم لتحديد مجالات تستحق تحسين البحث المحلي."
  },
  "Use supported language, sentiment and recurring-issue signals to understand how customer feedback changes over time.": {
    "fr": "Utilisez les signaux disponibles de langage, de ressenti et de problèmes récurrents pour comprendre l’évolution des retours clients.",
    "ar": "استخدم مؤشرات اللغة والمشاعر والمشكلات المتكررة المدعومة لفهم تغير ملاحظات العملاء عبر الزمن."
  },
  "Use supported performance history to understand meaningful local changes across different operating periods.": {
    "fr": "Utilisez l’historique des performances disponibles pour comprendre les changements locaux selon les périodes d’activité.",
    "ar": "استخدم سجل الأداء المدعوم لفهم التغيرات المحلية المهمة عبر فترات تشغيل مختلفة."
  },
  "Use supported search and performance context to surface recommendations that may deserve attention.": {
    "fr": "Utilisez le contexte de recherche et de performance disponible pour faire ressortir des recommandations utiles.",
    "ar": "استخدم سياق البحث والأداء المدعوم لإبراز توصيات قد تستحق الاهتمام."
  },
  "V1 controlled alerting channel. Consent, approved templates, permissions and provider policy apply.": {
    "fr": "Canal d’alerte encadré de la V1. Consentement, modèles approuvés, autorisations et règles du fournisseur s’appliquent.",
    "ar": "قناة تنبيه منضبطة في V1. تنطبق الموافقة والقوالب المعتمدة والأذونات وسياسة المزود."
  },
  "We built Optrixis Local with security, privacy, and transparency as foundations — not afterthoughts. The public security posture reflects the controls actually implemented in the platform and operations.": {
    "fr": "Optrixis Local repose sur la sécurité, la confidentialité et la transparence. La présentation publique de sa sécurité reflète les contrôles réellement mis en place dans la plateforme et son exploitation.",
    "ar": "بنينا Optrixis Local على الأمان والخصوصية والشفافية منذ البداية. يعكس عرض الأمان العام الضوابط المطبقة فعليًا في المنصة وعملياتها."
  },
  "What does 'one location' mean?": {
    "fr": "Que signifie « un établissement » ?",
    "ar": "ماذا يعني «موقع واحد»؟"
  },
  "What is the Local Score?": {
    "fr": "Qu’est-ce que le score local ?",
    "ar": "ما النتيجة المحلية؟"
  },
  "What payment methods are supported?": {
    "fr": "Quels moyens de paiement sont acceptés ?",
    "ar": "ما طرق الدفع المدعومة؟"
  },
  "What the Local Score actually measures — and why it matters": {
    "fr": "Ce que mesure le score local et pourquoi c’est utile",
    "ar": "ما الذي تقيسه النتيجة المحلية فعلًا ولماذا يهم"
  },
  "What's the highest impact thing I can do today?": {
    "fr": "Quelle action aura le plus d’impact aujourd’hui ?",
    "ar": "ما الإجراء الأعلى أثرًا الذي يمكنني اتخاذه اليوم؟"
  },
  "What's the opportunity?": {
    "fr": "Quelle est l’opportunité ?",
    "ar": "ما الفرصة؟"
  },
  "When someone searches for a restaurant like yours nearby, OPTRIXIS LOCAL helps you understand the supported visibility and reputation signals that influence local discovery.": {
    "fr": "Quand une personne cherche un restaurant comme le vôtre à proximité, OPTRIXIS LOCAL aide à comprendre les signaux de visibilité et de réputation disponibles qui influencent sa découverte.",
    "ar": "عندما يبحث شخص عن مطعم مثل مطعمك بالقرب منه، تساعدك OPTRIXIS LOCAL على فهم مؤشرات الظهور والسمعة المدعومة التي تؤثر في الاكتشاف المحلي."
  },
  "When someone searches for what you sell nearby, OPTRIXIS LOCAL helps you understand the supported visibility and reputation signals around your store.": {
    "fr": "Quand une personne cherche vos produits à proximité, OPTRIXIS LOCAL aide à comprendre les signaux de visibilité et de réputation disponibles autour du magasin.",
    "ar": "عندما يبحث شخص بالقرب منك عما تبيعه، تساعدك OPTRIXIS LOCAL على فهم مؤشرات الظهور والسمعة المدعومة حول متجرك."
  },
  "Whether you have a question about the platform, pricing, enterprise solutions, or anything else — we're here.": {
    "fr": "Une question sur la plateforme, les tarifs, Enterprise ou un autre sujet ? Nous sommes là.",
    "ar": "سواء كان سؤالك عن المنصة أو الأسعار أو حلول المؤسسات أو أي موضوع آخر، نحن هنا."
  },
  "Which integrations are included in V1?": {
    "fr": "Quelles intégrations sont prévues en V1 ?",
    "ar": "ما عمليات التكامل المشمولة في V1؟"
  },
  "Which platforms are included in V1?": {
    "fr": "Quelles plateformes sont prévues en V1 ?",
    "ar": "ما المنصات المشمولة في V1؟"
  },
  "Which review platforms are monitored?": {
    "fr": "Quelles plateformes d’avis sont suivies ?",
    "ar": "ما منصات التقييمات التي تتم متابعتها؟"
  },
  "Why did my visibility drop this week?": {
    "fr": "Pourquoi ma visibilité a-t-elle baissé cette semaine ?",
    "ar": "لماذا انخفض ظهوري هذا الأسبوع؟"
  },
  "Why local businesses lose search visibility (and how to reclaim it)": {
    "fr": "Pourquoi les entreprises locales perdent en visibilité et comment la retrouver",
    "ar": "لماذا تفقد الأنشطة المحلية ظهورها في البحث وكيف تستعيده"
  },
  "Workspace-scoped data": {
    "fr": "Données limitées à l’espace de travail",
    "ar": "بيانات محصورة بمساحة العمل"
  },
  "Yes. Tripadvisor is part of the V1 integration scope for supported reputation and hospitality signals, subject to the capabilities and permissions exposed by the provider.": {
    "fr": "Oui. Tripadvisor fait partie du périmètre V1 pour les signaux de réputation et d’hébergement pris en charge, selon les capacités et autorisations du fournisseur.",
    "ar": "نعم. Tripadvisor جزء من نطاق تكامل V1 لمؤشرات السمعة والضيافة المدعومة، وفق الإمكانات والأذونات التي يتيحها المزود."
  },
  "Your Google Business Profile photo activity changed from its recent pattern. Fresh, accurate photos may be worth reviewing alongside the supported visibility signals before taking action.": {
    "fr": "L’activité photo de votre fiche Google Business Profile a changé. Il peut être utile de vérifier des photos récentes et exactes avec les signaux de visibilité disponibles avant d’agir.",
    "ar": "تغير نشاط صور Google Business Profile عن نمطه الأخير. قد تستحق الصور الحديثة والدقيقة مراجعة مع مؤشرات الظهور المدعومة قبل اتخاذ إجراء."
  },
  "Your business at the center, with supported provider signals brought into one operating context as each integration becomes available.": {
    "fr": "Votre entreprise au centre, avec les signaux fournisseurs disponibles réunis à mesure que chaque intégration devient accessible.",
    "ar": "نشاطك في المركز، مع جمع مؤشرات المزودين المدعومة في سياق عمل واحد عند توفر كل تكامل."
  },
  "Your business at the center. Discovery, reputation, messaging and customer signals come together across the V1 provider ecosystem.": {
    "fr": "Votre entreprise au centre. Découverte, réputation, messagerie et signaux clients se rejoignent dans l’écosystème V1.",
    "ar": "نشاطك في المركز. تجتمع مؤشرات الاكتشاف والسمعة والمراسلة والعملاء عبر منظومة مزودي V1."
  },
  "Your business data belongs to you. We never sell it, never share it, and give you full control over what we store. Enterprise-grade security as a default — not an add-on.": {
    "fr": "Les données de votre entreprise vous appartiennent. Nous ne les vendons ni ne les partageons, et vous gardez le contrôle de leur stockage. Une sécurité de niveau entreprise est intégrée par défaut.",
    "ar": "بيانات نشاطك ملكك. لا نبيعها ولا نشاركها، ونمنحك التحكم الكامل فيما نخزنه. أمان بمستوى المؤسسات متاح افتراضيًا وليس إضافة."
  },
  "brands and groups.": {
    "fr": "les marques et les groupes.",
    "ar": "العلامات التجارية والمجموعات."
  },
  "drives local growth.": {
    "fr": "stimulent la croissance locale.",
    "ar": "يدفع النمو المحلي."
  },
  "finally in control.": {
    "fr": "enfin sous contrôle.",
    "ar": "تحت سيطرتك أخيرًا."
  },
  "is built for multi-site operations.": {
    "fr": "est conçu pour les activités multisites.",
    "ar": "مصمم للعمليات متعددة المواقع."
  },
  "that thinks with you.": {
    "fr": "qui réfléchit avec vous.",
    "ar": "يفكر معك."
  },
  "to be found.": {
    "fr": "d’être trouvée.",
    "ar": "أن يُعثر عليه."
  },
  "who are looking for you right now.": {
    "fr": "qui vous recherchent en ce moment.",
    "ar": "الذين يبحثون عنك الآن."
  },
  "integrations": {
    "fr": "intégrations",
    "ar": "عمليات تكامل"
  },
  "Save ~20%": {
    "fr": "Économisez environ 20 %",
    "ar": "وفّر نحو 20٪"
  },
  "/mo": {
    "fr": "/mois",
    "ar": "/شهر"
  },
  "/yr)": {
    "fr": "/an)",
    "ar": "/سنة)"
  },
  "The essentials for one physical business location.": {
    "fr": "L’essentiel pour un établissement physique.",
    "ar": "الأساسيات لموقع فعلي واحد للنشاط."
  },
  "Essential local-growth intelligence for one physical business location.": {
    "fr": "L’analyse essentielle de croissance locale pour un établissement physique.",
    "ar": "تحليلات النمو المحلي الأساسية لموقع فعلي واحد للنشاط."
  },
  "Advanced intelligence and alerting for a growing local business.": {
    "fr": "Analyses avancées et alertes pour une entreprise locale en croissance.",
    "ar": "تحليلات وتنبيهات متقدمة لنشاط محلي متنامٍ."
  },
  "Advanced intelligence and alerting for businesses strengthening their local presence.": {
    "fr": "Analyses avancées et alertes pour renforcer votre présence locale.",
    "ar": "تحليلات وتنبيهات متقدمة للأنشطة التي تعزز حضورها المحلي."
  },
  "The most complete standard-location operating model.": {
    "fr": "Le modèle standard le plus complet pour un établissement.",
    "ar": "نموذج التشغيل القياسي الأكثر اكتمالًا لموقع واحد."
  },
  "The deepest standard-plan intelligence and operating context for one location.": {
    "fr": "Les analyses et le contexte de pilotage les plus approfondis des offres standard pour un établissement.",
    "ar": "أعمق تحليلات وسياق تشغيل ضمن الخطط القياسية لموقع واحد."
  },
  "For organizations managing multiple physical business locations.": {
    "fr": "Pour les organisations qui gèrent plusieurs établissements physiques.",
    "ar": "للمؤسسات التي تدير مواقع فعلية متعددة للنشاط."
  },
  "Multi-location groups with a contact-led rollout and custom commercial scope.": {
    "fr": "Groupes multiétablissements avec déploiement accompagné et conditions commerciales adaptées.",
    "ar": "مجموعات متعددة المواقع مع إطلاق بمرافقة الفريق ونطاق تجاري مخصص."
  },
  "1 physical business location": {
    "fr": "1 établissement physique",
    "ar": "موقع فعلي واحد للنشاط"
  },
  "Up to 2 team members": {
    "fr": "Jusqu’à 2 membres d’équipe",
    "ar": "حتى عضوين في الفريق"
  },
  "Up to 5 team members": {
    "fr": "Jusqu’à 5 membres d’équipe",
    "ar": "حتى 5 أعضاء في الفريق"
  },
  "Up to 10 team members": {
    "fr": "Jusqu’à 10 membres d’équipe",
    "ar": "حتى 10 أعضاء في الفريق"
  },
  "Google Business Profile connection, subject to provider availability": {
    "fr": "Connexion Google Business Profile, sous réserve de disponibilité",
    "ar": "ربط Google Business Profile وفق توفر المزود"
  },
  "Review monitoring and AI-assisted reply suggestions": {
    "fr": "Suivi des avis et suggestions de réponses par IA",
    "ar": "متابعة التقييمات واقتراحات ردود بالذكاء الاصطناعي"
  },
  "Basic Local Score and Local SEO intelligence": {
    "fr": "Score local et référencement local de base",
    "ar": "نتيجة محلية وتحليل أساسي للبحث المحلي"
  },
  "Priority Actions workspace": {
    "fr": "Espace d’actions prioritaires",
    "ar": "مساحة عمل لإجراءات الأولوية"
  },
  "In-app and email notifications": {
    "fr": "Notifications dans l’application et par e-mail",
    "ar": "إشعارات داخل التطبيق وبالبريد الإلكتروني"
  },
  "Monthly reports and 12-month product history": {
    "fr": "Rapports mensuels et historique produit de 12 mois",
    "ar": "تقارير شهرية وسجل منتج لمدة 12 شهرًا"
  },
  "Everything in Start": {
    "fr": "Tout le contenu de Start",
    "ar": "كل ما تتضمنه Start"
  },
  "Everything in Growth": {
    "fr": "Tout le contenu de Growth",
    "ar": "كل ما تتضمنه Growth"
  },
  "Advanced review intelligence": {
    "fr": "Analyse avancée des avis",
    "ar": "تحليل متقدم للتقييمات"
  },
  "Advanced Local Score and Local SEO intelligence": {
    "fr": "Score local et référencement local avancés",
    "ar": "نتيجة محلية وتحليل متقدم للبحث المحلي"
  },
  "Critical WhatsApp alerts under policy and consent gates": {
    "fr": "Alertes WhatsApp critiques selon les règles et consentements",
    "ar": "تنبيهات WhatsApp حرجة وفق ضوابط السياسة والموافقة"
  },
  "Weekly insights": {
    "fr": "Analyses hebdomadaires",
    "ar": "رؤى أسبوعية"
  },
  "24-month product history": {
    "fr": "Historique produit de 24 mois",
    "ar": "سجل منتج لمدة 24 شهرًا"
  },
  "Curated additional-channel catalog": {
    "fr": "Catalogue sélectionné de canaux supplémentaires",
    "ar": "كتالوج منتقى لقنوات إضافية"
  },
  "Brand Voice AI context": {
    "fr": "Contexte IA du ton de votre marque",
    "ar": "سياق أسلوب العلامة بالذكاء الاصطناعي"
  },
  "Critical and high-impact WhatsApp alerts under policy gates": {
    "fr": "Alertes WhatsApp critiques et à fort impact selon les règles",
    "ar": "تنبيهات WhatsApp حرجة وذات أثر كبير وفق ضوابط السياسة"
  },
  "Premium PDF reports": {
    "fr": "Rapports PDF premium",
    "ar": "تقارير PDF مميزة"
  },
  "Advanced exports": {
    "fr": "Exports avancés",
    "ar": "عمليات تصدير متقدمة"
  },
  "Full compatible additional-channel catalog": {
    "fr": "Catalogue complet des canaux supplémentaires compatibles",
    "ar": "الكتالوج الكامل للقنوات الإضافية المتوافقة"
  },
  "Maximum compliant product-history access": {
    "fr": "Accès maximal à l’historique selon les règles applicables",
    "ar": "أقصى وصول لسجل المنتج وفق القواعد المعمول بها"
  },
  "Multi-location management": {
    "fr": "Gestion multiétablissement",
    "ar": "إدارة مواقع متعددة"
  },
  "Portfolio governance": {
    "fr": "Gouvernance du portefeuille",
    "ar": "حوكمة مجموعة المواقع"
  },
  "Custom entitlements and rollout": {
    "fr": "Droits et déploiement sur mesure",
    "ar": "صلاحيات وإطلاق مخصصان"
  },
  "Advanced reporting and exports": {
    "fr": "Rapports et exports avancés",
    "ar": "تقارير وعمليات تصدير متقدمة"
  },
  "Policy-aware alerting": {
    "fr": "Alertes conformes aux règles applicables",
    "ar": "تنبيهات تراعي السياسات"
  },
  "Contact-led implementation": {
    "fr": "Mise en œuvre accompagnée",
    "ar": "تنفيذ بمرافقة الفريق"
  },
  "AI Local Growth Platform": {
    "fr": "Plateforme de croissance locale par l’IA",
    "ar": "منصة نمو محلي بالذكاء الاصطناعي"
  },
  "Turn local visibility": {
    "fr": "Transformez votre visibilité locale",
    "ar": "حوّل ظهورك المحلي"
  },
  "into measurable": {
    "fr": "en croissance",
    "ar": "إلى نمو"
  },
  "growth.": {
    "fr": "mesurable.",
    "ar": "قابل للقياس."
  },
  "Reviews, Google performance, Local Score and AI-prioritized next actions — one workspace built to help local businesses grow with clarity.": {
    "fr": "Avis, performances Google, Local Score et prochaines actions priorisées par l’IA — un seul espace de travail pour faire grandir votre activité locale avec clarté.",
    "ar": "المراجعات وأداء Google وLocal Score والخطوات التالية التي يرتبها الذكاء الاصطناعي — مساحة عمل واحدة تساعد نشاطك المحلي على النمو بوضوح."
  },
  "Live product preview": {
    "fr": "Aperçu produit en direct",
    "ar": "معاينة مباشرة للمنتج"
  },
  "Downtown location": {
    "fr": "Établissement principal",
    "ar": "الموقع الرئيسي"
  },
  "Product preview navigation": {
    "fr": "Navigation de l’aperçu produit",
    "ar": "تنقل معاينة المنتج"
  },
  "Pro workspace": {
    "fr": "Espace Pro",
    "ar": "مساحة Pro"
  },
  "Sample data": {
    "fr": "Données d’exemple",
    "ar": "بيانات تجريبية"
  },
  "Good morning, Bella": {
    "fr": "Bonjour, Bella",
    "ar": "صباح الخير، Bella"
  },
  "Here is what matters today for your local growth.": {
    "fr": "Voici ce qui compte aujourd’hui pour votre croissance locale.",
    "ar": "إليك ما يهم اليوم لنمو نشاطك المحلي."
  },
  "Google connected": {
    "fr": "Google connecté",
    "ar": "Google متصل"
  },
  "Last 28 days": {
    "fr": "28 derniers jours",
    "ar": "آخر 28 يومًا"
  },
  "Google visibility": {
    "fr": "Visibilité Google",
    "ar": "الظهور على Google"
  },
  "Priority actions": {
    "fr": "Actions prioritaires",
    "ar": "الإجراءات ذات الأولوية"
  },
  "2 critical": {
    "fr": "2 critiques",
    "ar": "2 حرجتان"
  },
  "Local growth overview": {
    "fr": "Vue croissance locale",
    "ar": "نظرة عامة على النمو المحلي"
  },
  "Performance signals": {
    "fr": "Signaux de performance",
    "ar": "مؤشرات الأداء"
  },
  "28 days": {
    "fr": "28 jours",
    "ar": "28 يومًا"
  },
  "Google Search visibility": {
    "fr": "Visibilité Google Search",
    "ar": "الظهور في Google Search"
  },
  "Direction requests": {
    "fr": "Demandes d’itinéraire",
    "ar": "طلبات الاتجاهات"
  },
  "Website clicks": {
    "fr": "Clics vers le site",
    "ar": "نقرات الموقع"
  },
  "Recommended next action": {
    "fr": "Prochaine action recommandée",
    "ar": "الإجراء التالي الموصى به"
  },
  "Weekend dinner visibility is down versus the previous period. Check opening hours and recent review themes before making a profile update.": {
    "fr": "La visibilité des dîners du week-end baisse par rapport à la période précédente. Vérifiez les horaires et les thèmes des avis récents avant de modifier le profil.",
    "ar": "انخفض ظهور النشاط لعشاء عطلة نهاية الأسبوع مقارنة بالفترة السابقة. راجع ساعات العمل ومواضيع المراجعات الحديثة قبل تعديل الملف."
  },
  "Review opening hours": {
    "fr": "Vérifier les horaires",
    "ar": "مراجعة ساعات العمل"
  },
  "Excellent service and a great experience. We will be back.": {
    "fr": "Excellent service et très belle expérience. Nous reviendrons.",
    "ar": "خدمة ممتازة وتجربة رائعة. سنعود بالتأكيد."
  },
  "AI reply ready": {
    "fr": "Réponse IA prête",
    "ar": "رد الذكاء الاصطناعي جاهز"
  },
  "+6 vs previous period": {
    "fr": "+6 vs période précédente",
    "ar": "+6 مقابل الفترة السابقة"
  },
  "AI recommendation ready": {
    "fr": "Recommandation IA prête",
    "ar": "توصية الذكاء الاصطناعي جاهزة"
  },
  "3 priority actions ranked": {
    "fr": "3 actions prioritaires classées",
    "ar": "تم ترتيب 3 إجراءات ذات أولوية"
  },
  "LOCAL INTELLIGENCE · ACTION": {
    "fr": "INTELLIGENCE LOCALE · ACTION",
    "ar": "ذكاء محلي · خطوات عملية"
  },
  "Know what matters locally. Act before it costs you growth.": {
    "fr": "Identifiez les enjeux locaux. Agissez avant qu’ils ne freinent votre croissance.",
    "ar": "تعرّف على ما يهم نشاطك محليًا. تحرّك قبل أن يتأثر نموك."
  },
  "Reputation, local visibility and critical issues in one secure operating layer built for real businesses.": {
    "fr": "Réputation, visibilité locale et problèmes critiques réunis dans un espace sécurisé conçu pour les entreprises.",
    "ar": "السمعة والظهور المحلي والمشكلات المهمة في مساحة عمل آمنة مصممة للشركات."
  },
  "Tenant isolated": {
    "fr": "Espaces clients isolés",
    "ar": "عزل بيانات كل عميل"
  },
  "Human-controlled AI": {
    "fr": "IA sous contrôle humain",
    "ar": "ذكاء اصطناعي بإشراف بشري"
  },
  "Protected by OPTRIXIS account security controls. Never share your password or verification codes.": {
    "fr": "Protégé par les contrôles de sécurité OPTRIXIS. Ne partagez jamais votre mot de passe ni vos codes de vérification.",
    "ar": "محمي بضوابط أمان حسابات OPTRIXIS. لا تشارك كلمة المرور أو رموز التحقق أبدًا."
  },
  "START SECURELY": {
    "fr": "DÉMARREZ EN TOUTE SÉCURITÉ",
    "ar": "ابدأ بأمان"
  },
  "Use at least 12 characters for your password.": {
    "fr": "Utilisez au moins 12 caractères pour votre mot de passe.",
    "ar": "استخدم 12 حرفًا على الأقل لكلمة المرور."
  },
  "The passwords do not match.": {
    "fr": "Les mots de passe ne correspondent pas.",
    "ar": "كلمتا المرور غير متطابقتين."
  },
  "We could not create your account. Please review the details and try again.": {
    "fr": "Nous n’avons pas pu créer votre compte. Vérifiez les informations et réessayez.",
    "ar": "تعذّر إنشاء حسابك. راجع المعلومات وحاول مجددًا."
  },
  "Account creation is temporarily unavailable. Please try again.": {
    "fr": "La création de compte est temporairement indisponible. Veuillez réessayer.",
    "ar": "إنشاء الحساب غير متاح مؤقتًا. حاول مجددًا."
  },
  "Build your local growth workspace.": {
    "fr": "Créez votre espace de croissance locale.",
    "ar": "أنشئ مساحة عمل لتنمية نشاطك المحلي."
  },
  "Create the account first. After email verification, you’ll review the current Terms and Privacy policy before any customer workspace is created.": {
    "fr": "Créez d’abord votre compte. Après vérification de votre e-mail, vous consulterez les conditions et la politique de confidentialité en vigueur avant la création de votre espace.",
    "ar": "أنشئ الحساب أولًا. بعد التحقق من بريدك الإلكتروني، ستراجع الشروط وسياسة الخصوصية الساريتين قبل إنشاء مساحة العمل."
  },
  "Your name": {
    "fr": "Votre nom",
    "ar": "اسمك"
  },
  "Your full name": {
    "fr": "Votre nom complet",
    "ar": "اسمك الكامل"
  },
  "Work email": {
    "fr": "E-mail professionnel",
    "ar": "البريد الإلكتروني للعمل"
  },
  "Password": {
    "fr": "Mot de passe",
    "ar": "كلمة المرور"
  },
  "Minimum 12 characters. A password manager is recommended.": {
    "fr": "Au moins 12 caractères. Un gestionnaire de mots de passe est recommandé.",
    "ar": "12 حرفًا على الأقل. يُنصح باستخدام مدير كلمات مرور."
  },
  "Confirm password": {
    "fr": "Confirmez le mot de passe",
    "ar": "تأكيد كلمة المرور"
  },
  "Creating account…": {
    "fr": "Création du compte…",
    "ar": "جارٍ إنشاء الحساب…"
  },
  "Create account": {
    "fr": "Créer un compte",
    "ar": "إنشاء حساب"
  },
  "Already have an account?": {
    "fr": "Vous avez déjà un compte ?",
    "ar": "لديك حساب بالفعل؟"
  },
  "YOUR PURCHASE": {
    "fr": "VOTRE ACHAT",
    "ar": "عملية الشراء"
  },
  "Link your purchase securely.": {
    "fr": "Rattachez votre achat en toute sécurité.",
    "ar": "اربط عملية الشراء بحسابك بأمان."
  },
  "Use the same email address as your payment. We will check the payment confirmation before attaching the subscription to your account.": {
    "fr": "Utilisez l’adresse e-mail indiquée lors du paiement. Nous vérifierons la confirmation du paiement avant de rattacher l’abonnement à votre compte.",
    "ar": "استخدم البريد الإلكتروني نفسه الذي أدخلته عند الدفع. سنتحقق من تأكيد الدفع قبل ربط الاشتراك بحسابك."
  },
  "Open the return link from your checkout. Contact support if you cannot find it.": {
    "fr": "Ouvrez le lien de retour de votre paiement. Contactez l’assistance si vous ne le retrouvez pas.",
    "ar": "افتح رابط العودة من صفحة الدفع. تواصل مع الدعم إذا لم تجده."
  },
  "Signed in as": {
    "fr": "Connecté avec",
    "ar": "تم تسجيل الدخول باستخدام"
  },
  "Check payment and continue": {
    "fr": "Vérifier le paiement et continuer",
    "ar": "التحقق من الدفع والمتابعة"
  },
  "Open Billing": {
    "fr": "Ouvrir la facturation",
    "ar": "فتح صفحة الفوترة"
  },
  "Contact support": {
    "fr": "Contacter l’assistance",
    "ar": "التواصل مع الدعم"
  },
  "A return link alone never activates a subscription. If you were charged but cannot continue, contact support with your Stripe receipt.": {
    "fr": "Le lien de retour n’active pas votre abonnement à lui seul. Si vous avez été débité mais ne pouvez pas continuer, contactez l’assistance avec votre reçu Stripe.",
    "ar": "رابط العودة وحده لا يفعّل الاشتراك. إذا خُصم المبلغ وتعذّرت المتابعة، تواصل مع الدعم وأرفق إيصال Stripe."
  },
  "Payment confirmation is still pending, or this subscription is no longer active. Wait a moment and check again. Do not pay again if Stripe has already charged you.": {
    "fr": "La confirmation du paiement est en attente, ou cet abonnement n’est plus actif. Patientez puis réessayez. Ne payez pas à nouveau si Stripe vous a déjà débité.",
    "ar": "تأكيد الدفع قيد الانتظار، أو أن الاشتراك لم يعد نشطًا. انتظر قليلًا ثم تحقّق مجددًا. لا تدفع مرة أخرى إذا خُصم المبلغ عبر Stripe."
  },
  "We cannot link this purchase yet. Verify the same email address used at checkout, then try again. Contact support if you need help; do not make another payment.": {
    "fr": "Nous ne pouvons pas encore rattacher cet achat. Vérifiez l’adresse e-mail utilisée lors du paiement, puis réessayez. Contactez l’assistance si nécessaire ; n’effectuez pas un second paiement.",
    "ar": "تعذّر ربط عملية الشراء حاليًا. تحقّق من البريد الإلكتروني المستخدم عند الدفع ثم حاول مجددًا. تواصل مع الدعم عند الحاجة، ولا تُجرِ دفعة أخرى."
  },
  "The workspace country must match the business country selected at checkout. Contact support before continuing.": {
    "fr": "Le pays de l’espace doit correspondre à celui de l’entreprise sélectionné lors du paiement. Contactez l’assistance avant de continuer.",
    "ar": "يجب أن يطابق بلد مساحة العمل بلد النشاط المحدد عند الدفع. تواصل مع الدعم قبل المتابعة."
  },
  "Your account already has a purchase or subscription to manage. Open Billing or contact support to avoid a duplicate subscription.": {
    "fr": "Votre compte possède déjà un achat ou un abonnement à gérer. Ouvrez la facturation ou contactez l’assistance pour éviter un double abonnement.",
    "ar": "يوجد في حسابك شراء أو اشتراك يحتاج إلى إدارة. افتح صفحة الفوترة أو تواصل مع الدعم لتجنّب اشتراك مكرر."
  },
  "Online plans are billed in USD for businesses in France, the United States, the United Kingdom, Canada, the UAE, Saudi Arabia, Spain and Germany. For Morocco or another country, contact us before purchasing.": {
    "fr": "Les offres en ligne sont facturées en USD pour les entreprises en France, aux États-Unis, au Royaume-Uni, au Canada, aux Émirats arabes unis, en Arabie saoudite, en Espagne et en Allemagne. Pour le Maroc ou un autre pays, contactez-nous avant tout achat.",
    "ar": "تُفوتر الخطط عبر الإنترنت بالدولار الأمريكي للشركات في فرنسا والولايات المتحدة والمملكة المتحدة وكندا والإمارات والسعودية وإسبانيا وألمانيا. للمغرب أو أي بلد آخر، تواصل معنا قبل الشراء."
  },
  "Billed annually:": {
    "fr": "Facturation annuelle :",
    "ar": "الفوترة سنويًا:"
  },
  "per year": {
    "fr": "par an",
    "ar": "في السنة"
  },
  "0 days": {
    "fr": "0 jour",
    "ar": "0 يوم"
  },
  "1h ago": {
    "fr": "Il y a 1 h",
    "ar": "قبل ساعة"
  },
  "3h ago": {
    "fr": "Il y a 3 h",
    "ar": "قبل 3 ساعات"
  },
  "5h ago": {
    "fr": "Il y a 5 h",
    "ar": "قبل 5 ساعات"
  },
  "3 items": {
    "fr": "3 éléments",
    "ar": "3 عناصر"
  },
  "90-day context": {
    "fr": "Contexte sur 90 jours",
    "ar": "سياق آخر 90 يومًا"
  },
  "AI": {
    "fr": "IA",
    "ar": "ذكاء اصطناعي"
  },
  "AI explains changes in plain language": {
    "fr": "L’IA explique les changements simplement",
    "ar": "الذكاء الاصطناعي يشرح التغيّرات بلغة واضحة"
  },
  "Assisted context": {
    "fr": "Analyse assistée",
    "ar": "سياق بمساعدة الذكاء الاصطناعي"
  },
  "Checking supported review channels manually": {
    "fr": "Vérification manuelle des canaux d’avis pris en charge",
    "ar": "مراجعة قنوات التقييمات المدعومة يدويًا"
  },
  "Discovery & Local Search": {
    "fr": "Découverte et recherche locale",
    "ar": "الاكتشاف والبحث المحلي"
  },
  "Example feed": {
    "fr": "Flux d’exemple",
    "ar": "مثال على موجز النشاط"
  },
  "Guessing what to improve": {
    "fr": "Améliorations choisies au hasard",
    "ar": "تخمين ما ينبغي تحسينه"
  },
  "High": {
    "fr": "Élevé",
    "ar": "مرتفع"
  },
  "High impact": {
    "fr": "Impact élevé",
    "ar": "تأثير مرتفع"
  },
  "History-aware Local Score context": {
    "fr": "Contexte du Local Score tenant compte de l’historique",
    "ar": "سياق Local Score مع مراعاة السجل السابق"
  },
  "Hospitality & Discovery": {
    "fr": "Hébergement et découverte",
    "ar": "الضيافة والاكتشاف"
  },
  "Medium": {
    "fr": "Moyen",
    "ar": "متوسط"
  },
  "Messaging": {
    "fr": "Messagerie",
    "ar": "المراسلة"
  },
  "Multi": {
    "fr": "Plusieurs",
    "ar": "متعدد"
  },
  "No idea how you compare locally": {
    "fr": "Aucun repère face à la concurrence locale",
    "ar": "غياب رؤية لموقعك مقارنة بالمنافسين محليًا"
  },
  "Not knowing why traffic dropped": {
    "fr": "Baisse de trafic inexpliquée",
    "ar": "عدم معرفة سبب انخفاض الزيارات"
  },
  "Ranked priority actions every morning": {
    "fr": "Actions prioritaires classées chaque matin",
    "ar": "خطوات ذات أولوية مرتبة كل صباح"
  },
  "Recommended": {
    "fr": "Recommandé",
    "ar": "موصى به"
  },
  "Reputation workflow": {
    "fr": "Gestion de la réputation",
    "ar": "إدارة السمعة"
  },
  "SCORE": {
    "fr": "SCORE",
    "ar": "النتيجة"
  },
  "Social & Customer Engagement": {
    "fr": "Réseaux sociaux et engagement client",
    "ar": "التواصل الاجتماعي وتفاعل العملاء"
  },
  "Supported review activity in one workflow": {
    "fr": "Activité des avis pris en charge dans un même espace",
    "ar": "نشاط التقييمات المدعومة في مساحة واحدة"
  },
  "V1 Alerts": {
    "fr": "Alertes V1",
    "ar": "تنبيهات الإصدار الأول"
  },
  "V1 Core": {
    "fr": "Socle V1",
    "ar": "أساس الإصدار الأول"
  },
  "V1 Integration": {
    "fr": "Intégration V1",
    "ar": "تكامل الإصدار الأول"
  },
  "Visibility context": {
    "fr": "Contexte de visibilité",
    "ar": "سياق الظهور"
  },
  "needs attention": {
    "fr": "demande votre attention",
    "ar": "يحتاج إلى اهتمام"
  },
  "new activity": {
    "fr": "nouvelle activité",
    "ar": "نشاط جديد"
  },
  "signal available": {
    "fr": "signal disponible",
    "ar": "إشارة متاحة"
  },
  "Apple connects supported local-discovery and presence signals around the same business location.": {
    "fr": "Apple relie les signaux de découverte locale et de présence pris en charge pour un même établissement.",
    "ar": "يربط Apple إشارات الاكتشاف المحلي والحضور المدعومة للموقع نفسه."
  },
  "Booking.com connects supported hospitality discovery, guest and presence signals for eligible business accounts.": {
    "fr": "Booking.com relie les signaux de découverte hôtelière, de clientèle et de présence pris en charge pour les comptes éligibles.",
    "ar": "يربط Booking.com إشارات اكتشاف منشآت الضيافة والضيوف والحضور المدعومة لحسابات الأنشطة المؤهلة."
  },
  "Facebook brings supported local Page, engagement and customer-interaction signals into the business context.": {
    "fr": "Facebook apporte les signaux pris en charge des Pages locales, de l’engagement et des interactions clients au contexte de l’entreprise.",
    "ar": "يضيف Facebook إشارات الصفحات المحلية والتفاعل وتواصل العملاء المدعومة إلى سياق النشاط."
  },
  "Google Business Profile connects local search, Maps, reviews and supported performance context around the same business location.": {
    "fr": "Google Business Profile relie recherche locale, Maps, avis et contexte de performance pris en charge pour un même établissement.",
    "ar": "يربط Google Business Profile البحث المحلي والخرائط والتقييمات وسياق الأداء المدعوم للموقع نفسه."
  },
  "Instagram connects supported audience, presence and engagement signals around the same physical business location.": {
    "fr": "Instagram relie les signaux d’audience, de présence et d’engagement pris en charge pour un même établissement physique.",
    "ar": "يربط Instagram إشارات الجمهور والحضور والتفاعل المدعومة للموقع الفعلي نفسه."
  },
  "Meta connects supported ecosystem signals and account context to the unified local-growth workspace.": {
    "fr": "Meta relie les signaux de son écosystème et le contexte de compte pris en charge à l’espace de croissance locale unifié.",
    "ar": "يربط Meta إشارات المنظومة وسياق الحساب المدعومين بمساحة النمو المحلي الموحدة."
  },
  "Tripadvisor connects supported guest-review, reputation and hospitality-discovery signals to the unified reputation view.": {
    "fr": "Tripadvisor relie les signaux pris en charge des avis voyageurs, de réputation et de découverte hôtelière à la vue unifiée de la réputation.",
    "ar": "يربط Tripadvisor إشارات تقييمات الضيوف والسمعة واكتشاف منشآت الضيافة المدعومة بعرض السمعة الموحد."
  },
  "V1 discovery channels bring supported local-presence and search signals around one physical business location.": {
    "fr": "Les canaux de découverte V1 regroupent les signaux de présence locale et de recherche pris en charge pour un établissement physique.",
    "ar": "تجمع قنوات الاكتشاف في الإصدار الأول إشارات الحضور المحلي والبحث المدعومة لموقع فعلي واحد."
  },
  "V1 hospitality integrations connect supported guest, reputation and discovery signals for eligible accounts.": {
    "fr": "Les intégrations hôtelières V1 relient les signaux de clientèle, de réputation et de découverte pris en charge pour les comptes éligibles.",
    "ar": "تربط تكاملات الضيافة في الإصدار الأول إشارات الضيوف والسمعة والاكتشاف المدعومة للحسابات المؤهلة."
  },
  "V1 reputation integrations bring supported review and reputation signals into one operating workflow.": {
    "fr": "Les intégrations de réputation V1 réunissent les signaux d’avis et de réputation pris en charge dans un même espace de travail.",
    "ar": "تجمع تكاملات السمعة في الإصدار الأول إشارات التقييمات والسمعة المدعومة في سير عمل واحد."
  },
  "V1 social integrations connect supported presence, engagement and customer signals into one business context.": {
    "fr": "Les intégrations sociales V1 relient les signaux de présence, d’engagement et de clientèle pris en charge dans un même contexte d’entreprise.",
    "ar": "تربط تكاملات التواصل الاجتماعي في الإصدار الأول إشارات الحضور والتفاعل والعملاء المدعومة في سياق نشاط موحد."
  },
  "WhatsApp delivers controlled critical and high-impact alerts with consent, policy, approved-template and provider safeguards.": {
    "fr": "WhatsApp transmet des alertes critiques ou à fort impact dans le respect du consentement, des règles, des modèles approuvés et des garde-fous du fournisseur.",
    "ar": "يرسل WhatsApp تنبيهات مهمة ومرتفعة التأثير وفق الموافقة والسياسات والقوالب المعتمدة وضوابط المزوّد."
  },
  "WhatsApp supports controlled V1 alerting with consent, policy and provider safeguards.": {
    "fr": "WhatsApp prend en charge les alertes V1 encadrées par le consentement, les règles et les garde-fous du fournisseur.",
    "ar": "يدعم WhatsApp تنبيهات الإصدار الأول وفق الموافقة والسياسات وضوابط المزوّد."
  },
  "Yelp connects supported consumer-review, reputation and local-discovery signals to the unified local-growth workspace.": {
    "fr": "Yelp relie les signaux pris en charge des avis consommateurs, de réputation et de découverte locale à l’espace de croissance locale unifié.",
    "ar": "يربط Yelp إشارات تقييمات المستهلكين والسمعة والاكتشاف المحلي المدعومة بمساحة النمو المحلي الموحدة."
  },
  "A Local Score with supporting history and context": {
    "fr": "Un Local Score étayé par l’historique et le contexte",
    "ar": "نتيجة Local Score مدعومة بالسجل والسياق"
  },
  "Alert Delivery": {
    "fr": "Transmission des alertes",
    "ar": "إرسال التنبيهات"
  },
  "Apple Maps Presence": {
    "fr": "Présence sur Apple Maps",
    "ar": "الحضور على خرائط Apple"
  },
  "Audience Engagement": {
    "fr": "Engagement de l’audience",
    "ar": "تفاعل الجمهور"
  },
  "Audience Signals": {
    "fr": "Signaux d’audience",
    "ar": "إشارات الجمهور"
  },
  "Booking Discovery": {
    "fr": "Découverte sur Booking",
    "ar": "الاكتشاف عبر Booking"
  },
  "Brand Mentions": {
    "fr": "Mentions de la marque",
    "ar": "الإشارات إلى العلامة التجارية"
  },
  "Brand Reach": {
    "fr": "Portée de la marque",
    "ar": "وصول العلامة التجارية"
  },
  "Checking separate review and performance sources manually": {
    "fr": "Vérification manuelle de sources distinctes d’avis et de performance",
    "ar": "مراجعة مصادر التقييمات والأداء المنفصلة يدويًا"
  },
  "Consumer Reviews": {
    "fr": "Avis consommateurs",
    "ar": "تقييمات المستهلكين"
  },
  "Critical Alerts": {
    "fr": "Alertes critiques",
    "ar": "تنبيهات مهمة"
  },
  "Customer Intent": {
    "fr": "Intention client",
    "ar": "نية العميل"
  },
  "Customer Interactions": {
    "fr": "Interactions clients",
    "ar": "تفاعلات العملاء"
  },
  "Engagement Trends": {
    "fr": "Tendances d’engagement",
    "ar": "اتجاهات التفاعل"
  },
  "Escalation Context": {
    "fr": "Contexte de remontée des alertes",
    "ar": "سياق تصعيد التنبيهات"
  },
  "Guest Reviews": {
    "fr": "Avis voyageurs",
    "ar": "تقييمات الضيوف"
  },
  "Guest Signals": {
    "fr": "Signaux clients",
    "ar": "إشارات الضيوف"
  },
  "History-aware": {
    "fr": "Tenant compte de l’historique",
    "ar": "يراعي السجل السابق"
  },
  "Hospitality Discovery": {
    "fr": "Découverte hôtelière",
    "ar": "اكتشاف منشآت الضيافة"
  },
  "Hospitality Presence": {
    "fr": "Présence hôtelière",
    "ar": "حضور منشآت الضيافة"
  },
  "Local Discovery": {
    "fr": "Découverte locale",
    "ar": "الاكتشاف المحلي"
  },
  "Local Reviews": {
    "fr": "Avis locaux",
    "ar": "التقييمات المحلية"
  },
  "Local Search": {
    "fr": "Recherche locale",
    "ar": "البحث المحلي"
  },
  "No history-aware view of local changes": {
    "fr": "Aucune vue des changements locaux tenant compte de l’historique",
    "ar": "غياب عرض للتغيّرات المحلية يراعي السجل السابق"
  },
  "Operational Notifications": {
    "fr": "Notifications opérationnelles",
    "ar": "إشعارات تشغيلية"
  },
  "Page Engagement": {
    "fr": "Engagement sur la Page",
    "ar": "التفاعل مع الصفحة"
  },
  "Performance Signals": {
    "fr": "Signaux de performance",
    "ar": "إشارات الأداء"
  },
  "Performance context": {
    "fr": "Contexte de performance",
    "ar": "سياق الأداء"
  },
  "Ranked priority actions as supported signals change": {
    "fr": "Actions prioritaires classées selon l’évolution des signaux pris en charge",
    "ar": "خطوات ذات أولوية مرتبة مع تغيّر الإشارات المدعومة"
  },
  "Reputation Signals": {
    "fr": "Signaux de réputation",
    "ar": "إشارات السمعة"
  },
  "Reputation Trends": {
    "fr": "Tendances de réputation",
    "ar": "اتجاهات السمعة"
  },
  "Reviews": {
    "fr": "Avis",
    "ar": "التقييمات"
  },
  "Search Signals": {
    "fr": "Signaux de recherche",
    "ar": "إشارات البحث"
  },
  "Search Visibility": {
    "fr": "Visibilité dans la recherche",
    "ar": "الظهور في البحث"
  },
  "Social Presence": {
    "fr": "Présence sociale",
    "ar": "الحضور على وسائل التواصل الاجتماعي"
  },
  "Supported review activity in one intelligent workflow": {
    "fr": "Activité des avis pris en charge dans un même espace intelligent",
    "ar": "نشاط التقييمات المدعومة في سير عمل ذكي موحد"
  },
  "EMAIL VERIFICATION": {
    "fr": "VÉRIFICATION DE L’E-MAIL",
    "ar": "التحقق من البريد الإلكتروني"
  },
  "Check your inbox.": {
    "fr": "Consultez votre boîte de réception.",
    "ar": "تحقّق من صندوق الوارد."
  },
  "We use email verification before any OPTRIXIS customer workspace can be created or accessed. The verification link will return you to sign in.": {
    "fr": "La vérification de l’e-mail est nécessaire avant de créer un espace client OPTRIXIS ou d’y accéder. Le lien vous ramènera à la connexion.",
    "ar": "يلزم التحقق من البريد الإلكتروني قبل إنشاء مساحة عمل OPTRIXIS أو الوصول إليها. سيعيدك رابط التحقق إلى تسجيل الدخول."
  },
  "Verification required": {
    "fr": "Vérification requise",
    "ar": "التحقق مطلوب"
  },
  "Open the latest OPTRIXIS LOCAL verification email and use its secure link. Older links may expire.": {
    "fr": "Ouvrez le dernier e-mail de vérification OPTRIXIS LOCAL et utilisez son lien sécurisé. Les anciens liens peuvent expirer.",
    "ar": "افتح أحدث رسالة تحقق من OPTRIXIS LOCAL واستخدم رابطها الآمن. قد تنتهي صلاحية الروابط القديمة."
  },
  "Need another verification email?": {
    "fr": "Besoin d’un nouvel e-mail de vérification ?",
    "ar": "هل تحتاج إلى رسالة تحقق أخرى؟"
  },
  "Requesting…": {
    "fr": "Envoi de la demande…",
    "ar": "جارٍ إرسال الطلب…"
  },
  "Resend verification email": {
    "fr": "Renvoyer l’e-mail de vérification",
    "ar": "إعادة إرسال رسالة التحقق"
  },
  "Already verified?": {
    "fr": "Votre e-mail est déjà vérifié ?",
    "ar": "هل تحقّقت من بريدك بالفعل؟"
  },
  "Return to sign in": {
    "fr": "Revenir à la connexion",
    "ar": "العودة إلى تسجيل الدخول"
  },
  "We could not request another verification email right now. Please try again shortly.": {
    "fr": "Nous ne pouvons pas demander un nouvel e-mail de vérification pour le moment. Réessayez dans un instant.",
    "ar": "تعذّر طلب رسالة تحقق أخرى حاليًا. حاول مجددًا بعد قليل."
  },
  "If this address belongs to an eligible account, a verification email is on its way.": {
    "fr": "Si cette adresse correspond à un compte éligible, un e-mail de vérification va vous être envoyé.",
    "ar": "إذا كان هذا العنوان مرتبطًا بحساب مؤهل، فستصلك رسالة تحقق."
  },
  "Verification email delivery is temporarily unavailable. Please try again.": {
    "fr": "L’envoi des e-mails de vérification est temporairement indisponible. Veuillez réessayer.",
    "ar": "إرسال رسائل التحقق غير متاح مؤقتًا. حاول مجددًا."
  },
  "REQUIRED ACCOUNT CONSENT": {
    "fr": "CONSENTEMENTS REQUIS POUR LE COMPTE",
    "ar": "الموافقات المطلوبة للحساب"
  },
  "Review the current policies.": {
    "fr": "Consultez les politiques en vigueur.",
    "ar": "راجع السياسات السارية."
  },
  "Your acceptance is recorded with the exact policy versions before OPTRIXIS creates or opens a customer workspace. Marketing consent is separate and is not bundled here.": {
    "fr": "Votre acceptation est enregistrée avec les versions exactes des politiques avant la création ou l’ouverture d’un espace client. Le consentement marketing est distinct et n’est pas inclus ici.",
    "ar": "تُسجّل موافقتك مع الإصدارات الدقيقة للسياسات قبل إنشاء مساحة عمل أو فتحها. الموافقة التسويقية منفصلة ولا تُضمّن هنا."
  },
  "Both the Terms and Privacy Policy must be accepted to continue.": {
    "fr": "Les conditions et la politique de confidentialité doivent être acceptées pour continuer.",
    "ar": "يجب قبول الشروط وسياسة الخصوصية للمتابعة."
  },
  "I accept the current": {
    "fr": "J’accepte les présentes",
    "ar": "أوافق على"
  },
  "I acknowledge the current": {
    "fr": "Je reconnais avoir pris connaissance de la présente",
    "ar": "أقرّ باطلاعي على"
  },
  "These required account policies are versioned and auditable. Optional marketing communication will require a separate choice.": {
    "fr": "Les versions de ces politiques obligatoires sont enregistrées et auditables. Les communications marketing facultatives nécessiteront un choix distinct.",
    "ar": "تُحفظ إصدارات سياسات الحساب الإلزامية وتكون قابلة للتدقيق. وتتطلب الرسائل التسويقية الاختيارية موافقة منفصلة."
  },
  "Accept and continue": {
    "fr": "Accepter et continuer",
    "ar": "الموافقة والمتابعة"
  },
  "Use another account": {
    "fr": "Utiliser un autre compte",
    "ar": "استخدام حساب آخر"
  },
  "days": {
    "fr": "jours",
    "ar": "أيام"
  }
};
